var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M512,256c0,141.383-114.615,256-256,256C114.619,512,0,397.383,0,256S114.619,0,256,0 C397.385,0,512,114.617,512,256z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "#5BC0DE"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.021,456.208 329.566,449.273 383.348,473.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.207,407.75 372.824,372.822 407.748,420.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.204,383.35 449.267,329.563 456.213,388.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.23,333.182 494.061,373.926 506.394,373.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.928,494.064 333.185,500.23 373.928,506.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.711,428.518 354.444,413.241 386.48,439.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.157,386.482 413.246,354.441 428.519,392.72  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M683.675,585.77c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C683.295,590.795,683.675,588.328,683.675,585.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.807,454.992 328.351,448.059 382.132,471.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.992,406.535 371.609,371.607 406.533,418.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.989,382.134 448.052,328.348 454.997,386.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.016,331.967 492.846,372.71 505.179,372.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.712,492.849 331.97,499.016 372.712,505.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.496,427.302 353.229,412.026 385.265,437.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.942,385.267 412.031,353.227 427.303,391.505  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M682.46,584.554c0-14.139-11.094-25.653-25.046-26.399c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.03-9.514l16.235,1.926l-53.784-23.928l-0.224,0.813c-2.962-0.79-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.643,0.026c2.12-8.524,3.262-17.433,3.262-26.609c0-60.761-49.256-110.007-110.009-110.007 c-58.6,0-106.48,45.814-109.808,103.583c-3.763,4.599-6.505,10.068-7.803,16.086c-2.429-0.694-4.984-1.091-7.629-1.091 c-15.254,0-27.623,12.367-27.623,27.618c0,2.237,0.339,4.386,0.842,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511H681.4 C682.08,589.58,682.46,587.112,682.46,584.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.592,453.777 327.137,446.844 380.918,470.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.777,405.32 370.395,370.393 405.318,417.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.774,380.92 446.837,327.134 453.782,385.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.801,330.752 491.631,371.496 503.964,371.496  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.498,491.635 330.755,497.801 371.498,503.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.281,426.088 352.015,410.812 384.051,436.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.728,384.053 410.816,352.012 426.089,390.29  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M681.245,583.339c0-14.138-11.094-25.653-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.596 c0-3.735-1.552-7.099-4.029-9.514l16.234,1.926l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.237,0.339,4.387,0.843,6.473l-18.645,8.292l55.478-6.581h14.525 c17.063,38.647,55.703,65.63,100.661,65.63c21.666,0,41.848-6.286,58.873-17.102h21.726l46.805,34.512l-25.423-34.512h80.404 C680.865,588.365,681.245,585.898,681.245,583.339z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.376,452.563 325.922,445.628 379.703,469.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.562,404.105 369.18,369.178 404.104,416.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.559,379.705 445.621,325.918 452.568,384.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "496.585,329.536 490.416,370.28 502.748,370.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.282,490.42 329.539,496.585 370.282,502.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.065,424.872 350.8,409.597 382.836,435.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.513,382.838 409.602,350.797 424.873,389.074  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M680.03,582.124c0-14.139-11.095-25.654-25.046-26.4c0.011-0.196,0.061-0.392,0.061-0.596 c0-3.735-1.553-7.1-4.03-9.513l16.234,1.925l-53.783-23.928l-0.225,0.813c-2.961-0.79-6.054-1.258-9.267-1.258 c-0.216,0-0.424,0.023-0.641,0.027c2.119-8.524,3.26-17.433,3.26-26.61c0-60.76-49.255-110.006-110.009-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.763,4.6-6.505,10.069-7.803,16.087c-2.429-0.694-4.984-1.091-7.629-1.091 c-15.254,0-27.623,12.367-27.623,27.617c0,2.239,0.339,4.387,0.842,6.473l-18.644,8.293l55.479-6.582h14.525 c17.063,38.648,55.701,65.63,100.659,65.63c21.666,0,41.849-6.286,58.874-17.101h21.726l46.804,34.511l-25.422-34.511h80.404 C679.65,587.149,680.03,584.684,680.03,582.124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.161,451.348 324.706,444.413 378.487,468.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.347,402.89 367.964,367.962 402.888,415.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.344,378.489 444.406,324.703 451.354,383.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "495.371,328.321 489.2,369.065 501.533,369.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.067,489.204 328.324,495.371 369.067,501.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.851,423.657 349.584,408.381 381.62,434.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.297,381.622 408.386,349.581 423.658,387.859  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M678.815,580.91c0-14.14-11.094-25.655-25.047-26.4c0.013-0.197,0.062-0.392,0.062-0.598 c0-3.735-1.553-7.099-4.03-9.512l16.234,1.924l-53.784-23.927l-0.223,0.813c-2.963-0.79-6.056-1.257-9.268-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.431,3.261-26.608c0-60.762-49.255-110.007-110.008-110.007 c-58.601,0-106.48,45.813-109.808,103.583c-3.764,4.599-6.506,10.067-7.804,16.085c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.239,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.661,65.63c21.665,0,41.847-6.286,58.872-17.1h21.726l46.806,34.51l-25.423-34.51h80.403 C678.435,585.935,678.815,583.468,678.815,580.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.946,450.133 323.491,443.198 377.272,467.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.132,401.675 366.75,366.747 401.673,414.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.129,377.274 443.191,323.488 450.138,381.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.156,327.106 487.986,367.851 500.319,367.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.853,487.99 327.109,494.156 367.853,500.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.636,422.442 348.369,407.166 380.405,433.089  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.082,380.407 407.171,348.366 422.443,386.645  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M677.601,579.695c0-14.14-11.095-25.655-25.046-26.401c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.551-7.099-4.029-9.512l16.234,1.925l-53.784-23.928l-0.224,0.813c-2.961-0.789-6.055-1.257-9.267-1.257 c-0.215,0-0.425,0.022-0.642,0.027c2.119-8.525,3.261-17.432,3.261-26.609c0-60.762-49.256-110.007-110.008-110.007 c-58.601,0-106.48,45.813-109.808,103.582c-3.764,4.6-6.506,10.069-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.618c0,2.238,0.339,4.386,0.843,6.472l-18.645,8.293l55.479-6.582h14.525 c17.063,38.647,55.702,65.631,100.661,65.631c21.666,0,41.848-6.286,58.872-17.102h21.727l46.804,34.511l-25.422-34.511h80.404 C677.221,584.721,677.601,582.254,677.601,579.695z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.731,448.918 322.276,441.983 376.058,465.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.917,400.46 365.534,365.532 400.458,412.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.914,376.06 441.977,322.273 448.923,380.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.94,325.892 486.771,366.636 499.104,366.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.638,486.774 325.895,492.94 366.638,499.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.421,421.228 347.154,405.951 379.19,431.874  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.867,379.192 405.956,347.151 421.229,385.43  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M676.385,578.479c0-14.14-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.598 c0-3.734-1.552-7.099-4.028-9.512l16.233,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.629,100.66,65.629c21.666,0,41.848-6.285,58.873-17.1h21.726l46.805,34.511l-25.423-34.511h80.404 C676.005,583.505,676.385,581.038,676.385,578.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.516,447.702 321.061,440.769 374.843,464.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.702,399.244 364.318,364.316 399.242,411.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.698,374.845 440.761,321.059 447.708,379.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.725,324.677 485.555,365.421 497.889,365.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.423,485.559 324.679,491.725 365.423,497.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.206,420.012 345.939,404.736 377.975,430.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.651,377.977 404.74,345.936 420.013,384.214  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M675.169,577.265c0-14.139-11.093-25.654-25.045-26.401c0.011-0.197,0.06-0.392,0.06-0.596 c0-3.735-1.551-7.1-4.028-9.513l16.233,1.924l-53.783-23.926l-0.224,0.812c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.217,0-0.425,0.023-0.643,0.027c2.12-8.524,3.261-17.432,3.261-26.61c0-60.76-49.255-110.006-110.009-110.006 c-58.599,0-106.479,45.814-109.806,103.583c-3.765,4.6-6.506,10.067-7.804,16.085c-2.429-0.693-4.984-1.089-7.629-1.089 c-15.254,0-27.623,12.367-27.623,27.616c0,2.239,0.339,4.387,0.843,6.474l-18.646,8.291l55.479-6.58h14.525 c17.063,38.647,55.701,65.629,100.659,65.629c21.667,0,41.849-6.285,58.874-17.101h21.726l46.805,34.512l-25.423-34.512h80.403 C674.79,582.29,675.169,579.823,675.169,577.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.301,446.487 319.846,439.553 373.627,463.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.486,398.029 363.104,363.102 398.027,410.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.483,373.629 439.546,319.843 446.492,378.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.51,323.461 484.34,364.205 496.673,364.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.207,484.344 323.464,490.51 364.207,496.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.99,418.797 344.724,403.521 376.76,429.443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.437,376.762 403.525,344.721 418.798,382.999  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M673.954,576.049c0-14.139-11.094-25.654-25.046-26.4c0.013-0.197,0.062-0.392,0.062-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.233,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.215,0-0.425,0.022-0.642,0.026c2.12-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.285,58.873-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C673.575,581.074,673.954,578.607,673.954,576.049z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.086,445.272 318.631,438.338 372.412,462.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.271,396.814 361.889,361.887 396.813,409.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.269,372.414 438.331,318.628 445.277,377.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "489.295,322.246 483.125,362.99 495.458,362.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.992,483.129 322.249,489.295 362.992,495.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.775,417.582 343.509,402.306 375.545,428.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.222,375.547 402.311,343.506 417.583,381.784  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M672.739,574.834c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.694-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C672.359,579.859,672.739,577.393,672.739,574.834z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.871,444.058 317.416,437.123 371.197,461.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.057,395.6 360.674,360.672 395.598,408.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.054,371.199 437.116,317.413 444.063,375.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.08,321.031 481.91,361.775 494.243,361.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.777,481.914 321.034,488.08 361.777,494.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.561,416.367 342.294,401.091 374.33,427.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.007,374.332 401.096,342.291 416.368,380.569  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M671.524,573.619c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C671.145,578.645,671.524,576.178,671.524,573.619z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.655,442.842 316.201,435.907 369.981,459.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.842,394.384 359.459,359.456 394.382,406.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.838,369.984 435.9,316.197 442.848,374.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.864,319.816 480.695,360.561 493.028,360.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.563,480.698 319.818,486.864 360.563,493.028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.346,415.152 341.079,399.876 373.115,425.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.791,373.117 399.88,341.076 415.153,379.354  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M670.31,572.403c0-14.138-11.094-25.653-25.046-26.399c0.012-0.198,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.924l-53.784-23.926l-0.224,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.021-0.642,0.026c2.119-8.525,3.261-17.432,3.261-26.61c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.814-109.806,103.582c-3.765,4.601-6.507,10.069-7.805,16.086c-2.428-0.693-4.984-1.089-7.628-1.089 c-15.255,0-27.623,12.366-27.623,27.616c0,2.238,0.339,4.388,0.842,6.474l-18.644,8.291l55.479-6.58h14.525 c17.063,38.647,55.701,65.629,100.659,65.629c21.667,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C669.93,577.43,670.31,574.962,670.31,572.403z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.44,441.627 314.985,434.692 368.767,458.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.626,393.169 358.243,358.241 393.167,405.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.623,368.769 434.686,314.982 441.632,373.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.649,318.602 479.479,359.345 491.813,359.345  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.347,479.483 318.604,485.649 359.347,491.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.13,413.937 339.863,398.66 371.899,424.583  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.576,371.901 398.665,339.86 413.938,378.139  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M669.095,571.188c0-14.139-11.095-25.654-25.047-26.4c0.013-0.197,0.062-0.392,0.062-0.597 c0-3.735-1.553-7.099-4.03-9.513l16.234,1.925l-53.784-23.927l-0.223,0.813c-2.963-0.789-6.056-1.257-9.267-1.257 c-0.217,0-0.425,0.022-0.643,0.026c2.119-8.524,3.262-17.432,3.262-26.609c0-60.761-49.257-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.667,0,41.848-6.286,58.874-17.101h21.725l46.806,34.511l-25.424-34.511h80.404 C668.714,576.214,669.095,573.747,669.095,571.188z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "535.393,313.769 511.455,367.554 528.45,372.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.226,440.412 313.771,433.478 367.553,457.408  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.411,391.954 357.028,357.026 391.953,404.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.408,367.554 433.471,313.769 440.417,372.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "484.436,317.386 478.265,358.131 490.598,358.131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.132,478.269 317.389,484.436 358.132,490.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.915,412.723 338.648,397.445 370.686,423.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.361,370.687 397.45,338.646 412.723,376.924  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M667.879,569.975c0-14.14-11.093-25.655-25.045-26.401c0.011-0.196,0.061-0.392,0.061-0.597 c0-3.735-1.553-7.098-4.029-9.513l16.234,1.926l-53.785-23.927l-0.223,0.812c-2.963-0.789-6.055-1.256-9.268-1.256 c-0.215,0-0.424,0.022-0.641,0.025c2.119-8.524,3.26-17.432,3.26-26.608c0-60.762-49.255-110.006-110.008-110.006 c-58.6,0-106.479,45.813-109.808,103.582c-3.764,4.599-6.506,10.067-7.804,16.085c-2.428-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.239,0.339,4.387,0.844,6.473l-18.646,8.293l55.479-6.582h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.848-6.285,58.873-17.1h21.726l46.804,34.51l-25.422-34.51h80.404 C667.5,574.999,667.879,572.533,667.879,569.975z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "534.177,312.553 510.239,366.339 527.234,371.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.011,439.197 312.556,432.263 366.337,456.192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.196,390.739 355.813,355.812 390.737,403.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.193,366.339 432.256,312.553 439.202,371.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.22,316.171 477.05,356.915 489.383,356.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.917,477.054 316.174,483.22 356.917,489.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.7,411.507 337.434,396.23 369.47,422.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.146,369.472 396.235,337.431 411.508,375.709  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M666.664,568.759c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925L600.1,510.247l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511L585.2,576.122h80.404 C666.284,573.784,666.664,571.317,666.664,568.759z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "532.962,311.338 509.024,365.123 526.02,369.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.795,437.982 311.34,431.047 365.122,454.978  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.98,389.523 354.599,354.596 389.522,401.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.979,365.123 431.041,311.338 437.987,369.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.005,314.956 475.835,355.7 488.168,355.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.701,475.838 314.958,482.005 355.701,488.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.485,410.291 336.219,395.016 368.255,420.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.932,368.257 395.02,336.216 410.292,374.493  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M665.449,567.544c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.928l-0.224,0.813c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.025c2.119-8.523,3.261-17.432,3.261-26.608c0-60.762-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.808,103.582c-3.763,4.6-6.505,10.068-7.804,16.085c-2.429-0.693-4.983-1.089-7.628-1.089 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.646,8.292l55.479-6.582h14.525 c17.063,38.648,55.702,65.631,100.661,65.631c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C665.069,572.569,665.449,570.103,665.449,567.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "531.747,310.122 507.81,363.908 524.804,368.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.58,436.767 310.125,429.832 363.906,453.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.766,388.309 353.383,353.381 388.307,400.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.763,363.908 429.825,310.122 436.771,368.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.789,313.74 474.619,354.484 486.952,354.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.486,474.623 313.743,480.789 354.486,486.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.27,409.076 335.003,393.8 367.039,419.723  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.716,367.041 393.805,335 409.077,373.278  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M664.234,566.328c0-14.139-11.094-25.654-25.047-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.235,1.925l-53.784-23.927l-0.225,0.813c-2.961-0.789-6.055-1.257-9.266-1.257 c-0.217,0-0.425,0.022-0.643,0.026c2.12-8.523,3.262-17.432,3.262-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.983-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.702,65.63,100.66,65.63c21.667,0,41.849-6.286,58.873-17.1h21.726l46.806,34.51l-25.423-34.51h80.404 C663.854,571.354,664.234,568.887,664.234,566.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "530.531,308.907 506.594,362.693 523.589,367.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.365,435.552 308.91,428.617 362.691,452.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.551,387.094 352.168,352.165 387.092,399.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.548,362.693 428.61,308.907 435.557,367.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.574,312.525 473.404,353.27 485.737,353.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.271,473.408 312.528,479.574 353.271,485.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.055,407.861 333.788,392.585 365.824,418.508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.501,365.826 392.59,333.785 407.862,372.063  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M663.019,565.113c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.693-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C662.639,570.139,663.019,567.672,663.019,565.113z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "529.317,307.692 505.379,361.479 522.374,366.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.15,434.337 307.695,427.402 361.477,451.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.336,385.879 350.953,350.951 385.877,398.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.333,361.479 427.396,307.692 434.342,366.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "478.359,311.311 472.189,352.055 484.522,352.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.057,472.193 311.313,478.359 352.057,484.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.84,406.646 332.573,391.37 364.609,417.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.286,364.611 391.375,332.57 406.646,370.849  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M661.804,563.898c0-14.139-11.094-25.654-25.046-26.4c0.013-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.233,1.925l-53.784-23.927l-0.224,0.813c-2.961-0.79-6.055-1.257-9.266-1.257 c-0.217,0-0.426,0.022-0.642,0.026c2.118-8.524,3.261-17.432,3.261-26.609c0-60.761-49.257-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.694-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.667,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.405 C661.424,568.924,661.804,566.457,661.804,563.898z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "528.102,306.477 504.164,360.264 521.159,364.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.936,433.122 306.48,426.188 360.262,450.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.121,384.664 349.738,349.735 384.662,397.122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.117,360.264 426.181,306.477 433.126,364.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.145,310.096 470.975,350.84 483.308,350.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.842,470.979 310.098,477.145 350.842,483.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.625,405.432 331.358,390.154 363.395,416.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.071,363.396 390.16,331.355 405.432,369.633  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M660.589,562.683c0-14.138-11.094-25.654-25.046-26.399c0.012-0.198,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.48,45.813-109.808,103.582c-3.764,4.6-6.505,10.068-7.804,16.085c-2.429-0.693-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.368-27.623,27.618c0,2.238,0.339,4.387,0.842,6.473l-18.644,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.666,0,41.848-6.285,58.873-17.1h21.726l46.805,34.511l-25.423-34.511h80.404 C660.209,567.709,660.589,565.242,660.589,562.683z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "526.887,305.262 502.949,359.048 519.943,363.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.721,431.907 305.265,424.972 359.046,448.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.905,383.448 348.522,348.521 383.446,395.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.902,359.048 424.965,305.262 431.911,363.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.93,308.881 469.759,349.624 482.093,349.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.627,469.763 308.883,475.93 349.627,482.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.409,404.216 330.143,388.939 362.18,414.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.855,362.181 388.944,330.14 404.217,368.418  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M659.374,561.469c0-14.14-11.095-25.655-25.046-26.401c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.735-1.553-7.098-4.029-9.512l16.234,1.924l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.608c0-60.762-49.257-110.006-110.009-110.006 c-58.6,0-106.48,45.813-109.808,103.581c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.368-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.661,65.63c21.666,0,41.848-6.286,58.873-17.1h21.725l46.806,34.51l-25.423-34.51h80.404 C658.994,566.493,659.374,564.026,659.374,561.469z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "525.672,304.048 501.734,357.833 518.729,362.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.506,430.692 304.05,423.758 357.832,447.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.691,382.233 347.308,347.306 382.232,394.692  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.688,357.833 423.75,304.048 430.697,362.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.714,307.666 468.545,348.41 480.878,348.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.411,468.549 307.668,474.714 348.411,480.878  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.194,403.002 328.928,387.725 360.964,413.647  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.641,360.967 387.729,328.926 403.002,367.203  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M658.159,560.254c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.099-4.029-9.512l16.234,1.925l-53.784-23.928l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.524,3.261-17.432,3.261-26.61c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.814-109.806,103.583c-3.765,4.6-6.506,10.068-7.805,16.085c-2.429-0.693-4.983-1.09-7.628-1.09 c-15.255,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.844,6.473l-18.646,8.293l55.479-6.581h14.525 c17.063,38.647,55.702,65.629,100.66,65.629c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51H657.1 C657.779,565.278,658.159,562.812,658.159,560.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "524.457,302.832 500.519,356.618 517.515,361.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.29,429.477 302.835,422.542 356.616,446.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.476,381.019 346.093,346.091 381.017,393.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.473,356.618 422.535,302.832 429.481,361.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.499,306.45 467.329,347.194 479.663,347.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.196,467.333 306.453,473.499 347.196,479.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.979,401.786 327.713,386.51 359.749,412.433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.426,359.751 386.515,327.71 401.787,365.988  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M656.944,559.038c0-14.139-11.095-25.655-25.046-26.4c0.011-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.233,1.925l-53.783-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.217,0-0.426,0.022-0.642,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.009-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.805,16.086c-2.428-0.693-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.667,0,41.849-6.286,58.873-17.101h21.726l46.806,34.511l-25.424-34.511h80.404 C656.564,564.063,656.944,561.597,656.944,559.038z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "523.241,301.617 499.304,355.402 516.299,360.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.075,428.262 301.62,421.326 355.401,445.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.261,379.804 344.878,344.875 379.802,392.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.257,355.402 421.32,301.617 428.266,360.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "472.284,305.235 466.114,345.979 478.447,345.979  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.98,466.118 305.238,472.284 345.98,478.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.765,400.57 326.498,385.294 358.534,411.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.211,358.536 385.3,326.495 400.571,364.773  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M655.729,557.823c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.007-110.009-110.007 c-58.6,0-106.479,45.814-109.807,103.583c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.237,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.404 C655.349,562.848,655.729,560.381,655.729,557.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "522.026,300.402 498.089,354.188 515.084,358.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.859,427.047 300.404,420.111 354.187,444.042  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.045,378.588 343.662,343.66 378.586,391.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.042,354.188 420.104,300.402 427.051,358.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.069,304.02 464.898,344.764 477.232,344.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.766,464.902 304.022,471.069 344.766,477.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.549,399.355 325.282,384.079 357.318,410.002  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.995,357.32 384.084,325.279 399.356,363.558  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M654.514,556.607c0-14.138-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.525,3.261-17.433,3.261-26.609c0-60.762-49.256-110.007-110.009-110.007 c-58.6,0-106.479,45.813-109.808,103.582c-3.764,4.601-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.239,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.661,65.63c21.666,0,41.848-6.286,58.873-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C654.134,561.633,654.514,559.167,654.514,556.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "520.811,299.187 496.874,352.973 513.869,357.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.645,425.831 299.189,418.896 352.971,442.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.83,377.373 342.447,342.444 377.371,389.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.826,352.973 418.89,299.187 425.836,357.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.854,302.805 463.684,343.549 476.017,343.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.551,463.688 302.808,469.854 343.551,476.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.334,398.141 324.067,382.864 356.104,408.786  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.78,356.105 382.869,324.064 398.141,362.343  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M653.298,555.393c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.424,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.693-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.849-6.286,58.873-17.1h21.727l46.804,34.51l-25.423-34.51h80.404 C652.918,560.418,653.298,557.951,653.298,555.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "519.597,297.972 495.659,351.758 512.654,356.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.43,424.616 297.975,417.682 351.756,441.611  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.615,376.158 341.232,341.23 376.156,388.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.612,351.758 417.675,297.972 424.621,356.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.639,301.59 462.469,342.334 474.802,342.334  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.336,462.473 301.593,468.639 342.336,474.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.119,396.926 322.853,381.649 354.889,407.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.565,354.891 381.654,322.85 396.926,361.128  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M652.084,554.178c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.551-7.099-4.029-9.513l16.235,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.804,16.086c-2.429-0.693-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.666,0,41.849-6.286,58.874-17.1h21.725l46.806,34.51l-25.423-34.51h80.404 C651.704,559.203,652.084,556.736,652.084,554.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "518.381,296.757 494.443,350.543 511.438,355.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.215,423.401 296.76,416.467 350.541,440.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.4,374.943 340.018,340.015 374.941,387.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.396,350.543 416.46,296.757 423.406,355.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.424,300.375 461.254,341.119 473.587,341.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.121,461.258 300.378,467.424 341.121,473.587  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.904,395.711 321.638,380.435 353.674,406.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.351,353.676 380.439,321.635 395.711,359.912  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M650.869,552.963c0-14.139-11.095-25.655-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.48,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.844,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.848-6.286,58.873-17.101h21.726l46.806,34.511l-25.424-34.511h80.404 C650.488,557.988,650.869,555.521,650.869,552.963z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "517.166,295.541 493.229,349.327 510.224,354.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354,422.187 295.544,415.251 349.325,439.182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.185,373.728 338.802,338.8 373.726,386.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.182,349.327 415.244,295.541 422.19,354.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.208,299.16 460.039,339.903 472.372,339.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.905,460.042 299.162,466.208 339.905,472.372  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.688,394.495 320.422,379.219 352.458,405.142  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.135,352.461 379.224,320.42 394.496,358.697  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M649.653,551.748c0-14.14-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.735-1.552-7.099-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.027c2.119-8.524,3.261-17.433,3.261-26.61c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.601-6.506,10.069-7.804,16.087c-2.428-0.694-4.983-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.237,0.339,4.386,0.843,6.472l-18.645,8.293l55.479-6.582h14.526 c17.062,38.647,55.701,65.63,100.659,65.63c21.667,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C649.273,556.772,649.653,554.307,649.653,551.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "515.951,294.327 492.014,348.112 509.009,352.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.785,420.972 294.33,414.037 348.111,437.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.97,372.513 337.587,337.585 372.512,384.972  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.967,348.112 414.029,294.327 420.976,352.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.994,297.945 458.824,338.689 471.157,338.689  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.691,458.828 297.948,464.994 338.691,471.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.474,393.281 319.207,378.005 351.244,403.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.92,351.245 378.009,319.205 393.281,357.482  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M648.438,550.533c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.924l-53.784-23.926l-0.224,0.812c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.525,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.429-0.694-4.984-1.09-7.628-1.09 c-15.255,0-27.624,12.367-27.624,27.617c0,2.237,0.34,4.387,0.844,6.472l-18.645,8.292l55.478-6.58h14.526 c17.063,38.647,55.701,65.629,100.66,65.629c21.666,0,41.848-6.285,58.873-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C648.059,555.558,648.438,553.092,648.438,550.533z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "514.736,293.111 490.799,346.897 507.794,351.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.569,419.756 293.114,412.821 346.896,436.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.755,371.298 336.372,336.37 371.296,383.757  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.752,346.897 412.814,293.111 419.761,351.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.778,296.73 457.608,337.474 469.942,337.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.476,457.612 296.732,463.778 337.476,469.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.259,392.065 317.992,376.789 350.028,402.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.705,350.03 376.794,317.989 392.066,356.268  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M647.224,549.317c0-14.139-11.095-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.79-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.804,16.086c-2.429-0.694-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.702,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.725l46.806,34.51l-25.423-34.51h80.404 C646.844,554.343,647.224,551.876,647.224,549.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "513.521,291.896 489.583,345.682 506.578,350.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.354,418.541 291.899,411.606 345.681,435.536  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.54,370.083 335.157,335.154 370.081,382.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.536,345.682 411.6,291.896 418.546,350.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.563,295.515 456.394,336.259 468.727,336.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.261,456.397 295.518,462.563 336.261,468.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.043,390.851 316.777,375.574 348.813,401.496  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.49,348.815 375.579,316.774 390.851,355.052  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M646.008,548.103c0-14.139-11.094-25.655-25.045-26.4c0.011-0.197,0.06-0.392,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.785-23.927l-0.223,0.812c-2.963-0.789-6.056-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.643,0.026c2.12-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.849-6.286,58.873-17.101h21.726l46.805,34.511l-25.423-34.511h80.405 C645.628,553.128,646.008,550.661,646.008,548.103z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "512.306,290.682 488.368,344.467 505.363,349.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.139,417.326 290.684,410.391 344.466,434.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.324,368.867 333.941,333.939 368.865,381.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.321,344.467 410.385,290.682 417.33,349.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.348,294.299 455.178,335.044 467.512,335.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.045,455.183 294.302,461.348 335.045,467.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.828,389.635 315.562,374.358 347.598,400.281  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.274,347.601 374.363,315.559 389.636,353.837  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M644.793,546.887c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.596 c0-3.735-1.552-7.1-4.029-9.514l16.234,1.926l-53.784-23.928l-0.224,0.813c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.025c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.583c-3.764,4.599-6.505,10.067-7.804,16.085c-2.429-0.693-4.983-1.09-7.629-1.09 c-15.253,0-27.622,12.367-27.622,27.618c0,2.237,0.338,4.386,0.842,6.472l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.702,65.63,100.66,65.63c21.667,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C644.413,551.912,644.793,549.445,644.793,546.887z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.091,289.466 487.153,343.252 504.148,347.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.924,416.11 289.469,409.176 343.25,433.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.109,367.652 332.727,332.724 367.65,380.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.105,343.252 409.169,289.466 416.115,347.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.133,293.084 453.963,333.828 466.297,333.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.83,453.967 293.087,460.133 333.83,466.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.613,388.42 314.347,373.144 346.383,399.066  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.06,346.385 373.148,314.344 388.42,352.621  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M643.578,545.672c0-14.139-11.094-25.655-25.047-26.4c0.013-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.217,0-0.426,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.403 C643.198,550.697,643.578,548.23,643.578,545.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "509.876,288.251 485.938,342.037 502.934,346.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.709,414.896 288.254,407.961 342.035,431.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.895,366.438 331.512,331.509 366.436,378.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.891,342.037 407.954,288.251 414.9,346.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.918,291.869 452.748,332.613 465.082,332.613  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.615,452.752 291.872,458.918 332.615,465.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.398,387.205 313.132,371.929 345.168,397.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.845,345.17 371.934,313.129 387.206,351.406  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M642.363,544.457c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.693-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.873-17.1h21.727l46.805,34.51l-25.423-34.51h80.404 C641.983,549.482,642.363,547.016,642.363,544.457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "508.66,287.036 484.724,340.822 501.719,345.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.494,413.681 287.039,406.746 340.82,430.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.68,365.223 330.297,330.294 365.221,377.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.676,340.822 406.739,287.036 413.686,345.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.703,290.654 451.533,331.398 463.866,331.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.4,451.537 290.657,457.703 331.4,463.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.184,385.99 311.917,370.714 343.953,396.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.63,343.955 370.719,311.914 385.99,350.191  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M641.147,543.242c0-14.139-11.093-25.655-25.046-26.4c0.013-0.197,0.061-0.392,0.061-0.598 c0-3.734-1.551-7.098-4.029-9.512l16.235,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.789-6.056-1.256-9.267-1.256 c-0.216,0-0.426,0.022-0.643,0.026c2.12-8.524,3.262-17.432,3.262-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.873-17.1h21.727l46.804,34.51l-25.422-34.51h80.403 C640.768,548.268,641.147,545.801,641.147,543.242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "507.445,285.82 483.508,339.606 500.503,344.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.279,412.466 285.823,405.53 339.604,429.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.464,364.007 329.081,329.079 364.005,376.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.461,339.606 405.523,285.82 412.47,344.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.488,289.439 450.317,330.183 462.651,330.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.185,450.322 289.441,456.488 330.185,462.651  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.969,384.775 310.701,369.498 342.738,395.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.414,342.739 369.503,310.699 384.775,348.977  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M639.933,542.027c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.099-4.029-9.512l16.234,1.924l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.525,3.261-17.432,3.261-26.609c0-60.762-49.256-110.006-110.009-110.006 c-58.6,0-106.48,45.813-109.807,103.581c-3.765,4.6-6.506,10.068-7.805,16.087c-2.428-0.695-4.984-1.09-7.629-1.09 c-15.253,0-27.622,12.366-27.622,27.617c0,2.238,0.338,4.387,0.842,6.472l-18.645,8.292l55.479-6.58h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.666,0,41.848-6.286,58.873-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C639.553,547.053,639.933,544.585,639.933,542.027z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "506.23,284.606 482.294,338.392 499.289,343.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.064,411.251 284.609,404.315 338.391,428.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.25,362.792 327.867,327.864 362.791,375.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.246,338.392 404.31,284.606 411.255,343.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.273,288.225 449.104,328.969 461.437,328.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.971,449.106 288.228,455.273 328.971,461.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.754,383.561 309.486,368.283 341.523,394.206  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.199,341.525 368.289,309.484 383.561,347.762  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M638.719,540.813c0-14.139-11.095-25.655-25.047-26.4c0.012-0.197,0.061-0.392,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.235,1.924l-53.784-23.926l-0.225,0.812c-2.962-0.789-6.055-1.257-9.266-1.257 c-0.217,0-0.426,0.023-0.643,0.027c2.12-8.524,3.261-17.432,3.261-26.609c0-60.762-49.256-110.007-110.009-110.007 c-58.6,0-106.479,45.813-109.807,103.583c-3.765,4.599-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.666,0,41.848-6.285,58.873-17.1h21.726l46.806,34.51l-25.424-34.51h80.404 C638.338,545.838,638.719,543.371,638.719,540.813z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.016,283.391 481.078,337.177 498.073,341.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.849,410.035 283.395,403.101 337.175,427.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.034,361.577 326.651,326.649 361.575,374.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.031,337.177 403.094,283.391 410.04,341.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.058,287.01 447.888,327.753 460.222,327.753  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.756,447.892 287.012,454.058 327.756,460.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.538,382.345 308.271,367.068 340.308,392.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.984,340.31 367.073,308.269 382.345,346.547  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M637.503,539.597c0-14.138-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.098-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.583c-3.765,4.599-6.505,10.067-7.805,16.085c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.618c0,2.237,0.339,4.386,0.843,6.472l-18.644,8.292l55.478-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C637.123,544.622,637.503,542.156,637.503,539.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "503.801,282.176 479.863,335.962 496.858,340.639  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.634,408.82 282.179,401.886 335.96,425.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.819,360.362 325.437,325.434 360.36,372.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.815,335.962 401.879,282.176 408.825,340.639  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.843,285.794 446.673,326.538 459.006,326.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.54,446.677 285.797,452.843 326.54,459.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.322,381.13 307.057,365.854 339.093,391.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.77,339.095 365.858,307.054 381.13,345.331  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M636.288,538.382c0-14.139-11.095-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.551-7.099-4.028-9.513l16.234,1.925l-53.785-23.927l-0.223,0.812c-2.963-0.789-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C635.908,543.406,636.288,540.94,636.288,538.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "502.585,280.961 478.647,334.746 495.643,339.424  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.418,407.605 280.964,400.67 334.745,424.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.604,359.146 324.222,324.218 359.145,371.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.601,334.746 400.664,280.961 407.609,339.424  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.628,284.578 445.458,325.323 457.791,325.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.325,445.461 284.582,451.628 325.325,457.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.107,379.914 305.842,364.638 337.878,390.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.555,337.879 364.643,305.839 379.915,344.116  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M635.072,537.167c0-14.139-11.094-25.655-25.046-26.401c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.098-4.029-9.513l16.234,1.926l-53.784-23.927l-0.224,0.812c-2.962-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.641,0.025c2.118-8.523,3.26-17.432,3.26-26.608c0-60.761-49.256-110.007-110.009-110.007 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.507,10.069-7.806,16.086c-2.428-0.693-4.982-1.09-7.628-1.09 c-15.254,0-27.622,12.368-27.622,27.617c0,2.238,0.338,4.388,0.842,6.473l-18.644,8.293L336.441,496h14.525 c17.063,38.648,55.702,65.63,100.661,65.63c21.667,0,41.848-6.286,58.873-17.099h21.726l46.805,34.509l-25.422-34.509h80.403 C634.692,542.191,635.072,539.726,635.072,537.167z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "501.37,279.746 477.433,333.531 494.428,338.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.203,406.39 279.748,399.455 333.529,423.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.389,357.932 323.006,323.003 357.93,370.391  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.385,333.531 399.448,279.746 406.395,338.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.412,283.363 444.242,324.107 456.576,324.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "537.405,304.623 511.486,336.664 522.126,342.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.662,511.483 304.626,537.398 342.893,522.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.109,444.246 283.366,450.412 324.109,456.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.893,378.699 304.626,363.423 336.662,389.345  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.339,336.664 363.428,304.623 378.699,342.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M633.857,535.951c0-14.139-11.094-25.654-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.764,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C633.478,540.977,633.857,538.51,633.857,535.951z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.155,278.53 476.218,332.316 493.213,336.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.988,405.175 278.533,398.24 332.314,422.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.174,356.717 321.791,321.788 356.715,369.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.17,332.316 398.233,278.53 405.18,336.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.197,282.148 443.027,322.893 455.361,322.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "536.19,303.408 510.271,335.449 520.911,341.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.447,510.269 303.411,536.184 341.678,520.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.895,443.031 282.152,449.197 322.895,455.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.678,377.484 303.411,362.208 335.447,388.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.124,335.449 362.213,303.408 377.485,341.686  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M632.643,534.736c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.813c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.702,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C632.263,539.762,632.643,537.295,632.643,534.736z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "498.94,277.315 475.003,331.102 491.998,335.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.773,403.96 277.318,397.025 331.1,420.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.959,355.502 320.576,320.573 355.5,367.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.955,331.102 397.019,277.315 403.965,335.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.982,280.934 441.813,321.678 454.146,321.678  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "534.976,302.193 509.057,334.234 519.696,340.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.232,509.054 302.196,534.969 340.463,519.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.68,441.816 280.937,447.982 321.68,454.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.463,376.27 302.196,360.993 334.232,386.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.909,334.234 360.998,302.193 376.27,340.471  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M631.428,533.521c0-14.139-11.095-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.788-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.873-17.1h21.727l46.805,34.51l-25.423-34.51h80.404 C631.047,538.547,631.428,536.08,631.428,533.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.725,276.101 473.787,329.886 490.782,334.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.559,402.745 276.104,395.811 329.884,419.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.744,354.286 319.361,319.358 354.284,366.745  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.74,329.886 395.804,276.101 402.75,334.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.768,279.719 440.598,320.463 452.931,320.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "533.761,300.979 507.841,333.02 518.481,339.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.018,507.838 300.98,533.753 339.248,518.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.464,440.602 279.721,446.768 320.464,452.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.248,375.055 300.98,359.777 333.018,385.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.693,333.02 359.783,300.979 375.054,339.256  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M630.213,532.307c0-14.139-11.095-25.656-25.047-26.4c0.012-0.198,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.924l-53.783-23.926l-0.225,0.812c-2.962-0.789-6.055-1.257-9.267-1.257 c-0.216,0-0.424,0.023-0.642,0.026c2.12-8.523,3.261-17.432,3.261-26.608c0-60.761-49.256-110.007-110.009-110.007 c-58.6,0-106.48,45.813-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.428-0.695-4.982-1.09-7.627-1.09 c-15.255,0-27.624,12.367-27.624,27.616c0,2.239,0.34,4.388,0.844,6.474l-18.645,8.291l55.478-6.58h14.525 c17.063,38.647,55.702,65.63,100.661,65.63c21.666,0,41.849-6.286,58.873-17.101h21.726l46.806,34.51l-25.424-34.51h80.405 C629.832,537.331,630.213,534.865,630.213,532.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "496.51,274.886 472.573,328.672 489.568,333.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.344,401.53 274.889,394.596 328.67,418.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.529,353.072 318.146,318.144 353.069,365.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.525,328.672 394.589,274.886 401.535,333.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.553,278.504 439.383,319.248 451.717,319.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "532.546,299.764 506.627,331.805 517.267,338.041  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.803,506.623 299.767,532.539 338.033,517.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.25,439.387 278.507,445.553 319.25,451.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.033,373.84 299.767,358.563 331.803,384.485  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.479,331.805 358.568,299.764 373.84,338.041  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M628.998,531.092c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.789-6.055-1.256-9.267-1.256 c-0.216,0-0.426,0.022-0.642,0.026c2.118-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.808,103.582c-3.764,4.6-6.505,10.068-7.804,16.086c-2.428-0.695-4.983-1.09-7.629-1.09 c-15.254,0-27.622,12.367-27.622,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.666,0,41.849-6.286,58.873-17.101h21.727l46.805,34.511l-25.423-34.511h80.404 C628.617,536.116,628.998,533.65,628.998,531.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "495.295,273.67 471.357,327.456 488.353,332.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.128,400.314 273.674,393.38 327.455,417.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.313,351.856 316.931,316.928 351.854,364.314  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.31,327.456 393.373,273.67 400.319,332.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.337,277.289 438.167,318.033 450.501,318.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "531.33,298.549 505.411,330.589 516.051,336.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.587,505.408 298.551,531.323 336.817,516.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.035,438.171 277.291,444.337 318.035,450.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.817,372.624 298.551,357.348 330.587,383.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.264,330.589 357.353,298.549 372.624,336.826  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M627.782,529.876c0-14.139-11.094-25.655-25.046-26.4c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.926l-0.224,0.811c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.804,16.087c-2.429-0.695-4.984-1.091-7.629-1.091 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.58h14.525 c17.063,38.647,55.702,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C627.402,534.901,627.782,532.435,627.782,529.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.08,272.455 470.143,326.241 487.138,330.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.913,399.1 272.458,392.165 326.239,416.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.099,350.642 315.716,315.713 350.64,363.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.095,326.241 392.158,272.455 399.104,330.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.122,276.073 436.952,316.817 449.285,316.817  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "530.115,297.333 504.195,329.374 514.836,335.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.372,504.193 297.336,530.108 335.603,514.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.819,436.956 276.076,443.122 316.819,449.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.603,371.409 297.336,356.133 329.372,382.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.049,329.374 356.138,297.333 371.409,335.61  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M626.567,528.661c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.009-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.725l46.806,34.51l-25.423-34.51h80.404 C626.188,533.687,626.567,531.22,626.567,528.661z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.865,271.24 468.928,325.025 485.922,329.703  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.697,397.885 271.243,390.949 325.024,414.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.884,349.426 314.501,314.497 349.424,361.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.879,325.025 390.943,271.24 397.889,329.703  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.907,274.858 435.737,315.603 448.07,315.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "528.9,296.118 502.98,328.159 513.621,334.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.157,502.978 296.121,528.894 334.387,513.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.604,435.74 274.861,441.907 315.604,448.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.387,370.193 296.121,354.918 328.157,380.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.834,328.159 354.922,296.118 370.194,334.396  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M625.353,527.446c0-14.139-11.095-25.655-25.046-26.401c0.011-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.098-4.029-9.512l16.233,1.925l-53.783-23.928l-0.224,0.813c-2.963-0.789-6.056-1.256-9.268-1.256 c-0.215,0-0.424,0.022-0.641,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.255-110.007-110.009-110.007 c-58.6,0-106.479,45.813-109.808,103.582c-3.764,4.601-6.505,10.068-7.804,16.087c-2.429-0.695-4.983-1.09-7.628-1.09 c-15.254,0-27.624,12.367-27.624,27.616c0,2.239,0.34,4.388,0.843,6.473l-18.644,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.666,0,41.849-6.285,58.873-17.099h21.726l46.805,34.509l-25.422-34.509h80.404 C624.973,532.471,625.353,530.004,625.353,527.446z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.649,270.025 467.712,323.811 484.707,328.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.482,396.669 270.027,389.734 323.809,413.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.668,348.211 313.285,313.282 348.209,360.669  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.664,323.811 389.728,270.025 396.674,328.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.691,273.643 434.521,314.387 446.855,314.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "527.685,294.902 501.766,326.943 512.405,333.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.941,501.763 294.905,527.678 333.172,512.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.389,434.525 273.646,440.691 314.389,446.855  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.172,368.979 294.905,353.702 326.941,379.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.618,326.943 353.707,294.902 368.979,333.18  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M624.137,526.23c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.405 C623.757,531.256,624.137,528.789,624.137,526.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.436,268.81 466.498,322.596 483.492,327.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.268,395.454 268.813,388.52 322.594,412.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.453,346.996 312.07,312.067 346.994,359.454  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.45,322.596 388.514,268.81 395.459,327.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.477,272.428 433.307,313.172 445.641,313.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "526.471,293.688 500.551,325.729 511.191,331.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.727,500.548 293.691,526.463 331.957,511.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.174,433.311 272.432,439.477 313.174,445.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.957,367.764 293.691,352.487 325.727,378.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.403,325.729 352.492,293.688 367.764,331.965  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M622.922,525.016c0-14.139-11.094-25.654-25.045-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.785-23.927l-0.224,0.812c-2.962-0.788-6.054-1.256-9.267-1.256 c-0.216,0-0.424,0.022-0.642,0.026c2.12-8.523,3.261-17.432,3.261-26.609c0-60.76-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.583c-3.764,4.599-6.505,10.067-7.805,16.086c-2.428-0.695-4.983-1.091-7.628-1.091 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.667,0,41.85-6.286,58.874-17.099h21.726l46.805,34.509l-25.422-34.509h80.404 C622.542,530.041,622.922,527.574,622.922,525.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "489.22,267.595 465.282,321.381 482.277,326.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.053,394.239 267.598,387.305 321.379,411.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.238,345.781 310.855,310.853 345.779,358.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.234,321.381 387.298,267.595 394.244,326.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.262,271.213 432.092,311.957 444.426,311.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "525.255,292.473 499.336,324.514 509.976,330.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.512,499.333 292.476,525.248 330.742,509.979  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.959,432.096 271.216,438.262 311.959,444.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.742,366.549 292.476,351.272 324.512,377.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.188,324.514 351.277,292.473 366.549,330.75  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M621.707,523.801c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C621.327,528.826,621.707,526.359,621.707,523.801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.005,266.38 464.067,320.165 481.063,324.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.838,393.024 266.383,386.089 320.163,410.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.022,344.565 309.641,309.637 344.563,357.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.02,320.165 386.083,266.38 393.028,324.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.046,269.998 430.876,310.742 443.21,310.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "524.039,291.258 498.121,323.298 508.761,329.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.296,498.117 291.26,524.033 329.526,508.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.744,430.88 270,437.046 310.744,443.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.526,365.334 291.26,350.057 323.296,375.979  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.973,323.298 350.063,291.258 365.333,329.535  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M620.492,522.586c0-14.14-11.095-25.655-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512L607.712,488l-53.784-23.926l-0.224,0.811c-2.962-0.787-6.056-1.256-9.267-1.256 c-0.217,0-0.426,0.023-0.643,0.027c2.119-8.525,3.262-17.432,3.262-26.61c0-60.761-49.256-110.005-110.011-110.005 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.505,10.067-7.804,16.086c-2.428-0.695-4.983-1.09-7.628-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.844,6.473L266.383,488l55.479-6.58h14.525 c17.063,38.647,55.7,65.629,100.659,65.629c21.667,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.405 C620.111,527.611,620.492,525.145,620.492,522.586z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.789,265.164 462.852,318.95 479.848,323.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.623,391.809 265.168,384.874 318.949,408.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.808,343.351 308.426,308.422 343.349,355.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.805,318.95 384.868,265.164 391.813,323.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.832,268.783 429.662,309.527 441.995,309.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "522.825,290.043 496.905,322.084 507.546,328.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.082,496.902 290.045,522.818 328.313,507.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.529,429.666 268.785,435.832 309.529,441.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.313,364.118 290.045,348.842 322.082,374.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.758,322.084 348.848,290.043 364.119,328.32  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M619.277,521.371c0-14.139-11.094-25.656-25.047-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.513l16.234,1.925l-53.783-23.926l-0.224,0.811c-2.963-0.787-6.056-1.255-9.267-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.12-8.524,3.261-17.433,3.261-26.609c0-60.762-49.255-110.007-110.009-110.007 c-58.6,0-106.48,45.813-109.807,103.583c-3.766,4.6-6.506,10.068-7.805,16.085c-2.429-0.694-4.983-1.089-7.628-1.089 c-15.255,0-27.623,12.366-27.623,27.617c0,2.237,0.339,4.387,0.842,6.473l-18.644,8.291l55.478-6.58h14.525 c17.063,38.647,55.701,65.629,100.661,65.629c21.666,0,41.849-6.285,58.873-17.1h21.726l46.806,34.51l-25.423-34.51h80.403 C618.896,526.396,619.277,523.93,619.277,521.371z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.575,263.95 461.638,317.736 478.633,322.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.408,390.594 263.952,383.66 317.734,407.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.593,342.136 307.211,307.207 342.134,354.594  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.59,317.736 383.653,263.95 390.6,322.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.617,267.568 428.447,308.313 440.781,308.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "521.609,288.828 495.69,320.869 506.331,327.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.867,495.688 288.83,521.604 327.097,506.334  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.314,428.45 267.571,434.617 308.314,440.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.097,362.904 288.83,347.627 320.867,373.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.543,320.869 347.633,288.828 362.903,327.105  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M618.063,520.156c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.233,1.925l-53.783-23.927l-0.224,0.811c-2.963-0.787-6.056-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.643,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.255-110.006-110.009-110.006 c-58.6,0-106.479,45.813-109.808,103.582c-3.765,4.6-6.505,10.068-7.804,16.086c-2.429-0.695-4.984-1.09-7.629-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.34,4.387,0.844,6.473l-18.646,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.666,0,41.849-6.285,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C617.683,525.182,618.063,522.715,618.063,520.156z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "484.359,262.734 460.422,316.521 477.417,321.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.192,389.379 262.737,382.444 316.519,406.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.378,340.921 305.995,305.992 340.919,353.379  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.374,316.521 382.438,262.734 389.384,321.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.401,266.353 427.231,307.097 439.565,307.097  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "520.395,287.612 494.476,319.653 505.115,325.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.651,494.473 287.615,520.388 325.882,505.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.099,427.235 266.355,433.401 307.099,439.565  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.882,361.688 287.615,346.412 319.651,372.334  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.328,319.653 346.417,287.612 361.688,325.89  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M616.847,518.94c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.51l-25.423-34.51h80.404 C616.467,523.966,616.847,521.499,616.847,518.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.145,261.52 459.207,315.305 476.201,319.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.977,388.164 261.522,381.229 315.303,405.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.162,339.705 304.779,304.777 339.703,352.163  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.158,315.305 381.223,261.52 388.168,319.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.186,265.138 426.017,305.882 438.35,305.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "519.18,286.396 493.26,318.438 503.9,324.674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.436,493.257 286.4,519.172 324.666,503.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.884,426.021 265.141,432.186 305.884,438.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.666,360.474 286.4,345.197 318.436,371.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.113,318.438 345.201,286.396 360.473,324.674  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M615.632,517.725c0-14.139-11.094-25.654-25.046-26.399c0.012-0.198,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.099-4.029-9.512l16.234,1.925l-53.785-23.927l-0.223,0.811c-2.963-0.788-6.055-1.255-9.268-1.255 c-0.216,0-0.424,0.022-0.641,0.025c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.814-109.807,103.583c-3.764,4.599-6.506,10.068-7.805,16.085c-2.428-0.694-4.982-1.09-7.627-1.09 c-15.254,0-27.624,12.368-27.624,27.617c0,2.238,0.34,4.387,0.843,6.473l-18.644,8.293L317,476.56h14.525 c17.063,38.647,55.702,65.629,100.66,65.629c21.668,0,41.85-6.286,58.874-17.099h21.726l46.806,34.509l-25.423-34.509h80.404 C615.251,522.75,615.632,520.283,615.632,517.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "481.93,260.305 457.992,314.09 474.986,318.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "523.456,350.948 558.375,303.562 510.996,338.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.488,510.989 303.564,558.385 350.948,523.452  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.762,386.949 260.307,380.014 314.089,403.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.948,338.49 303.564,303.562 338.488,350.948  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.943,314.09 380.008,260.305 386.953,318.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.971,263.923 424.801,304.667 437.136,304.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "517.965,285.183 492.045,317.224 502.686,323.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.221,492.042 285.186,517.958 323.451,502.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.668,424.805 263.926,430.971 304.668,437.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.451,359.258 285.186,343.982 317.221,369.904  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.898,317.224 343.986,285.183 359.258,323.459  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M614.416,516.51c0-14.138-11.094-25.654-25.045-26.399c0.012-0.198,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.099-4.029-9.513l16.234,1.926l-53.784-23.928l-0.224,0.812c-2.963-0.788-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.021-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.61c0-60.761-49.256-110.005-110.01-110.005 c-58.598,0-106.479,45.813-109.807,103.582c-3.764,4.599-6.506,10.067-7.805,16.086c-2.427-0.695-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.368-27.623,27.617c0,2.238,0.339,4.387,0.842,6.473l-18.645,8.293l55.479-6.582h14.526 c17.062,38.648,55.7,65.63,100.659,65.63c21.668,0,41.85-6.285,58.875-17.099h21.725l46.805,34.51l-25.422-34.51h80.404 C614.037,521.535,614.416,519.068,614.416,516.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.715,259.09 456.777,312.875 473.772,317.553  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "522.24,349.734 557.161,302.347 509.781,337.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.273,509.773 302.35,557.169 349.733,522.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.547,385.734 259.093,378.799 312.873,402.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.733,337.275 302.35,302.347 337.273,349.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.729,312.875 378.793,259.09 385.738,317.553  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.757,262.707 423.587,303.451 435.921,303.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "516.75,283.968 490.83,316.009 501.471,322.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.007,490.828 283.971,516.743 322.236,501.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.454,423.591 262.711,429.757 303.454,435.921  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.236,358.043 283.971,342.768 316.007,368.689  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.684,316.009 342.771,283.968 358.043,322.245  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M613.202,515.295c0-14.138-11.095-25.654-25.046-26.399c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.514l16.234,1.926l-53.784-23.927l-0.224,0.811c-2.962-0.788-6.055-1.255-9.268-1.255 c-0.215,0-0.424,0.022-0.641,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.007-110.01-110.007 c-58.599,0-106.479,45.813-109.808,103.583c-3.764,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.366-27.623,27.616c0,2.238,0.338,4.388,0.843,6.473l-18.645,8.293l55.478-6.581h14.525 c17.063,38.647,55.701,65.629,100.661,65.629c21.667,0,41.849-6.285,58.874-17.099h21.725l46.806,34.509l-25.423-34.509h80.404 C612.821,520.32,613.202,517.854,613.202,515.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.5,257.874 455.563,311.66 472.557,316.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "521.025,348.519 555.945,301.132 508.566,336.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.059,508.559 301.135,555.954 348.518,521.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.332,384.519 257.877,377.584 311.658,401.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.518,336.061 301.135,301.132 336.059,348.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.514,311.66 377.577,257.874 384.523,316.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.541,261.492 422.371,302.236 434.705,302.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "515.534,282.752 489.615,314.793 500.255,321.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.791,489.612 282.755,515.527 321.021,500.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.238,422.375 261.495,428.541 302.238,434.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.021,356.828 282.755,341.552 314.791,367.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.468,314.793 341.557,282.752 356.828,321.029  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M611.986,514.08c0-14.139-11.094-25.655-25.045-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.233,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.641,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.982-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.1h21.726l46.805,34.51l-25.422-34.51h80.403 C611.606,519.105,611.986,516.639,611.986,514.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "478.284,256.659 454.347,310.444 471.342,315.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "519.811,347.304 554.73,299.916 507.352,334.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.843,507.344 299.92,554.738 347.303,519.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.117,383.304 256.662,376.368 310.442,400.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.303,334.845 299.92,299.916 334.843,347.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.299,310.444 376.361,256.659 383.309,315.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.326,260.277 421.156,301.021 433.489,301.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "514.319,281.537 488.4,313.578 499.04,319.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.576,488.396 281.539,514.313 319.806,499.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.023,421.16 260.279,427.326 301.023,433.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.806,355.613 281.539,340.336 313.576,366.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.253,313.578 340.342,281.537 355.613,319.814  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M610.771,512.865c0-14.139-11.094-25.656-25.046-26.4c0.011-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.007-110.01-110.007 c-58.599,0-106.48,45.813-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.34,4.387,0.844,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C610.391,517.89,610.771,515.424,610.771,512.865z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.069,255.444 453.132,309.23 470.127,313.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "518.596,346.089 553.516,298.701 506.137,333.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.629,506.129 298.705,553.523 346.088,518.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.902,382.088 255.447,375.153 309.229,399.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.088,333.631 298.705,298.701 333.629,346.089  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.084,309.23 375.146,255.444 382.093,313.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.111,259.063 419.941,299.807 432.275,299.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "513.104,280.322 487.185,312.363 497.825,318.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.361,487.182 280.324,513.098 318.592,497.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.809,419.945 259.065,426.111 299.809,432.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.592,354.398 280.324,339.121 312.361,365.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.038,312.363 339.127,280.322 354.397,318.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M609.557,511.65c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.924l-53.784-23.926l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.6,0-106.48,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.983-1.09-7.627-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.844,6.472l-18.645,8.292l55.479-6.58h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C609.177,516.675,609.557,514.209,609.557,511.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.854,254.229 451.917,308.016 468.912,312.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "517.381,344.873 552.301,297.486 504.922,332.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.414,504.914 297.49,552.309 344.873,517.377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.688,380.873 254.232,373.938 308.014,397.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.873,332.416 297.49,297.486 332.414,344.873  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.869,308.016 373.932,254.229 380.878,312.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.896,257.848 418.727,298.592 431.061,298.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.89,279.107 485.971,311.148 496.61,317.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.146,485.967 279.11,511.883 317.377,496.613  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.594,418.73 257.851,424.896 298.594,431.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.377,353.184 279.11,337.906 311.146,363.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.823,311.148 337.912,279.107 353.183,317.385  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M608.342,510.436c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.762-49.256-110.007-110.01-110.007 c-58.6,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.873-17.099h21.727l46.805,34.509L526.878,517.8h80.404 C607.961,515.46,608.342,512.994,608.342,510.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.64,253.014 450.701,306.8 467.697,311.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "516.165,343.658 551.086,296.271 503.706,331.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.198,503.698 296.274,551.094 343.657,516.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.472,379.658 253.017,372.724 306.798,396.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.657,331.2 296.274,296.271 331.198,343.658  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.653,306.8 372.717,253.014 379.663,311.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.681,256.632 417.511,297.376 429.845,297.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "510.674,277.893 484.755,309.933 495.395,316.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.931,484.752 277.895,510.667 316.161,495.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.378,417.515 256.635,423.681 297.378,429.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.161,351.968 277.895,336.691 309.931,362.613  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.607,309.933 336.696,277.893 351.968,316.169  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M607.127,509.22c0-14.139-11.095-25.655-25.047-26.4c0.013-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.225,0.812c-2.962-0.788-6.055-1.256-9.266-1.256 c-0.217,0-0.426,0.022-0.643,0.027c2.12-8.525,3.261-17.433,3.261-26.61c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.806,16.086c-2.427-0.694-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.667,0,41.849-6.285,58.874-17.099h21.726l46.806,34.509l-25.424-34.509h80.404 C606.746,514.245,607.127,511.778,607.127,509.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.424,251.799 449.486,305.584 466.481,310.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "514.95,342.443 549.87,295.057 502.49,329.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.982,502.483 295.059,549.878 342.441,514.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.256,378.443 251.802,371.508 305.582,395.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.441,329.984 295.059,295.057 329.982,342.443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.438,305.584 371.501,251.799 378.447,310.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.466,255.417 416.295,296.161 428.629,296.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "509.459,276.677 483.539,308.718 494.18,314.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.716,483.537 276.68,509.451 314.945,494.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.163,416.299 255.419,422.466 296.163,428.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.945,350.753 276.68,335.477 308.716,361.397  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.393,308.718 335.48,276.677 350.752,314.954  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M605.911,508.004c0-14.138-11.094-25.655-25.046-26.399c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.553-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.067-7.806,16.085c-2.428-0.694-4.982-1.089-7.627-1.089 c-15.254,0-27.623,12.366-27.623,27.617c0,2.237,0.339,4.386,0.843,6.472l-18.645,8.293l55.478-6.582h14.525 c17.063,38.648,55.701,65.63,100.661,65.63c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C605.531,513.029,605.911,510.563,605.911,508.004z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "472.209,250.584 448.271,304.369 465.267,309.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "513.735,341.229 548.655,293.841 501.276,328.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.768,501.269 293.844,548.664 341.227,513.731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.041,377.229 250.586,370.293 304.368,394.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.227,328.77 293.844,293.841 328.768,341.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.223,304.369 370.286,250.584 377.232,309.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.251,254.202 415.081,294.946 427.415,294.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "508.244,275.462 482.324,307.503 492.965,313.739  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.501,482.321 275.465,508.237 313.73,492.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.947,415.084 254.205,421.251 294.947,427.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.73,349.537 275.465,334.262 307.501,360.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.178,307.503 334.266,275.462 349.537,313.739  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M604.696,506.789c0-14.139-11.095-25.654-25.046-26.399c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.513l16.234,1.926l-53.784-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.021-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.255-110.007-110.009-110.007 c-58.599,0-106.479,45.814-109.808,103.583c-3.765,4.6-6.505,10.068-7.805,16.086c-2.428-0.695-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.368-27.623,27.618c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.479-6.581h14.525 c17.062,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.725l46.806,34.51l-25.423-34.51h80.404 C604.316,511.814,604.696,509.349,604.696,506.789z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.994,249.369 447.057,303.154 464.052,307.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "512.521,340.014 547.44,292.626 500.062,327.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.553,500.054 292.629,547.448 340.012,512.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.826,376.014 249.372,369.078 303.152,393.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.012,327.555 292.629,292.626 327.553,340.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.008,303.154 369.071,249.369 376.018,307.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.036,252.987 413.866,293.73 426.2,293.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "507.029,274.247 481.11,306.288 491.75,312.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.286,481.107 274.25,507.021 312.516,491.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.733,413.869 252.99,420.036 293.733,426.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.516,348.323 274.25,333.047 306.286,358.968  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.963,306.288 333.051,274.247 348.322,312.524  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M603.481,505.575c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.512l16.234,1.925l-53.784-23.928l-0.224,0.813c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.022-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.608c0-60.761-49.255-110.006-110.009-110.006 c-58.599,0-106.479,45.813-109.807,103.581c-3.765,4.601-6.506,10.069-7.806,16.087c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.478-6.581h14.526 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C603.102,510.6,603.481,508.134,603.481,505.575z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.779,248.153 445.842,301.939 462.836,306.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.305,338.798 546.225,291.411 498.846,326.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.338,498.838 291.414,546.233 338.797,511.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.611,374.799 248.156,367.863 301.938,391.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.797,326.34 291.414,291.411 326.338,338.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.793,301.939 367.856,248.153 374.803,306.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.82,251.772 412.65,292.516 424.984,292.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.814,273.031 479.895,305.072 490.535,311.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.07,479.892 273.034,505.807 311.301,490.538  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.518,412.654 251.775,418.82 292.518,424.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.301,347.107 273.034,331.831 305.07,357.753  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.747,305.072 331.836,273.031 347.107,311.309  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M602.266,504.359c0-14.139-11.094-25.655-25.045-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.926l-53.785-23.928l-0.223,0.812c-2.963-0.788-6.055-1.256-9.268-1.256 c-0.216,0-0.424,0.022-0.641,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.694-4.983-1.09-7.627-1.09 c-15.255,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.725l46.805,34.509l-25.422-34.509h80.404 C601.887,509.385,602.266,506.918,602.266,504.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.563,246.938 444.626,300.724 461.621,305.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "510.09,337.582 545.01,290.195 497.631,325.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.123,497.623 290.199,545.018 337.582,510.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.396,373.583 246.941,366.648 300.723,390.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.582,325.125 290.199,290.195 325.123,337.582  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.577,300.724 366.641,246.938 373.588,305.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.605,250.557 411.436,291.301 423.77,291.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "504.599,271.816 478.679,303.857 489.319,310.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.855,478.676 271.818,504.592 310.085,489.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.303,411.439 250.56,417.605 291.303,423.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.085,345.893 271.818,330.616 303.855,356.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.532,303.857 330.621,271.816 345.893,310.094  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M601.051,503.145c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.762-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.805,16.086c-2.428-0.695-4.983-1.09-7.629-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.34,4.387,0.844,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C600.671,508.17,601.051,505.703,601.051,503.145z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.349,245.724 443.411,299.51 460.406,304.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "508.875,336.367 543.795,288.98 496.416,323.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.908,496.408 288.984,543.803 336.367,508.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.182,372.368 245.727,365.434 299.508,389.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.367,323.91 288.984,288.98 323.908,336.367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.362,299.51 365.426,245.724 372.373,304.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.391,249.342 410.221,290.086 422.555,290.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "503.384,270.602 477.465,302.643 488.104,308.879  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.641,477.461 270.604,503.377 308.87,488.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.088,410.225 249.345,416.391 290.088,422.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.87,344.678 270.604,329.401 302.641,355.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.317,302.643 329.406,270.602 344.677,308.879  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M599.836,501.93c0-14.139-11.094-25.656-25.046-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.235,1.925l-53.785-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.805,16.086c-2.428-0.695-4.983-1.09-7.628-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.844,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.668,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C599.456,506.955,599.836,504.488,599.836,501.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.134,244.509 442.196,298.294 459.191,302.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "507.66,335.152 542.58,287.766 495.201,322.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.693,495.193 287.77,542.588 335.152,507.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.967,371.153 244.512,364.219 298.293,388.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.152,322.695 287.77,287.766 322.693,335.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.147,298.294 364.211,244.509 371.158,302.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.176,248.127 409.006,288.871 421.34,288.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "502.169,269.387 476.249,301.428 486.89,307.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.426,476.246 269.39,502.162 307.656,486.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.873,409.01 248.13,415.176 288.873,421.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.656,343.463 269.39,328.187 301.426,354.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.103,301.428 328.191,269.387 343.463,307.664  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M598.621,500.715c0-14.139-11.094-25.656-25.045-26.4c0.011-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.424,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.701,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.098h21.726l46.805,34.508l-25.423-34.508h80.404 C598.241,505.74,598.621,503.273,598.621,500.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.919,243.293 440.981,297.079 457.977,301.757  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "506.445,333.938 541.365,286.551 493.986,321.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.478,493.979 286.554,541.373 333.937,506.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.751,369.938 243.296,363.003 297.078,386.934  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.937,321.479 286.554,286.551 321.478,333.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.933,297.079 362.996,243.293 369.942,301.757  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.96,246.912 407.791,287.655 420.125,287.655  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.954,268.172 475.034,300.213 485.675,306.448  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.21,475.031 268.174,500.946 306.44,485.678  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.657,407.794 246.915,413.96 287.657,420.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.44,342.247 268.174,326.971 300.21,352.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.887,300.213 326.976,268.172 342.247,306.448  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M597.406,499.499c0-14.138-11.095-25.655-25.047-26.4c0.013-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.098-4.029-9.513l16.235,1.925l-53.784-23.927l-0.224,0.812c-2.963-0.787-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.643,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.601-6.506,10.069-7.805,16.086c-2.428-0.694-4.983-1.089-7.628-1.089 c-15.254,0-27.623,12.366-27.623,27.617c0,2.238,0.34,4.386,0.843,6.472l-18.645,8.292l55.479-6.58h14.526 c17.062,38.646,55.7,65.629,100.659,65.629c21.667,0,41.85-6.286,58.874-17.099h21.726l46.806,34.509l-25.424-34.509h80.405 C597.026,504.524,597.406,502.058,597.406,499.499z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.703,242.078 439.766,295.864 456.761,300.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.229,332.722 540.149,285.336 492.771,320.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.262,492.763 285.338,540.157 332.722,505.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.535,368.723 242.081,361.787 295.861,385.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.722,320.264 285.338,285.336 320.262,332.722  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.717,295.864 361.781,242.078 368.728,300.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.745,245.696 406.575,286.44 418.909,286.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.738,266.956 473.818,298.996 484.459,305.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.995,473.815 266.959,499.731 305.225,484.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.442,406.578 245.699,412.745 286.442,418.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.225,341.032 266.959,325.756 298.995,351.678  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.672,298.996 325.761,266.956 341.031,305.233  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M596.19,498.284c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.552-7.1-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.811c-2.962-0.787-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.007-110.01-110.007 c-58.599,0-106.479,45.814-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.338,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.805,34.509l-25.423-34.509h80.404 C595.811,503.309,596.19,500.843,596.19,498.284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.488,240.863 438.551,294.648 455.546,299.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "504.016,331.507 538.935,284.121 491.556,319.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.047,491.548 284.123,538.943 331.507,504.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.32,367.508 240.866,360.572 294.647,384.503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.507,319.049 284.123,284.121 319.047,331.507  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.502,294.648 360.566,240.863 367.513,299.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.53,244.481 405.36,285.226 417.694,285.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "498.523,265.741 472.604,297.782 483.244,304.019  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.78,472.602 265.744,498.517 304.01,483.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.228,405.364 244.484,411.53 285.228,417.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.01,339.816 265.744,324.541 297.78,350.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.457,297.782 324.546,265.741 339.816,304.019  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M594.976,497.069c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.428-0.695-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.368-27.623,27.618c0,2.238,0.339,4.387,0.842,6.473l-18.644,8.292l55.478-6.581h14.526 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.51l-25.423-34.51h80.404 C594.596,502.094,594.976,499.628,594.976,497.069z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.273,239.648 437.336,293.434 454.332,298.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "502.801,330.292 537.721,282.905 490.341,317.834  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.832,490.333 282.909,537.728 330.292,502.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.105,366.293 239.651,359.357 293.432,383.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.292,317.834 282.909,282.905 317.832,330.292  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.287,293.434 359.352,239.648 366.297,298.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.315,243.267 404.146,284.011 416.479,284.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.309,264.526 471.389,296.567 482.029,302.803  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.565,471.387 264.529,497.302 302.796,482.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.013,404.148 243.27,410.315 284.013,416.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.796,338.603 264.529,323.326 296.565,349.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.242,296.567 323.331,264.526 338.602,302.803  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M593.762,495.854c0-14.139-11.095-25.655-25.047-26.4c0.012-0.197,0.061-0.392,0.061-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.007-110.01-110.007 c-58.599,0-106.479,45.814-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.428-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.806,34.509l-25.424-34.509h80.404 C593.381,500.88,593.762,498.413,593.762,495.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.059,238.434 436.121,292.219 453.116,296.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "501.585,329.077 536.505,281.689 489.125,316.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.617,489.117 281.693,536.513 329.076,501.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.891,365.078 238.436,358.143 292.217,382.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.076,316.619 281.693,281.689 316.617,329.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.072,292.219 358.136,238.434 365.082,296.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.1,242.052 402.93,282.795 415.264,282.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "496.094,263.312 470.174,295.352 480.814,301.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.35,470.171 263.313,496.086 301.58,480.817  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.797,402.934 242.055,409.1 282.797,415.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.58,337.387 263.313,322.11 295.35,348.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.026,295.352 322.115,263.312 337.387,301.588  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M592.546,494.639c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.926l-53.784-23.928l-0.224,0.812c-2.963-0.788-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.021-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.765,4.6-6.506,10.068-7.805,16.086c-2.428-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.624,12.368-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.725l46.806,34.509l-25.423-34.509h80.404 C592.165,499.664,592.546,497.197,592.546,494.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.843,237.218 434.906,291.004 451.9,295.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.369,327.861 535.289,280.475 487.91,315.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.402,487.902 280.479,535.297 327.861,500.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.676,363.862 237.221,356.928 291.002,380.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.861,315.404 280.479,280.475 315.402,327.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.857,291.004 356.92,237.218 363.866,295.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.885,240.836 401.715,281.58 414.049,281.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.879,262.096 468.959,294.137 479.6,300.373  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.135,468.955 262.099,494.871 300.365,479.602  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.582,401.719 240.839,407.885 281.582,414.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.365,336.172 262.099,320.896 294.135,346.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.812,294.137 320.9,262.096 336.171,300.373  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M591.33,493.424c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.233,1.925l-53.784-23.927l-0.223,0.811c-2.963-0.787-6.055-1.255-9.268-1.255 c-0.216,0-0.424,0.022-0.641,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.473l-18.644,8.292l55.479-6.581h14.525 c17.063,38.647,55.701,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C590.95,498.449,591.33,495.982,591.33,493.424z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.629,236.003 433.691,289.789 450.686,294.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.154,326.646 534.075,279.26 486.695,314.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.188,486.688 279.264,534.082 326.646,499.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.461,362.647 236.006,355.713 289.787,379.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.646,314.189 279.264,279.26 314.188,326.646  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.642,289.789 355.705,236.003 362.652,294.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.67,239.621 400.5,280.365 412.834,280.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "493.663,260.881 467.743,292.922 478.385,299.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.92,467.741 260.884,493.656 299.149,478.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.367,400.504 239.624,406.67 280.367,412.834  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.149,334.957 260.884,319.68 292.92,345.602  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.597,292.922 319.686,260.881 334.956,299.157  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M590.115,492.209c0-14.139-11.094-25.655-25.046-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.785-23.927l-0.224,0.812c-2.962-0.788-6.055-1.256-9.267-1.256 c-0.216,0-0.424,0.022-0.641,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.85-6.285,58.874-17.099h21.726l46.806,34.509l-25.423-34.509h80.404 C589.735,497.234,590.115,494.768,590.115,492.209z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.413,234.788 432.477,288.573 449.471,293.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.94,325.432 532.859,278.045 485.48,312.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.973,485.473 278.049,532.867 325.432,497.936  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.246,361.433 234.791,354.498 288.572,378.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.432,312.975 278.049,278.045 312.973,325.432  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.427,288.573 354.49,234.788 361.438,293.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.455,238.406 399.285,279.15 411.619,279.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.449,259.666 466.529,291.707 477.17,297.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.705,466.525 259.669,492.441 297.936,477.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.152,399.289 238.409,405.455 279.152,411.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.936,333.742 259.669,318.465 291.705,344.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.382,291.707 318.471,259.666 333.741,297.943  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M588.9,490.994c0-14.139-11.094-25.656-25.045-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.225,0.811c-2.962-0.787-6.054-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.641,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.762-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C588.521,496.02,588.9,493.553,588.9,490.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.198,233.573 431.261,287.358 448.256,292.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "496.725,324.217 531.645,276.83 484.266,311.759  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.757,484.258 276.833,531.652 324.216,496.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.031,360.217 233.576,353.282 287.357,377.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.216,311.759 276.833,276.83 311.757,324.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.212,287.358 353.275,233.573 360.222,292.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.24,237.191 398.069,277.936 410.404,277.936  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.233,258.451 465.313,290.491 475.954,296.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "517.98,343.172 550.023,317.25 511.751,332.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.313,517.986 491.233,550.025 475.954,511.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.255,550.025 343.166,517.986 332.526,511.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.49,465.311 258.453,491.227 296.72,475.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.938,398.073 237.194,404.24 277.938,410.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.72,332.526 258.453,317.25 290.49,343.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.166,290.491 317.255,258.451 332.526,296.728  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M587.686,489.779c0-14.14-11.094-25.656-25.046-26.401c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.811c-2.962-0.787-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.027c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.007-110.01-110.007 c-58.599,0-106.48,45.813-109.808,103.583c-3.765,4.599-6.505,10.067-7.806,16.085c-2.427-0.694-4.982-1.089-7.627-1.089 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.292l55.478-6.58h14.525 c17.063,38.647,55.701,65.629,100.661,65.629c21.667,0,41.849-6.285,58.874-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C587.305,494.804,587.686,492.338,587.686,489.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.982,232.357 430.045,286.144 447.041,290.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "495.51,323.002 530.43,275.614 483.05,310.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.541,483.042 275.618,530.438 323,495.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.815,359.002 232.36,352.067 286.142,375.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323,310.543 275.618,275.614 310.541,323.002  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.996,286.144 352.061,232.357 359.006,290.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.024,235.976 396.854,276.72 409.188,276.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.018,257.235 464.099,289.276 474.739,295.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "516.765,341.956 548.809,316.035 510.535,331.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.099,516.771 490.018,548.81 474.739,510.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.04,548.81 341.951,516.771 331.311,510.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.274,464.096 257.238,490.011 295.504,474.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.722,396.858 235.979,403.024 276.722,409.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.504,331.311 257.238,316.035 289.274,341.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.951,289.276 316.04,257.235 331.311,295.512  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M586.471,488.563c0-14.139-11.095-25.656-25.046-26.4c0.011-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.225,0.812c-2.962-0.788-6.054-1.256-9.266-1.256 c-0.217,0-0.426,0.022-0.643,0.026c2.12-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.808,103.582c-3.765,4.6-6.505,10.068-7.805,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.667,0,41.85-6.286,58.874-17.099h21.726l46.806,34.509l-25.424-34.509h80.405 C586.09,493.588,586.471,491.122,586.471,488.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.769,231.143 428.831,284.928 445.826,289.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.295,321.787 529.215,274.399 481.835,309.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.326,481.827 274.403,529.223 321.785,494.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.601,357.787 231.146,350.853 284.927,374.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.785,309.328 274.403,274.399 309.326,321.787  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.781,284.928 350.846,231.143 357.791,289.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.81,234.761 395.64,275.505 407.974,275.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.804,256.021 462.883,288.062 473.524,294.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "515.55,340.741 547.594,314.82 509.32,330.097  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.883,515.556 488.804,547.595 473.524,509.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.825,547.595 340.736,515.556 330.096,509.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.06,462.88 256.023,488.796 294.289,473.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.507,395.644 234.764,401.81 275.507,407.974  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.289,330.097 256.023,314.82 288.06,340.741  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.736,288.062 314.825,256.021 330.096,294.297  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M585.256,487.349c0-14.139-11.095-25.655-25.047-26.4c0.013-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.233,1.925l-53.783-23.927l-0.224,0.812c-2.963-0.788-6.055-1.256-9.268-1.256 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726l46.806,34.51l-25.423-34.51h80.403 C584.875,492.373,585.256,489.907,585.256,487.349z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.553,229.928 427.615,283.713 444.611,288.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "493.08,320.572 528,273.186 480.621,308.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.111,480.612 273.188,528.008 320.571,493.075  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.386,356.572 229.931,349.638 283.712,373.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.571,308.113 273.188,273.186 308.111,320.572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.566,283.713 349.631,229.928 356.577,288.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.595,233.546 394.425,274.29 406.759,274.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "487.588,254.806 461.669,286.847 472.31,293.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "514.335,339.526 546.379,313.605 508.105,328.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.669,514.341 487.588,546.38 472.31,508.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.61,546.38 339.521,514.341 328.881,508.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.845,461.666 254.809,487.581 293.075,472.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.292,394.429 233.549,400.595 274.292,406.759  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.075,328.882 254.809,313.605 286.845,339.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.521,286.847 313.61,254.806 328.881,293.082  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M584.041,486.134c0-14.139-11.095-25.656-25.047-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.224,0.812c-2.963-0.788-6.056-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.643,0.026c2.119-8.524,3.262-17.433,3.262-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.808,103.582c-3.765,4.6-6.505,10.068-7.805,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.478-6.581h14.526 c17.063,38.647,55.7,65.63,100.66,65.63c21.667,0,41.849-6.286,58.874-17.1h21.726L528,528.008l-25.424-34.51h80.405 C583.66,491.158,584.041,488.692,584.041,486.134z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.338,228.713 426.4,282.498 443.396,287.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.865,319.356 526.784,271.969 479.405,306.898  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.584,355.357 516.261,372.352 570.045,348.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.4,516.258 450.338,570.043 443.396,511.587  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.415,570.043 372.352,516.258 355.361,511.587  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.896,479.397 271.973,526.792 319.355,491.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.17,355.357 228.715,348.422 282.496,372.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.355,306.898 271.973,271.969 306.896,319.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.352,282.498 348.415,228.713 355.361,287.176  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.38,232.331 393.21,273.074 405.544,273.074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.373,253.591 460.453,285.631 471.094,291.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "513.12,338.312 545.164,312.391 506.891,327.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.453,513.126 486.373,545.164 471.094,506.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.395,545.164 338.307,513.126 327.666,506.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.629,460.45 253.593,486.365 291.859,471.097  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.077,393.213 232.334,399.38 273.077,405.544  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.859,327.666 253.593,312.391 285.629,338.312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.307,285.631 312.395,253.591 327.666,291.867  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M582.825,484.918c0-14.139-11.094-25.655-25.046-26.4c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.098-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.025c2.119-8.523,3.261-17.432,3.261-26.608c0-60.762-49.256-110.007-110.01-110.007 c-58.599,0-106.479,45.813-109.808,103.582c-3.765,4.6-6.506,10.069-7.805,16.087c-2.428-0.696-4.982-1.091-7.627-1.091 c-15.254,0-27.624,12.367-27.624,27.618c0,2.237,0.339,4.386,0.842,6.472l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.661,65.63c21.667,0,41.849-6.285,58.874-17.099h21.725l46.806,34.509l-25.423-34.509h80.404 C582.445,489.943,582.825,487.478,582.825,484.918z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.123,227.498 425.186,281.283 442.18,285.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.649,318.141 525.569,270.754 478.189,305.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "510.369,354.142 515.045,371.137 568.83,347.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.186,515.043 449.123,568.827 442.18,510.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.2,568.827 371.137,515.043 354.146,510.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.682,478.182 270.758,525.576 318.141,490.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.955,354.142 227.5,347.207 281.281,371.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.141,305.684 270.758,270.754 305.682,318.141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.137,281.283 347.2,227.498 354.146,285.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.164,231.115 391.994,271.859 404.328,271.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.158,252.375 459.238,284.416 469.879,290.651  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.904,337.096 543.948,311.175 505.675,326.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.238,511.91 485.158,543.949 469.879,505.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.18,543.949 337.091,511.91 326.45,505.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.414,459.235 252.378,485.15 290.645,469.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.861,391.998 231.118,398.164 271.861,404.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.645,326.451 252.378,311.175 284.414,337.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.091,284.416 311.18,252.375 326.45,290.651  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M581.609,483.703c0-14.139-11.094-25.656-25.045-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925l-53.785-23.927l-0.223,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.805,16.086c-2.428-0.695-4.983-1.09-7.628-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C581.23,488.729,581.609,486.262,581.609,483.703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.908,226.282 423.971,280.068 440.966,284.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "489.434,316.926 524.354,269.539 476.975,304.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "509.154,352.927 513.83,369.922 567.615,345.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.971,513.828 447.908,567.612 440.966,509.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.985,567.612 369.922,513.828 352.932,509.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.467,476.967 269.543,524.362 316.926,489.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.74,352.927 226.285,345.992 280.066,369.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.926,304.469 269.543,269.539 304.467,316.926  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.922,280.068 345.985,226.282 352.932,284.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.949,229.901 390.779,270.645 403.113,270.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.943,251.16 458.023,283.201 468.664,289.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "510.689,335.881 542.733,309.96 504.46,325.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.023,510.695 483.943,542.734 468.664,504.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.965,542.734 335.876,510.695 325.235,504.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.199,458.02 251.163,483.936 289.43,468.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.646,390.783 229.903,396.949 270.646,403.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.43,325.236 251.163,309.96 283.199,335.881  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.876,283.201 309.965,251.16 325.235,289.438  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M580.396,482.488c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925l-53.785-23.927l-0.223,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.805,34.509l-25.422-34.509h80.404 C580.015,487.514,580.396,485.047,580.396,482.488z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.693,225.067 422.756,278.854 439.751,283.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.22,315.711 523.14,268.324 475.76,303.254  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "507.939,351.712 512.616,368.707 566.4,344.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.756,512.613 446.693,566.397 439.751,507.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.771,566.397 368.707,512.613 351.717,507.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.252,475.752 268.328,523.146 315.711,488.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.525,351.712 225.07,344.777 278.852,368.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.711,303.254 268.328,268.324 303.252,315.711  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.707,278.854 344.771,225.067 351.717,283.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.734,228.686 389.564,269.43 401.898,269.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.729,249.945 456.809,281.986 467.449,288.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "509.475,334.666 541.519,308.745 503.246,324.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.809,509.48 482.729,541.52 467.449,503.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.75,541.52 334.661,509.48 324.021,503.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.984,456.806 249.948,482.721 288.215,467.452  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.432,389.568 228.688,395.734 269.432,401.898  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.215,324.021 249.948,308.745 281.984,334.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.661,281.986 308.75,249.945 324.021,288.223  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M579.181,481.273c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C578.801,486.299,579.181,483.832,579.181,481.273z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.478,223.852 421.54,277.638 438.535,282.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "487.004,314.496 521.924,267.109 474.545,302.038  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "506.725,350.496 511.4,367.492 565.185,343.562  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.54,511.397 445.478,565.182 438.535,506.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.555,565.182 367.491,511.397 350.501,506.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.036,474.536 267.112,521.932 314.496,487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.311,350.496 223.855,343.562 277.637,367.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.496,302.038 267.112,267.109 302.036,314.496  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.491,277.638 343.555,223.852 350.501,282.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.52,227.471 388.35,268.215 400.684,268.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "481.514,248.73 455.593,280.771 466.233,287.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "508.26,333.451 540.304,307.529 502.03,322.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.593,508.266 481.514,540.305 466.233,502.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.534,540.305 333.445,508.266 322.805,502.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.77,455.59 248.733,481.506 286.999,466.236  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.217,388.353 227.474,394.52 268.217,400.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.999,322.806 248.733,307.529 280.77,333.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.445,280.771 307.534,248.73 322.805,287.007  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M577.965,480.059c0-14.139-11.094-25.656-25.046-26.401c0.013-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925L511.4,421.547l-0.224,0.811c-2.962-0.787-6.055-1.256-9.267-1.256 c-0.216,0-0.425,0.023-0.642,0.027c2.12-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.808,103.582c-3.765,4.6-6.505,10.068-7.805,16.086c-2.427-0.696-4.983-1.09-7.628-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.7,65.629,100.66,65.629c21.667,0,41.849-6.285,58.874-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C577.585,485.083,577.965,482.617,577.965,480.059z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.262,222.637 420.325,276.423 437.32,281.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.789,313.28 520.709,265.894 473.33,300.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.509,349.281 510.186,366.276 563.97,342.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.325,510.183 444.262,563.967 437.32,505.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.34,563.967 366.275,510.183 349.286,505.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.82,473.321 265.897,520.717 313.28,485.784  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.095,349.281 222.64,342.346 276.421,366.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.28,300.823 265.897,265.894 300.82,313.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.275,276.423 342.34,222.637 349.286,281.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.304,226.255 387.134,266.999 399.468,266.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.298,247.515 454.377,279.556 465.019,285.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "507.045,332.235 539.088,306.314 500.814,321.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.377,507.051 480.298,539.089 465.019,500.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.319,539.089 332.23,507.051 321.59,500.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.554,454.375 247.518,480.29 285.784,465.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.001,387.138 226.258,393.304 267.001,399.468  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.784,321.591 247.518,306.314 279.554,332.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.23,279.556 306.319,247.515 321.59,285.791  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M576.75,478.843c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.099h21.727l46.805,34.509l-25.423-34.509h80.404 C576.369,483.867,576.75,481.401,576.75,478.843z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.048,221.422 419.11,275.207 436.105,279.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "484.574,312.065 519.494,264.679 472.115,299.608  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "504.295,348.066 508.971,365.062 562.755,341.132  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.11,508.968 443.048,562.752 436.105,504.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.125,562.752 365.061,508.968 348.07,504.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.605,472.106 264.683,519.502 312.065,484.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.88,348.066 221.425,341.132 275.206,365.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.065,299.608 264.683,264.679 299.605,312.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.061,275.207 341.125,221.422 348.07,279.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.089,225.041 385.919,265.784 398.253,265.784  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.083,246.3 453.163,278.341 463.804,284.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.83,331.021 537.873,305.1 499.6,320.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.163,505.835 479.083,537.874 463.804,499.601  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.104,537.874 331.016,505.835 320.375,499.601  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.339,453.16 246.303,479.075 284.568,463.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.786,385.923 225.043,392.089 265.786,398.253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.568,320.376 246.303,305.1 278.339,331.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.016,278.341 305.104,246.3 320.375,284.576  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M575.535,477.628c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.725l46.806,34.509l-25.423-34.509h80.404 C575.154,482.652,575.535,480.187,575.535,477.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.833,220.207 417.896,273.993 434.891,278.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.359,310.851 518.279,263.464 470.899,298.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "503.079,346.852 507.756,363.847 561.54,339.917  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.896,507.752 441.833,561.537 434.891,503.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.91,561.537 363.846,507.752 346.855,503.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.391,470.892 263.468,518.287 310.851,483.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.665,346.852 220.21,339.917 273.991,363.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.851,298.394 263.468,263.464 298.391,310.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.846,273.993 339.91,220.207 346.855,278.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.874,223.826 384.704,264.569 397.039,264.569  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.868,245.085 451.948,277.126 462.589,283.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "504.614,329.806 536.658,303.885 498.385,319.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.948,504.621 477.868,536.659 462.589,498.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.89,536.659 329.801,504.621 319.16,498.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.124,451.945 245.088,477.86 283.354,462.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.571,384.708 223.828,390.874 264.571,397.039  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.354,319.161 245.088,303.885 277.124,329.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.801,277.126 303.89,245.085 319.16,283.361  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M574.32,476.413c0-14.139-11.095-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.735-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.099h21.727l46.805,34.509l-25.423-34.509h80.404 C573.939,481.438,574.32,478.972,574.32,476.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.617,218.992 416.68,272.777 433.676,277.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.145,309.635 517.064,262.248 469.685,297.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "501.864,345.637 506.54,362.632 560.325,338.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.68,506.537 440.617,560.322 433.676,501.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.694,560.322 362.631,506.537 345.641,501.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.176,469.676 262.252,517.071 309.635,482.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.449,345.637 218.995,338.701 272.775,362.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.635,297.178 262.252,262.248 297.176,309.635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.631,272.777 338.694,218.992 345.641,277.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.658,222.61 383.488,263.354 395.823,263.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "476.652,243.87 450.732,275.911 461.373,282.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "503.399,328.59 535.443,302.67 497.17,317.945  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.732,503.405 476.652,535.443 461.373,497.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.674,535.443 328.586,503.405 317.945,497.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.909,450.729 243.873,476.646 282.139,461.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.355,383.492 222.613,389.658 263.355,395.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.139,317.945 243.873,302.67 275.909,328.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.586,275.911 302.674,243.87 317.945,282.146  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M573.105,475.198c0-14.139-11.095-25.656-25.047-26.401c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.235,1.926l-53.785-23.927l-0.224,0.811c-2.962-0.787-6.054-1.255-9.266-1.255 c-0.217,0-0.425,0.022-0.642,0.025c2.118-8.523,3.26-17.432,3.26-26.609c0-60.76-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.067-7.805,16.086c-2.428-0.696-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.367-27.623,27.618c0,2.237,0.338,4.386,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.062,38.647,55.7,65.629,100.659,65.629c21.668,0,41.85-6.286,58.875-17.099h21.726l46.806,34.509l-25.424-34.509h80.404 C572.725,480.223,573.105,477.756,573.105,475.198z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.402,217.777 415.465,271.563 432.46,276.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.929,308.42 515.849,261.033 468.469,295.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.648,344.421 505.325,361.416 559.109,337.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.465,505.322 439.402,559.106 432.46,500.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.479,559.106 361.415,505.322 344.426,500.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.961,468.461 261.037,515.855 308.42,480.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.234,344.421 217.779,337.486 271.561,361.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.42,295.963 261.037,261.033 295.961,308.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.415,271.563 337.479,217.777 344.426,276.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.443,221.395 382.273,262.139 394.607,262.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.438,242.654 449.518,274.695 460.158,280.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "502.184,327.375 534.228,301.454 495.955,316.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.518,502.19 475.438,534.229 460.158,495.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.459,534.229 327.37,502.19 316.729,495.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.693,449.515 242.657,475.43 280.924,460.161  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.141,382.277 221.397,388.443 262.141,394.607  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.924,316.73 242.657,301.454 274.693,327.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.37,274.695 301.459,242.654 316.729,280.932  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M571.89,473.982c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.787-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.524,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.508l-25.423-34.508h80.404 C571.509,479.008,571.89,476.541,571.89,473.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.188,216.562 414.25,270.348 431.245,275.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.714,307.205 514.634,259.818 467.254,294.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.434,343.206 504.11,360.201 557.895,336.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.25,504.107 438.188,557.892 431.245,499.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.265,557.892 360.201,504.107 343.211,499.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.746,467.246 259.822,514.642 307.205,479.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.02,343.206 216.564,336.271 270.346,360.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.205,294.748 259.822,259.818 294.746,307.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.201,270.348 336.265,216.562 343.211,275.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.229,220.18 381.059,260.924 393.393,260.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.223,241.44 448.303,273.48 458.943,279.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.969,326.16 533.014,300.239 494.74,315.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.303,500.975 474.223,533.014 458.943,494.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.244,533.014 326.155,500.975 315.515,494.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.479,448.3 241.442,474.215 279.709,458.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.926,381.063 220.183,387.229 260.926,393.393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.709,315.516 241.442,300.239 273.479,326.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.155,273.48 300.244,241.44 315.515,279.717  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M570.675,472.768c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.509l-25.423-34.509h80.404 C570.295,477.793,570.675,475.326,570.675,472.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.973,215.347 413.035,269.133 430.03,273.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "478.499,305.99 513.419,258.604 466.04,293.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "498.219,341.991 502.896,358.987 556.68,335.057  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.035,502.893 436.973,556.677 430.03,498.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.05,556.677 358.986,502.893 341.996,498.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.531,466.031 258.607,513.426 305.99,478.494  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.805,341.991 215.35,335.057 269.131,358.987  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.99,293.533 258.607,258.604 293.531,305.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.986,269.133 335.05,215.347 341.996,273.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.014,218.965 379.844,259.709 392.179,259.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.008,240.225 447.088,272.266 457.729,278.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.755,324.945 531.799,299.024 493.525,314.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.088,499.76 473.008,531.799 457.729,493.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.029,531.799 324.94,499.76 314.3,493.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.264,447.084 240.228,473 278.494,457.731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.711,379.848 218.968,386.014 259.711,392.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.494,314.301 240.228,299.024 272.264,324.945  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.94,272.266 299.029,240.225 314.3,278.502  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M569.46,471.553c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.726l46.805,34.508l-25.423-34.508H568.4 C569.08,476.578,569.46,474.111,569.46,471.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.758,214.132 411.82,267.917 428.814,272.595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.283,304.775 512.203,257.389 464.824,292.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.004,340.775 501.681,357.771 555.465,333.842  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.82,501.678 435.758,555.462 428.814,497.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.834,555.462 357.771,501.678 340.78,497.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.315,464.816 257.393,512.211 304.775,477.279  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.59,340.775 214.135,333.842 267.916,357.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.775,292.317 257.393,257.389 292.315,304.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.771,267.917 333.834,214.132 340.78,272.595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.799,217.75 378.629,258.494 390.963,258.494  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.793,239.01 445.872,271.051 456.514,277.286  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "498.539,323.73 530.583,297.809 492.31,313.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "551.839,384.799 511.096,378.633 511.096,390.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.872,498.545 471.793,530.584 456.514,492.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.799,551.843 390.963,511.104 378.629,511.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.814,530.584 323.726,498.545 313.084,492.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.049,445.869 239.013,471.785 277.279,456.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.496,378.633 217.753,384.799 258.496,390.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.279,313.085 239.013,297.809 271.049,323.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.726,271.051 297.814,239.01 313.084,277.286  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M568.244,470.338c0-14.139-11.094-25.656-25.046-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.432,3.26-26.609c0-60.762-49.256-110.007-110.01-110.007 c-58.599,0-106.479,45.813-109.808,103.583c-3.765,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C567.864,475.362,568.244,472.896,568.244,470.338z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.542,212.916 410.604,266.702 427.6,271.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "476.068,303.561 510.988,256.173 463.609,291.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "495.789,339.561 500.465,356.557 554.249,332.625  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.604,500.461 434.542,554.246 427.6,495.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.619,554.246 356.555,500.461 339.565,495.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.1,463.601 256.177,510.996 303.56,476.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.374,339.561 212.919,332.625 266.7,356.557  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.56,291.103 256.177,256.173 291.1,303.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.555,266.702 332.619,212.916 339.565,271.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.583,216.534 377.413,257.278 389.748,257.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.577,237.794 444.657,269.835 455.298,276.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.324,322.515 529.368,296.594 491.095,311.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "550.623,383.583 509.88,377.417 509.88,389.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.657,497.33 470.577,529.368 455.298,491.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.583,550.628 389.748,509.889 377.413,509.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.599,529.368 322.51,497.33 311.869,491.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.833,444.654 237.797,470.569 276.063,455.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.281,377.417 216.537,383.583 257.281,389.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.063,311.87 237.797,296.594 269.833,322.515  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.51,269.835 296.599,237.794 311.869,276.07  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M567.029,469.122c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.787-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.388,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C566.648,474.147,567.029,471.681,567.029,469.122z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.327,211.702 409.39,265.486 426.385,270.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.854,302.346 509.773,254.958 462.395,289.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.574,338.346 499.25,355.342 553.034,331.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.39,499.246 433.327,553.031 426.385,494.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.404,553.031 355.34,499.246 338.351,494.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.885,462.387 254.962,509.781 302.345,474.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.159,338.346 211.704,331.41 265.485,355.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.345,289.888 254.962,254.958 289.885,302.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.34,265.486 331.404,211.702 338.351,270.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.368,215.32 376.198,256.063 388.533,256.063  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.362,236.579 443.442,268.62 454.083,274.855  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "496.109,321.3 528.152,295.379 489.879,310.655  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "549.408,382.368 508.665,376.202 508.665,388.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.442,496.115 469.362,528.153 454.083,489.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.368,549.412 388.533,508.673 376.198,508.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.384,528.153 321.295,496.115 310.654,489.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.618,443.439 236.582,469.354 274.849,454.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.065,376.202 215.322,382.368 256.065,388.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.849,310.655 236.582,295.379 268.618,321.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.295,268.62 295.384,236.579 310.654,274.855  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M565.814,467.907c0-14.139-11.094-25.655-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.812c-2.962-0.787-6.055-1.256-9.267-1.256 c-0.217,0-0.425,0.023-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.599-6.505,10.067-7.806,16.085c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.368-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.099h21.727l46.805,34.509l-25.423-34.509h80.404 C565.435,472.933,565.814,470.466,565.814,467.907z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.112,210.487 408.175,264.272 425.17,268.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.639,301.13 508.559,253.743 461.18,288.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "493.359,337.131 498.035,354.127 551.819,330.195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.175,498.032 432.112,551.816 425.17,493.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.189,551.816 354.125,498.032 337.136,493.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.67,461.171 253.747,508.566 301.13,473.635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.944,337.131 210.49,330.195 264.271,354.127  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.13,288.673 253.747,253.743 288.67,301.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.125,264.272 330.189,210.487 337.136,268.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.153,214.105 374.983,254.849 387.318,254.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.147,235.364 442.227,267.406 452.868,273.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.895,320.085 526.938,294.164 488.664,309.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "548.193,381.153 507.45,374.987 507.45,387.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.227,494.9 468.147,526.938 452.868,488.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.153,548.198 387.318,507.458 374.983,507.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.169,526.938 320.08,494.9 309.439,488.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.404,442.225 235.367,468.141 273.633,452.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.851,374.987 214.107,381.153 254.851,387.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.633,309.44 235.367,294.164 267.404,320.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.08,267.406 294.169,235.364 309.439,273.642  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M564.6,466.693c0-14.14-11.094-25.657-25.046-26.401c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.512l16.234,1.924l-53.784-23.927l-0.224,0.812c-2.962-0.787-6.055-1.256-9.267-1.256 c-0.216,0-0.424,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.087c-2.427-0.696-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.668,0,41.851-6.286,58.874-17.099h21.727l46.805,34.509l-25.422-34.509h80.403 C564.219,471.718,564.6,469.251,564.6,466.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.897,209.271 406.959,263.057 423.955,267.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "472.424,299.915 507.344,252.528 459.965,287.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.144,335.916 496.82,352.911 550.604,328.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.959,496.816 430.897,550.602 423.955,492.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.975,550.602 352.91,496.816 335.92,492.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.455,459.955 252.532,507.352 299.914,472.419  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.729,335.916 209.274,328.98 263.055,352.911  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.914,287.457 252.532,252.528 287.455,299.915  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.91,263.057 328.975,209.271 335.92,267.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.938,212.89 373.769,253.633 386.103,253.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.933,234.149 441.012,266.189 451.652,272.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "493.679,318.87 525.723,292.948 487.449,308.225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "546.979,379.938 506.235,373.771 506.235,386.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.012,493.685 466.933,525.724 451.652,487.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.938,546.982 386.103,506.242 373.769,506.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.953,525.724 318.865,493.685 308.225,487.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.188,441.009 234.152,466.925 272.418,451.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.635,373.771 212.893,379.938 253.635,386.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.418,308.225 234.152,292.948 266.188,318.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.865,266.189 292.953,234.149 308.225,272.426  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M563.385,465.478c0-14.139-11.094-25.656-25.046-26.401c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.098-4.028-9.512l16.233,1.925l-53.783-23.928l-0.225,0.812c-2.962-0.787-6.054-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.642,0.026c2.118-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.767,4.599-6.506,10.068-7.807,16.086c-2.427-0.696-4.981-1.091-7.626-1.091 c-15.254,0-27.624,12.367-27.624,27.617c0,2.239,0.34,4.387,0.843,6.473l-18.644,8.293l55.478-6.581h14.525 c17.063,38.647,55.701,65.629,100.661,65.629c21.667,0,41.85-6.285,58.874-17.099h21.726l46.806,34.51l-25.423-34.51h80.403 C563.004,470.502,563.385,468.036,563.385,465.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.682,208.056 405.744,261.842 422.739,266.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.208,298.699 506.128,251.313 458.749,286.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.929,334.7 495.605,351.695 549.389,327.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.744,495.602 429.682,549.387 422.739,490.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.759,549.387 351.694,495.602 334.705,490.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.24,458.74 251.316,506.135 298.699,471.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.514,334.7 208.059,327.766 261.84,351.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.699,286.242 251.316,251.313 286.24,298.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.694,261.842 327.759,208.056 334.705,266.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.723,211.674 372.553,252.418 384.887,252.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.717,232.935 439.797,264.975 450.438,271.211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.464,317.654 524.508,291.733 486.234,307.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "545.763,378.723 505.02,372.557 505.02,384.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.797,492.47 465.717,524.508 450.438,486.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.723,545.768 384.887,505.027 372.553,505.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.738,524.508 317.649,492.47 307.009,486.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.973,439.793 232.937,465.709 271.203,450.439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.42,372.557 211.677,378.723 252.42,384.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.203,307.01 232.937,291.733 264.973,317.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.649,264.975 291.738,232.935 307.009,271.211  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M562.169,464.262c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.926l-53.783-23.928l-0.225,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.726l46.805,34.508l-25.423-34.508h80.404 C561.789,469.287,562.169,466.82,562.169,464.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.467,206.842 404.529,260.627 421.525,265.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.994,297.484 504.914,250.098 457.533,285.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "489.713,333.486 494.391,350.48 548.174,326.551  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.529,494.387 428.467,548.172 421.525,489.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.544,548.172 350.479,494.387 333.49,489.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.025,457.525 250.102,504.921 297.484,469.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.299,333.486 206.844,326.551 260.625,350.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.484,285.027 250.102,250.098 285.025,297.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.479,260.627 326.544,206.842 333.49,265.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.508,210.459 371.338,251.204 383.672,251.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.502,231.719 438.582,263.76 449.223,269.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.249,316.439 523.293,290.519 485.02,305.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "544.548,377.508 503.805,371.342 503.805,383.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.582,491.255 464.502,523.293 449.223,485.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.508,544.553 383.672,503.813 371.338,503.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.523,523.293 316.435,491.255 305.794,485.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.758,438.579 231.722,464.494 269.988,449.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.206,371.342 210.462,377.508 251.206,383.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.988,305.795 231.722,290.519 263.758,316.439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.435,263.76 290.523,231.719 305.794,269.996  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M560.955,463.047c0-14.139-11.096-25.656-25.047-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.811c-2.962-0.786-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.725l46.807,34.509l-25.424-34.509h80.404 C560.574,468.072,560.955,465.605,560.955,463.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.252,205.626 403.314,259.412 420.31,264.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.778,296.27 503.699,248.883 456.319,283.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.498,332.271 493.175,349.266 546.959,325.336  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.314,493.172 427.252,546.957 420.31,488.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.328,546.957 349.265,493.172 332.275,488.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.811,456.311 248.887,503.705 296.27,468.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.084,332.271 205.629,325.336 259.41,349.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.27,283.813 248.887,248.883 283.811,296.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.265,259.412 325.328,205.626 332.275,264.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.293,209.244 370.123,249.988 382.457,249.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.287,230.504 437.367,262.545 448.008,268.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "490.033,315.225 522.078,289.304 483.805,304.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "543.333,376.293 502.59,370.127 502.59,382.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.367,490.039 463.287,522.078 448.008,483.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.293,543.338 382.457,502.598 370.123,502.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.309,522.078 315.22,490.039 304.578,483.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.543,437.363 230.507,463.279 268.773,448.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.99,370.127 209.247,376.293 249.99,382.457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.773,304.58 230.507,289.304 262.543,315.225  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.22,262.545 289.309,230.504 304.578,268.78  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M559.739,461.832c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.807,16.086c-2.426-0.695-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.807,34.508l-25.424-34.508h80.404 C559.359,466.857,559.739,464.391,559.739,461.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.037,204.411 402.1,258.197 419.095,262.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.563,295.055 502.483,247.667 455.104,282.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "487.283,331.056 491.96,348.051 545.744,324.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.1,491.956 426.037,545.74 419.095,487.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.113,545.74 348.049,491.956 331.06,487.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.595,455.096 247.671,502.49 295.055,467.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.869,331.056 204.414,324.121 258.195,348.051  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.055,282.598 247.671,247.667 282.595,295.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.049,258.197 324.113,204.411 331.06,262.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.078,208.029 368.908,248.773 381.242,248.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.072,229.289 436.152,261.33 446.793,267.565  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.818,314.01 520.863,288.088 482.59,303.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "542.118,375.078 501.375,368.912 501.375,381.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.152,488.824 462.072,520.863 446.793,482.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.078,542.123 381.242,501.383 368.908,501.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.094,520.863 314.005,488.824 303.363,482.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.328,436.148 229.292,462.064 267.558,446.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.775,368.912 208.032,375.078 248.775,381.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.558,303.365 229.292,288.088 261.328,314.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.005,261.33 288.094,229.289 303.363,267.565  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M558.524,460.617c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.811c-2.963-0.787-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.01-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.695-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.292l55.479-6.58h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.508l-25.423-34.508h80.404 C558.144,465.642,558.524,463.176,558.524,460.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.822,203.196 400.885,256.981 417.88,261.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.348,293.84 501.269,246.452 453.889,281.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.068,329.841 490.744,346.836 544.529,322.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.885,490.741 424.822,544.525 417.88,486.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.898,544.525 346.834,490.741 329.845,486.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.38,453.881 246.457,501.275 293.839,466.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.654,329.841 203.199,322.905 256.979,346.836  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.839,281.382 246.457,246.452 281.38,293.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.834,256.981 322.898,203.196 329.845,261.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.862,206.814 367.693,247.558 380.027,247.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.857,228.074 434.937,260.115 445.578,266.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "487.604,312.794 519.647,286.873 481.374,302.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "540.902,373.862 500.16,367.696 500.16,380.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.937,487.609 460.857,519.648 445.578,481.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.862,540.907 380.027,500.168 367.693,500.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.879,519.648 312.789,487.609 302.148,481.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.113,434.934 228.077,460.85 266.343,445.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.561,367.696 206.817,373.862 247.561,380.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.343,302.15 228.077,286.873 260.113,312.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.789,260.115 286.879,228.074 302.148,266.351  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M557.309,459.402c0-14.139-11.094-25.656-25.045-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.924l-53.785-23.926l-0.223,0.811c-2.963-0.787-6.055-1.256-9.268-1.256 c-0.216,0-0.424,0.023-0.641,0.027c2.119-8.524,3.26-17.433,3.26-26.61c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.981-1.09-7.627-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.34,4.387,0.843,6.472l-18.644,8.292l55.478-6.58h14.526 c17.062,38.647,55.699,65.629,100.659,65.629c21.669,0,41.851-6.285,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C556.929,464.427,557.309,461.961,557.309,459.402z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.607,201.981 399.669,255.766 416.664,260.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.133,292.624 500.053,245.237 452.674,280.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "484.854,328.625 489.529,345.621 543.314,321.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.669,489.526 423.607,543.311 416.664,484.855  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.684,543.311 345.619,489.526 328.63,484.855  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.165,452.666 245.241,500.061 292.624,465.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.438,328.625 201.984,321.69 255.765,345.621  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.624,280.167 245.241,245.237 280.165,292.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.619,255.766 321.684,201.981 328.63,260.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.647,205.6 366.478,246.343 378.813,246.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.643,226.859 433.722,258.899 444.362,265.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.389,311.579 518.433,285.658 480.159,300.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "539.688,372.647 498.945,366.481 498.945,378.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.722,486.395 459.643,518.434 444.362,480.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.647,539.692 378.813,498.952 366.478,498.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.663,518.434 311.574,486.395 300.934,480.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.897,433.719 226.861,459.634 265.128,444.365  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.345,366.481 205.602,372.647 246.345,378.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.128,300.935 226.861,285.658 258.897,311.579  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.574,258.899 285.663,226.859 300.934,265.135  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M556.094,458.187c0-14.138-11.094-25.655-25.045-26.399c0.012-0.198,0.059-0.393,0.059-0.598 c0-3.734-1.551-7.098-4.027-9.513l16.234,1.925l-53.785-23.927l-0.223,0.811c-2.963-0.786-6.056-1.255-9.268-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.12-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.506,10.067-7.806,16.085c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.58h14.525 c17.063,38.646,55.7,65.629,100.66,65.629c21.669,0,41.851-6.286,58.875-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C555.713,463.212,556.094,460.745,556.094,458.187z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.392,200.766 398.454,254.551 415.449,259.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.918,291.409 498.838,244.022 451.459,278.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.639,327.41 488.314,344.405 542.099,320.475  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.454,488.311 422.392,542.096 415.449,483.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.469,542.096 344.404,488.311 327.414,483.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.949,451.45 244.026,498.846 291.409,463.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.224,327.41 200.769,320.475 254.55,344.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.409,278.952 244.026,244.022 278.949,291.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.404,254.551 320.469,200.766 327.414,259.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.433,204.384 365.263,245.128 377.598,245.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.427,225.644 432.506,257.685 443.147,263.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.174,310.363 517.217,284.443 478.944,299.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "538.473,371.433 497.729,365.267 497.729,377.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.506,485.18 458.427,517.218 443.147,478.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.433,538.478 377.598,497.737 365.263,497.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.448,517.218 310.359,485.18 299.719,478.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.683,432.504 225.646,458.419 263.912,443.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.13,365.267 204.387,371.433 245.13,377.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.912,299.72 225.646,284.443 257.683,310.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.359,257.685 284.448,225.644 299.719,263.92  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M554.879,456.972c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.786-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.696-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.099h21.727l46.805,34.509l-25.423-34.509h80.404 C554.498,461.996,554.879,459.53,554.879,456.972z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.177,199.551 397.239,253.336 414.234,258.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.703,290.194 497.623,242.807 450.244,277.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.424,326.195 487.1,343.19 540.884,319.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.239,487.096 421.177,540.881 414.234,482.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.254,540.881 343.189,487.096 326.199,482.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.734,450.235 242.812,497.631 290.194,462.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.008,326.195 199.553,319.26 253.335,343.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.194,277.737 242.812,242.807 277.734,290.194  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.189,253.336 319.254,199.551 326.199,258.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.218,203.169 364.048,243.913 376.382,243.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.212,224.429 431.291,256.47 441.933,262.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.958,309.148 516.002,283.229 477.729,298.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "537.258,370.218 496.515,364.051 496.515,376.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.291,483.965 457.212,516.003 441.933,477.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.218,537.262 376.382,496.521 364.048,496.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.233,516.003 309.145,483.965 298.504,477.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.468,431.288 224.432,457.204 262.697,441.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.915,364.051 203.172,370.218 243.915,376.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.697,298.504 224.432,283.229 256.468,309.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.145,256.47 283.233,224.429 298.504,262.705  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M553.664,455.757c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.735-1.552-7.099-4.028-9.513l16.234,1.925L487.1,397.245l-0.224,0.81c-2.963-0.786-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.255-110.007-110.01-110.007 c-58.599,0-106.479,45.814-109.808,103.583c-3.765,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.981-1.091-7.626-1.091 c-15.254,0-27.623,12.368-27.623,27.617c0,2.239,0.339,4.388,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.701,65.631,100.661,65.631c21.668,0,41.85-6.286,58.874-17.099h21.727l46.805,34.509L472.2,463.122h80.404 C553.284,460.781,553.664,458.315,553.664,455.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.962,198.336 396.024,252.121 413.02,256.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.488,288.979 496.408,241.592 449.028,276.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "481.208,324.98 485.885,341.976 539.669,318.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.024,485.881 419.962,539.666 413.02,481.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.039,539.666 341.975,485.881 324.984,481.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.52,449.02 241.596,496.415 288.979,461.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.793,324.98 198.338,318.045 252.119,341.976  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.979,276.521 241.596,241.592 276.52,288.979  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.975,252.121 318.039,198.336 324.984,256.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.003,201.954 362.832,242.698 375.167,242.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.996,223.214 430.076,255.255 440.718,261.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.743,307.934 514.787,282.014 476.514,297.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "536.043,369.003 495.3,362.836 495.3,375.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.076,482.749 455.996,514.788 440.718,476.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.003,536.047 375.167,495.307 362.832,495.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.019,514.788 307.929,482.749 297.288,476.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.252,430.073 223.216,455.989 261.482,440.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.7,362.836 201.957,369.003 242.7,375.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.482,297.289 223.216,282.014 255.252,307.934  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.929,255.255 282.019,223.214 297.288,261.49  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M552.449,454.541c0-14.138-11.095-25.656-25.046-26.399c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.926l-53.784-23.927l-0.224,0.81c-2.963-0.786-6.056-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.608c0-60.762-49.255-110.007-110.01-110.007 c-58.599,0-106.479,45.813-109.808,103.583c-3.766,4.599-6.505,10.067-7.806,16.085c-2.427-0.695-4.981-1.089-7.627-1.089 c-15.253,0-27.623,12.367-27.623,27.616c0,2.238,0.34,4.387,0.843,6.473l-18.644,8.293l55.478-6.582h14.526 c17.062,38.648,55.7,65.63,100.66,65.63c21.667,0,41.85-6.286,58.874-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C552.068,459.566,552.449,457.101,552.449,454.541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.746,197.12 394.81,250.906 411.805,255.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.273,287.764 495.192,240.377 447.813,275.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.993,323.766 484.67,340.76 538.453,316.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.81,484.666 418.746,538.45 411.805,479.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.823,538.45 340.759,484.666 323.77,479.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.305,447.805 240.381,495.2 287.764,460.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.578,323.766 197.123,316.83 250.904,340.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.764,275.307 240.381,240.377 275.305,287.764  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.759,250.906 316.823,197.12 323.77,255.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.787,200.739 361.617,241.483 373.952,241.483  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.782,221.999 428.861,254.039 439.502,260.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "481.528,306.719 513.572,280.798 475.299,296.074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "534.828,367.787 494.084,361.621 494.084,373.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.861,481.534 454.782,513.572 439.502,475.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.787,534.832 373.952,494.092 361.617,494.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.803,513.572 306.714,481.534 296.073,475.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.037,428.857 222.001,454.773 260.268,439.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.484,361.621 200.742,367.787 241.484,373.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.268,296.074 222.001,280.798 254.037,306.719  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.714,254.039 280.803,221.999 296.073,260.275  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M551.234,453.326c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.224,0.811c-2.963-0.786-6.056-1.254-9.267-1.254 c-0.217,0-0.426,0.021-0.642,0.025c2.118-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.695-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.701,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.726l46.805,34.509l-25.422-34.509h80.403 C550.854,458.352,551.234,455.885,551.234,453.326z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.531,195.905 393.594,249.691 410.589,254.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.058,286.549 493.978,239.162 446.598,274.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "478.778,322.55 483.455,339.545 537.238,315.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.594,483.451 417.531,537.235 410.589,478.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.608,537.235 339.544,483.451 322.555,478.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.089,446.59 239.166,493.985 286.549,459.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.363,322.55 195.908,315.615 249.689,339.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.549,274.092 239.166,239.162 274.089,286.549  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.544,249.691 315.608,195.905 322.555,254.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.572,199.524 360.402,240.268 372.737,240.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.566,220.783 427.646,252.824 438.287,259.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.313,305.504 512.357,279.583 474.084,294.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "533.613,366.572 492.869,360.406 492.869,372.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.646,480.318 453.566,512.357 438.287,474.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.572,533.617 372.737,492.877 360.402,492.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.588,512.357 305.499,480.318 294.857,474.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.822,427.643 220.786,453.559 259.053,438.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.27,360.406 199.526,366.572 240.27,372.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.053,294.859 220.786,279.583 252.822,305.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.499,252.824 279.588,220.783 294.857,259.06  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M550.02,452.111c0-14.139-11.095-25.656-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.597 c0-3.735-1.552-7.099-4.029-9.513l16.234,1.925L483.455,393.6l-0.225,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.762-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.426-0.695-4.982-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.478-6.581h14.526 c17.063,38.648,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.726l46.805,34.509l-25.423-34.509h80.404 C549.639,457.137,550.02,454.67,550.02,452.111z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.316,194.69 392.379,248.476 409.374,253.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.843,285.334 492.763,237.947 445.384,272.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.563,321.335 482.239,338.33 536.023,314.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.379,482.235 416.316,536.021 409.374,477.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.393,536.021 338.328,482.235 321.34,477.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.874,445.375 237.951,492.77 285.334,457.838  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.148,321.335 194.693,314.399 248.474,338.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.334,272.877 237.951,237.947 272.874,285.334  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.328,248.476 314.393,194.69 321.34,253.153  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.357,198.309 359.188,239.053 371.522,239.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.352,219.568 426.432,251.609 437.072,257.845  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "479.098,304.288 511.143,278.367 472.869,293.644  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "532.397,365.357 491.654,359.191 491.654,371.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.432,479.104 452.352,511.143 437.072,472.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.357,532.402 371.522,491.662 359.188,491.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.373,511.143 304.284,479.104 293.643,472.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.607,426.428 219.571,452.344 257.837,437.074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.055,359.191 198.312,365.357 239.055,371.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.837,293.644 219.571,278.367 251.607,304.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.284,251.609 278.373,219.568 293.643,257.845  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M548.804,450.896c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.787-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.762-49.255-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.508l-25.423-34.508h80.404 C548.424,455.922,548.804,453.455,548.804,450.896z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.102,193.476 391.164,247.261 408.159,251.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.628,284.118 491.548,236.731 444.168,271.661  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "476.348,320.12 481.024,337.115 534.809,313.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.164,481.021 415.102,534.806 408.159,476.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.178,534.806 337.113,481.021 320.124,476.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.659,444.16 236.735,491.555 284.119,456.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.933,320.12 193.479,313.185 247.259,337.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.119,271.661 236.735,236.731 271.659,284.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.113,247.261 313.178,193.476 320.124,251.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.143,197.094 357.973,237.838 370.307,237.838  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.137,218.354 425.216,250.395 435.857,256.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.883,303.073 509.928,277.152 471.653,292.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "531.183,364.143 490.439,357.977 490.439,370.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.216,477.889 451.137,509.928 435.857,471.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.143,531.187 370.307,490.447 357.973,490.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.158,509.928 303.068,477.889 292.428,471.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.393,425.213 218.356,451.129 256.622,435.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.84,357.977 197.097,364.143 237.84,370.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.622,292.43 218.356,277.152 250.393,303.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.068,250.395 277.158,218.354 292.428,256.63  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M547.589,449.682c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.81c-2.963-0.786-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.01-110.006 c-58.599,0-106.48,45.813-109.808,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.292l55.478-6.58h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.874-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C547.208,454.706,547.589,452.24,547.589,449.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.887,192.261 389.949,246.046 406.944,250.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.413,282.903 490.332,235.517 442.953,270.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.133,318.904 479.809,335.9 533.594,311.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.949,479.806 413.887,533.59 406.944,475.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.963,533.59 335.898,479.806 318.908,475.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.444,442.945 235.521,490.34 282.903,455.407  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.718,318.904 192.263,311.97 246.044,335.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.903,270.446 235.521,235.517 270.444,282.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.898,246.046 311.963,192.261 318.908,250.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.928,195.879 356.758,236.622 369.092,236.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.921,217.138 424.001,249.179 434.643,255.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "476.668,301.858 508.712,275.938 470.438,291.214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "529.967,362.928 489.225,356.761 489.225,369.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.001,476.674 449.921,508.713 434.643,470.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.928,529.972 369.092,489.232 356.758,489.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.942,508.713 301.854,476.674 291.213,470.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.177,423.998 217.141,449.913 255.407,434.645  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.625,356.761 195.881,362.928 236.625,369.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.407,291.214 217.141,275.938 249.177,301.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.854,249.179 275.942,217.138 291.213,255.414  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M546.374,448.467c0-14.14-11.095-25.657-25.046-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.785-23.926l-0.223,0.81c-2.963-0.786-6.055-1.255-9.268-1.255 c-0.216,0-0.424,0.022-0.641,0.027c2.119-8.524,3.26-17.434,3.26-26.609c0-60.762-49.255-110.007-110.01-110.007 c-58.599,0-106.48,45.813-109.808,103.582c-3.766,4.6-6.506,10.069-7.806,16.086c-2.427-0.696-4.982-1.09-7.627-1.09 c-15.254,0-27.623,12.367-27.623,27.618c0,2.238,0.339,4.386,0.843,6.472l-18.644,8.292l55.478-6.581h14.526 c17.063,38.648,55.699,65.63,100.66,65.63c21.668,0,41.85-6.286,58.874-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C545.993,453.491,546.374,451.025,546.374,448.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.671,191.045 388.734,244.83 405.729,249.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.197,281.688 489.117,234.301 441.738,269.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.918,317.689 478.594,334.685 532.379,310.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.734,478.59 412.671,532.375 405.729,473.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.748,532.375 334.684,478.59 317.694,473.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.229,441.729 234.306,489.125 281.688,454.192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.503,317.689 191.048,310.754 244.829,334.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.688,269.231 234.306,234.301 269.229,281.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.684,244.83 310.748,191.045 317.694,249.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.712,194.664 355.542,235.407 367.877,235.407  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.707,215.923 422.785,247.964 433.427,254.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.453,300.644 507.497,274.723 469.224,289.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "528.752,361.712 488.01,355.546 488.01,367.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.785,475.459 448.707,507.497 433.427,469.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.712,528.756 367.877,488.017 355.542,488.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.728,507.497 300.639,475.459 289.997,469.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.962,422.783 215.926,448.698 254.192,433.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.409,355.546 194.666,361.712 235.409,367.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.192,289.999 215.926,274.723 247.962,300.644  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.639,247.964 274.728,215.923 289.997,254.199  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M545.158,447.251c0-14.139-11.094-25.656-25.045-26.4c0.011-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.785-23.927l-0.223,0.811c-2.963-0.786-6.056-1.255-9.268-1.255 c-0.216,0-0.424,0.022-0.642,0.026c2.12-8.524,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.426-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.098h21.726l46.805,34.508l-25.423-34.508H544.1 C544.778,452.275,545.158,449.81,545.158,447.251z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.456,189.83 387.519,243.615 404.514,248.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.982,280.473 487.902,233.086 440.523,268.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "472.703,316.475 477.379,333.47 531.163,309.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.519,477.375 411.456,531.16 404.514,472.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.533,531.16 333.469,477.375 316.479,472.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.014,440.515 233.091,487.909 280.473,452.978  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.288,316.475 189.833,309.539 243.614,333.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.473,268.017 233.091,233.086 268.014,280.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.469,243.615 309.533,189.83 316.479,248.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.497,193.448 354.327,234.192 366.662,234.192  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.491,214.708 421.57,246.749 432.212,252.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.238,299.428 506.281,273.508 468.008,288.783  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "527.537,360.497 486.794,354.331 486.794,366.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.57,474.244 447.491,506.282 432.212,468.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.497,527.541 366.662,486.802 354.327,486.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.513,506.282 299.424,474.244 288.782,468.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.747,421.568 214.711,447.483 252.977,432.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.194,354.331 193.451,360.497 234.194,366.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.977,288.783 214.711,273.508 246.747,299.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.424,246.749 273.513,214.708 288.782,252.984  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M543.943,446.036c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.551-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.962-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.478-6.581h14.526 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.85-6.286,58.875-17.099h21.726l46.805,34.508l-25.423-34.508h80.404 C543.563,451.061,543.943,448.595,543.943,446.036z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.241,188.615 386.304,242.4 403.299,247.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.768,279.258 486.688,231.871 439.309,266.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.488,315.26 476.164,332.255 529.948,308.324  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.304,476.16 410.241,529.944 403.299,471.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.318,529.944 332.253,476.16 315.264,471.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.799,439.299 231.875,486.694 279.258,451.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.073,315.26 188.618,308.324 242.398,332.255  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.258,266.801 231.875,231.871 266.799,279.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.253,242.4 308.318,188.615 315.264,247.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.281,192.233 353.112,232.977 365.447,232.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.276,213.493 420.355,245.534 430.997,251.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "473.022,298.213 505.066,272.292 466.793,287.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "526.322,359.281 485.579,353.115 485.579,365.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.355,473.028 446.276,505.067 430.997,466.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.281,526.326 365.447,485.586 353.112,485.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.298,505.067 298.208,473.028 287.567,466.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.532,420.353 213.496,446.269 251.762,430.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.979,353.115 192.236,359.281 232.979,365.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.762,287.568 213.496,272.292 245.532,298.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.208,245.534 272.298,213.493 287.567,251.769  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M542.729,444.82c0-14.139-11.095-25.656-25.046-26.399c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.551-7.099-4.028-9.513l16.234,1.926l-53.784-23.928l-0.224,0.811c-2.963-0.786-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.025c2.119-8.523,3.261-17.432,3.261-26.609c0-60.76-49.256-110.005-110.012-110.005 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.616c0,2.239,0.339,4.387,0.843,6.473l-18.644,8.293l55.478-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C542.348,449.846,542.729,447.379,542.729,444.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.025,187.4 385.089,241.186 402.084,245.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.553,278.043 485.473,230.656 438.093,265.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.273,314.045 474.949,331.04 528.733,307.109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.089,474.945 409.025,528.729 402.084,470.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.103,528.729 331.038,474.945 314.049,470.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.584,438.084 230.66,485.479 278.043,450.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.857,314.045 187.402,307.109 241.184,331.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.043,265.586 230.66,230.656 265.584,278.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.038,241.186 307.103,187.4 314.049,245.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.066,191.019 351.896,231.762 364.231,231.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.061,212.278 419.141,244.319 429.782,250.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.808,296.998 503.852,271.077 465.578,286.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "525.107,358.066 484.364,351.9 484.364,364.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.141,471.813 445.061,503.852 429.782,465.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.066,525.111 364.231,484.371 351.896,484.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.082,503.852 296.993,471.813 286.353,465.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.317,419.138 212.281,445.053 250.547,429.784  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.764,351.9 191.021,358.066 231.764,364.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.547,286.354 212.281,271.077 244.317,296.998  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.993,244.319 271.082,212.278 286.353,250.554  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M541.514,443.605c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.512l16.234,1.924l-53.784-23.927l-0.225,0.811c-2.962-0.786-6.054-1.254-9.266-1.254 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.695-4.981-1.09-7.626-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.403 C541.133,448.631,541.514,446.164,541.514,443.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.811,186.185 383.873,239.97 400.868,244.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.338,276.828 484.258,229.441 436.878,264.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.058,312.829 473.734,329.824 527.518,305.895  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.873,473.73 407.811,527.515 400.868,469.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.888,527.515 329.823,473.73 312.834,469.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.369,436.869 229.445,484.264 276.828,449.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.643,312.829 186.188,305.895 239.969,329.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.828,264.371 229.445,229.441 264.369,276.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.823,239.97 305.888,186.185 312.834,244.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.852,189.804 350.682,230.547 363.017,230.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.847,211.063 417.925,243.104 428.566,249.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.593,295.783 502.637,269.862 464.363,285.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "523.892,356.852 483.149,350.686 483.149,363.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.925,470.599 443.847,502.637 428.566,464.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.852,523.896 363.017,483.156 350.682,483.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.867,502.637 295.778,470.599 285.137,464.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.102,417.922 211.065,443.838 249.332,428.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.549,350.686 189.806,356.852 230.549,363.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.332,285.139 211.065,269.862 243.102,295.783  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.778,243.104 269.867,211.063 285.137,249.339  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M540.299,442.391c0-14.139-11.095-25.656-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.234,1.925l-53.783-23.927l-0.225,0.811c-2.962-0.786-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.85-6.286,58.875-17.099h21.726l46.806,34.508l-25.424-34.508h80.405 C539.918,447.416,540.299,444.949,540.299,442.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.596,184.97 382.658,238.755 399.654,243.433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.122,275.613 483.042,228.226 435.662,263.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.843,311.614 472.52,328.609 526.303,304.679  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.658,472.515 406.596,526.299 399.654,467.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.672,526.299 328.607,472.515 311.618,467.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.154,435.654 228.229,483.049 275.613,448.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.427,311.614 184.973,304.679 238.753,328.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.613,263.156 228.229,228.226 263.154,275.613  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.607,238.755 304.672,184.97 311.618,243.433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.637,188.588 349.467,229.332 361.802,229.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.631,209.848 416.71,241.889 427.352,248.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.377,294.567 501.422,268.647 463.148,283.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "522.677,355.637 481.934,349.471 481.934,361.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.71,469.383 442.631,501.422 427.352,463.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.637,522.682 361.802,481.941 349.467,481.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.652,501.422 294.563,469.383 283.922,463.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.887,416.707 209.851,442.623 248.116,427.354  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.334,349.471 188.591,355.637 229.334,361.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.116,283.924 209.851,268.647 241.887,294.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.563,241.889 268.652,209.848 283.922,248.124  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M539.084,441.176c0-14.139-11.096-25.656-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.512l16.234,1.925l-53.783-23.927l-0.225,0.81c-2.962-0.785-6.055-1.254-9.266-1.254 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.01-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.508l-25.423-34.508h80.404 C538.703,446.2,539.084,443.734,539.084,441.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.381,183.755 381.443,237.54 398.438,242.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.907,274.398 481.827,227.011 434.447,261.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.627,310.399 471.304,327.395 525.088,303.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.443,471.3 405.381,525.084 398.438,466.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.457,525.084 327.393,471.3 310.403,466.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.938,434.439 227.015,481.834 274.397,446.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.212,310.399 183.757,303.464 237.538,327.395  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.397,261.94 227.015,227.011 261.938,274.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.393,237.54 303.457,183.755 310.403,242.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.422,187.373 348.252,228.117 360.586,228.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.416,208.633 415.495,240.673 426.137,246.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "468.162,293.353 500.207,267.432 461.933,282.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "521.462,354.422 480.719,348.256 480.719,360.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.495,468.168 441.416,500.207 426.137,461.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.422,521.466 360.586,480.727 348.252,480.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.438,500.207 293.348,468.168 282.707,461.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.672,415.492 208.636,441.408 246.901,426.139  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.119,348.256 187.376,354.422 228.119,360.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.901,282.709 208.636,267.432 240.672,293.353  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.348,240.673 267.438,208.633 282.707,246.908  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M537.868,439.961c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.81c-2.963-0.786-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.007-110.01-110.007 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.253,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.292l55.478-6.58h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.726l46.805,34.508l-25.423-34.508h80.404 C537.488,444.985,537.868,442.52,537.868,439.961z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.166,182.54 380.229,236.325 397.223,241.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.692,273.183 480.612,225.796 433.232,260.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.413,309.184 470.089,326.18 523.873,302.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.229,470.085 404.166,523.869 397.223,465.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.242,523.869 326.178,470.085 309.188,465.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.724,433.225 225.8,480.619 273.183,445.688  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.997,309.184 182.542,302.249 236.323,326.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.183,260.726 225.8,225.796 260.724,273.183  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.178,236.325 302.242,182.54 309.188,241.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.206,186.158 347.036,226.901 359.371,226.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.201,207.417 414.28,239.458 424.922,245.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.947,292.138 498.991,266.217 460.719,281.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "520.247,353.206 479.504,347.04 479.504,359.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.28,466.953 440.201,498.992 424.922,460.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.206,520.251 359.371,479.512 347.036,479.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.222,498.992 292.133,466.953 281.492,460.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.457,414.277 207.42,440.192 245.687,424.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.904,347.04 186.161,353.206 226.904,359.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.687,281.493 207.42,266.217 239.457,292.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.133,239.458 266.222,207.417 281.492,245.694  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M536.653,438.746c0-14.139-11.095-25.657-25.046-26.4c0.012-0.198,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.099-4.029-9.512l16.234,1.924l-53.784-23.927l-0.224,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.427-0.696-4.982-1.089-7.626-1.089 c-15.254,0-27.624,12.367-27.624,27.616c0,2.239,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.581h14.526 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.285,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C536.272,443.77,536.653,441.304,536.653,438.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.951,181.325 379.014,235.11 396.009,239.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.477,271.967 479.396,224.58 432.018,259.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.197,307.969 468.874,324.965 522.658,301.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.014,468.869 402.951,522.654 396.009,464.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.027,522.654 324.963,468.869 307.973,464.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.508,432.009 224.585,479.404 271.968,444.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.782,307.969 181.327,301.033 235.108,324.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.968,259.511 224.585,224.58 259.508,271.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.963,235.11 301.027,181.325 307.973,239.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.991,184.942 345.821,225.687 358.156,225.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.985,206.203 413.065,238.243 423.707,244.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.732,290.922 497.776,265.002 459.503,280.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "519.032,351.991 478.289,345.825 478.289,358.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.065,465.738 438.985,497.776 423.707,459.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.991,519.036 358.156,478.297 345.821,478.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.007,497.776 290.918,465.738 280.277,459.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.241,413.063 206.205,438.978 244.471,423.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.688,345.825 184.946,351.991 225.688,358.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.471,280.278 206.205,265.002 238.241,290.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.918,238.243 265.007,206.203 280.277,244.479  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M535.438,437.53c0-14.139-11.095-25.656-25.046-26.4c0.011-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.235,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.118-8.523,3.26-17.433,3.26-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.087c-2.427-0.697-4.982-1.091-7.627-1.091 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.805,34.508l-25.422-34.508h80.404 C535.058,442.555,535.438,440.089,535.438,437.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.736,180.109 377.799,233.895 394.793,238.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.262,270.752 478.182,223.365 430.803,258.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.982,306.754 467.659,323.749 521.443,299.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.799,467.654 401.736,521.439 394.793,462.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.813,521.439 323.748,467.654 306.758,462.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.293,430.794 223.37,478.188 270.753,443.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.567,306.754 180.112,299.818 233.894,323.749  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.753,258.296 223.37,223.365 258.293,270.752  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.748,233.895 299.813,180.109 306.758,238.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.776,183.728 344.606,224.472 356.941,224.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.771,204.987 411.85,237.028 422.492,243.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.518,289.707 496.561,263.787 458.288,279.063  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "517.816,350.776 477.074,344.61 477.074,356.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.85,464.523 437.771,496.562 422.492,458.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.776,517.82 356.941,477.081 344.606,477.081  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.792,496.562 289.703,464.523 279.062,458.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.026,411.847 204.99,437.763 243.256,422.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.474,344.61 183.73,350.776 224.474,356.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.256,279.063 204.99,263.787 237.026,289.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.703,237.028 263.792,204.987 279.062,243.263  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M534.223,436.315c0-14.139-11.094-25.656-25.045-26.4c0.011-0.197,0.059-0.393,0.059-0.598 c0-3.734-1.551-7.098-4.027-9.512l16.234,1.925l-53.784-23.927l-0.225,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.022-0.641,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.85-6.286,58.875-17.098h21.726l46.805,34.507l-25.422-34.507h80.404 C533.843,441.34,534.223,438.874,534.223,436.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.521,178.895 376.583,232.68 393.578,237.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.047,269.537 476.967,222.15 429.588,257.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.768,305.539 466.443,322.534 520.228,298.604  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.583,466.439 400.521,520.225 393.578,461.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.597,520.225 322.532,466.439 305.543,461.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.078,429.579 222.155,476.974 269.537,442.042  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.352,305.539 178.897,298.604 232.678,322.534  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.537,257.08 222.155,222.15 257.078,269.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.532,232.68 298.597,178.895 305.543,237.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.562,182.513 343.391,223.257 355.727,223.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.556,203.772 410.635,235.813 421.276,242.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.303,288.492 495.347,262.571 457.072,277.848  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "516.602,349.562 475.858,343.395 475.858,355.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.635,463.308 436.556,495.346 421.276,457.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.562,516.605 355.727,475.866 343.391,475.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.577,495.346 288.488,463.308 277.847,457.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.811,410.632 203.775,436.548 242.041,421.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.259,343.395 182.516,349.562 223.259,355.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.041,277.848 203.775,262.571 235.811,288.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.488,235.813 262.577,203.772 277.847,242.048  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M533.008,435.101c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.099-4.029-9.513l16.234,1.926l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.007-110.011-110.007 c-58.599,0-106.479,45.813-109.807,103.582c-3.766,4.601-6.505,10.068-7.806,16.087c-2.426-0.696-4.982-1.09-7.626-1.09 c-15.253,0-27.623,12.366-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.582h14.525 c17.063,38.648,55.7,65.63,100.661,65.63c21.668,0,41.851-6.285,58.874-17.098h21.727l46.805,34.508l-25.423-34.508h80.404 C532.627,440.125,533.008,437.659,533.008,435.101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.306,177.679 375.368,231.465 392.363,236.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.832,268.322 475.752,220.936 428.373,255.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.553,304.324 465.229,321.319 519.013,297.389  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.368,465.225 399.306,519.01 392.363,460.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.382,519.01 321.317,465.225 304.328,460.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.863,428.363 220.939,475.759 268.322,440.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.137,304.324 177.683,297.389 231.463,321.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.322,255.865 220.939,220.936 255.863,268.322  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.317,231.465 297.382,177.679 304.328,236.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.346,181.298 342.176,222.042 354.512,222.042  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.341,202.558 409.42,234.599 420.062,240.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "462.088,287.277 494.131,261.356 455.857,276.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "515.387,348.346 474.644,342.18 474.644,354.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.42,462.093 435.341,494.132 420.062,455.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.346,515.391 354.512,474.65 342.176,474.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.362,494.132 287.272,462.093 276.631,455.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.596,409.417 202.56,435.332 240.826,420.063  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.043,342.18 181.3,348.346 222.043,354.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.826,276.633 202.56,261.356 234.596,287.277  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.272,234.599 261.362,202.558 276.631,240.833  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M531.793,433.885c0-14.139-11.094-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.512l16.234,1.925l-53.784-23.928l-0.224,0.811c-2.962-0.785-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.806,16.086c-2.427-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.293l55.478-6.582h14.526 c17.062,38.648,55.699,65.63,100.659,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C531.412,438.91,531.793,436.443,531.793,433.885z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.091,176.464 374.152,230.25 391.148,234.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.617,267.107 474.537,219.72 427.157,254.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.338,303.108 464.014,320.104 517.798,296.174  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.152,464.01 398.091,517.794 391.148,459.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.167,517.794 320.102,464.01 303.113,459.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.648,427.148 219.725,474.543 267.107,439.611  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.922,303.108 176.467,296.174 230.248,320.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.107,254.65 219.725,219.72 254.648,267.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.102,230.25 296.167,176.464 303.113,234.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.131,180.082 340.961,220.826 353.296,220.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.125,201.342 408.205,233.383 418.847,239.618  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.872,286.062 492.916,260.142 454.643,275.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "514.172,347.131 473.429,340.965 473.429,353.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.205,460.878 434.125,492.916 418.847,454.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.131,514.176 353.296,473.436 340.961,473.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.146,492.916 286.058,460.878 275.416,454.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.381,408.201 201.345,434.117 239.611,418.849  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.828,340.965 180.085,347.131 220.828,353.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.611,275.418 201.345,260.142 233.381,286.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.058,233.383 260.146,201.342 275.416,239.618  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M530.578,432.67c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.643,0.026c2.12-8.523,3.261-17.433,3.261-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.506,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.581h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.668,0,41.851-6.286,58.875-17.098h21.726l46.806,34.507l-25.423-34.507h80.404 C530.197,437.695,530.578,435.229,530.578,432.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.875,175.249 372.938,229.034 389.933,233.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.401,265.893 473.322,218.505 425.942,253.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.122,301.894 462.799,318.889 516.583,294.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.938,462.794 396.875,516.579 389.933,458.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.952,516.579 318.888,462.794 301.898,458.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.433,425.934 218.51,473.328 265.893,438.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.707,301.894 175.252,294.958 229.033,318.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.893,253.436 218.51,218.505 253.433,265.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.888,229.034 294.952,175.249 301.898,233.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.916,178.867 339.746,219.611 352.081,219.611  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.911,200.127 406.989,232.168 417.631,238.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.657,284.847 491.701,258.927 453.428,274.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "512.957,345.916 472.214,339.75 472.214,352.081  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.989,459.663 432.911,491.701 417.631,453.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.916,512.961 352.081,472.221 339.746,472.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.932,491.701 284.842,459.663 274.201,453.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.166,406.986 200.13,432.902 238.396,417.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.613,339.75 178.87,345.916 219.613,352.081  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.396,274.203 200.13,258.927 232.166,284.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.842,232.168 258.932,200.127 274.201,238.403  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M529.362,431.455c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.235,1.925l-53.784-23.927l-0.225,0.811c-2.962-0.786-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.403 C528.982,436.48,529.362,434.014,529.362,431.455z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.66,174.034 371.723,227.819 388.719,232.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.187,264.677 472.106,217.29 424.727,252.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.907,300.679 461.583,317.674 515.367,293.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.723,461.579 395.66,515.363 388.719,456.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.736,515.363 317.672,461.579 300.683,456.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.218,424.719 217.294,472.113 264.678,437.182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.492,300.679 174.037,293.743 227.818,317.674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.678,252.22 217.294,217.29 252.218,264.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.672,227.819 293.736,174.034 300.683,232.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.701,177.652 338.531,218.396 350.866,218.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.695,198.912 405.774,230.953 416.416,237.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.442,283.631 490.486,257.711 452.213,272.987  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "511.741,344.701 470.998,338.534 470.998,350.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.774,458.448 431.695,490.486 416.416,452.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.701,511.745 350.866,471.006 338.531,471.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.717,490.486 283.627,458.448 272.986,452.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.951,405.771 198.915,431.688 237.181,416.418  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.398,338.534 177.655,344.701 218.398,350.866  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.181,272.987 198.915,257.711 230.951,283.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.627,230.953 257.717,198.912 272.986,237.188  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M528.147,430.24c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.506,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.098h21.725l46.806,34.508l-25.423-34.508h80.404 C527.768,435.265,528.147,432.799,528.147,430.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.445,172.819 370.508,226.604 387.503,231.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.972,263.462 470.892,216.075 423.512,251.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.692,299.463 460.368,316.459 514.152,292.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.508,460.364 394.445,514.148 387.503,455.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.521,514.148 316.457,460.364 299.468,455.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.003,423.504 216.079,470.898 263.462,435.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.276,299.463 172.822,292.528 226.603,316.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.462,251.005 216.079,216.075 251.003,263.462  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.457,226.604 292.521,172.819 299.468,231.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.486,176.438 337.316,217.182 349.65,217.182  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.48,197.697 404.56,229.738 415.201,235.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.227,282.416 489.271,256.497 450.998,271.772  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "510.526,343.486 469.783,337.319 469.783,349.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.56,457.232 430.48,489.271 415.201,450.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.486,510.53 349.65,469.791 337.316,469.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.502,489.271 282.412,457.232 271.771,450.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.735,404.557 197.699,430.473 235.966,415.203  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.183,337.319 176.44,343.486 217.183,349.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.966,271.772 197.699,256.497 229.735,282.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.412,229.738 256.502,197.697 271.771,235.973  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M526.933,429.025c0-14.14-11.095-25.657-25.046-26.4c0.012-0.198,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.512l16.234,1.924l-53.784-23.926l-0.224,0.81c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.027c2.119-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.007-110.01-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.766,4.601-6.505,10.069-7.807,16.086c-2.426-0.696-4.981-1.089-7.625-1.089 c-15.254,0-27.624,12.367-27.624,27.617c0,2.237,0.339,4.386,0.843,6.472l-18.644,8.292l55.478-6.58h14.525 c17.063,38.647,55.7,65.629,100.661,65.629c21.668,0,41.85-6.286,58.874-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C526.553,434.05,526.933,431.584,526.933,429.025z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.23,171.604 369.293,225.39 386.288,230.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.757,262.247 469.677,214.859 422.297,249.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.478,298.248 459.153,315.244 512.938,291.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.293,459.148 393.23,512.934 386.288,454.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.307,512.934 315.242,459.148 298.253,454.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.788,422.289 214.864,469.684 262.247,434.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.062,298.248 171.606,291.313 225.388,315.244  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.247,249.79 214.864,214.859 249.788,262.247  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.242,225.39 291.307,171.604 298.253,230.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.271,175.222 336.101,215.966 348.436,215.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.266,196.482 403.345,228.523 413.986,234.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "456.012,281.201 488.056,255.281 449.782,270.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "509.312,342.271 468.568,336.104 468.568,348.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.345,456.018 429.266,488.056 413.986,449.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.271,509.315 348.436,468.575 336.101,468.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.286,488.056 281.197,456.018 270.557,449.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.521,403.342 196.484,429.257 234.75,413.988  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.968,336.104 175.225,342.271 215.968,348.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.75,270.558 196.484,255.281 228.521,281.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.197,228.523 255.286,196.482 270.557,234.758  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M525.718,427.81c0-14.138-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.027c2.119-8.524,3.26-17.433,3.26-26.61c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.767,4.599-6.506,10.067-7.806,16.086c-2.426-0.697-4.981-1.091-7.626-1.091 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.388,0.843,6.472l-18.645,8.293l55.479-6.581h14.526 c17.062,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C525.337,432.835,525.718,430.368,525.718,427.81z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.016,170.389 368.078,224.174 385.073,228.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.541,261.031 468.462,213.645 421.082,248.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.263,297.033 457.938,314.029 511.723,290.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.078,457.934 392.016,511.719 385.073,453.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.092,511.719 314.026,457.934 297.037,453.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.573,421.073 213.649,468.468 261.031,433.536  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.847,297.033 170.392,290.098 224.173,314.029  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.031,248.575 213.649,213.645 248.573,261.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.026,224.174 290.092,170.389 297.037,228.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.056,174.007 334.886,214.751 347.221,214.751  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.05,195.267 402.129,227.308 412.771,233.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.797,279.986 486.841,254.066 448.567,269.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "508.097,341.056 467.354,334.889 467.354,347.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.129,454.803 428.05,486.841 412.771,448.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.056,508.101 347.221,467.36 334.886,467.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.071,486.841 279.982,454.803 269.341,448.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.306,402.127 195.27,428.042 233.536,412.772  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.753,334.889 174.01,341.056 214.753,347.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.536,269.343 195.27,254.066 227.306,279.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.982,227.308 254.071,195.267 269.341,233.542  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M524.502,426.595c0-14.139-11.094-25.657-25.045-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.268-1.254 c-0.216,0-0.424,0.022-0.641,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.256-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.63,100.66,65.63c21.668,0,41.851-6.286,58.875-17.098h21.726l46.806,34.507l-25.423-34.507h80.404 C524.122,431.619,524.502,429.153,524.502,426.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.8,169.174 366.862,222.959 383.857,227.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.326,259.816 467.246,212.43 419.867,247.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.047,295.818 456.723,312.813 510.507,288.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.862,456.719 390.8,510.504 383.857,452.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.876,510.504 312.812,456.719 295.822,452.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.357,419.858 212.434,467.253 259.816,432.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.632,295.818 169.177,288.883 222.958,312.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.816,247.36 212.434,212.43 247.357,259.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.812,222.959 288.876,169.174 295.822,227.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.841,172.792 333.671,213.536 346.006,213.536  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.836,194.052 400.914,226.092 411.557,232.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.582,278.771 485.626,252.851 447.353,268.127  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "506.881,339.841 466.138,333.674 466.138,346.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.914,453.588 426.836,485.626 411.557,447.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.841,506.885 346.006,466.146 333.671,466.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.856,485.626 278.768,453.588 268.126,447.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.091,400.911 194.055,426.827 232.32,411.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.538,333.674 172.795,339.841 213.538,346.006  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.32,268.127 194.055,252.851 226.091,278.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.768,226.092 252.856,194.052 268.126,232.328  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M523.287,425.38c0-14.139-11.094-25.657-25.045-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.233,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.424,0.022-0.642,0.025c2.12-8.523,3.261-17.432,3.261-26.608c0-60.761-49.256-110.006-110.011-110.006 c-58.599,0-106.479,45.813-109.807,103.582c-3.767,4.601-6.505,10.069-7.806,16.087c-2.427-0.696-4.981-1.091-7.626-1.091 c-15.254,0-27.624,12.368-27.624,27.618c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.668,0,41.85-6.286,58.874-17.097h21.727l46.805,34.507l-25.423-34.507h80.404 C522.907,430.404,523.287,427.938,523.287,425.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.585,167.958 365.647,221.744 382.643,226.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.111,258.602 466.031,211.215 418.651,246.145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.832,294.604 455.508,311.599 509.292,287.668  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.647,455.504 389.585,509.288 382.643,450.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.661,509.288 311.597,455.504 294.607,450.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.143,418.643 211.219,466.038 258.602,431.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.416,294.604 167.961,287.668 221.742,311.599  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.602,246.145 211.219,211.215 246.143,258.602  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.597,221.744 287.661,167.958 294.607,226.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.625,171.577 332.456,212.321 344.791,212.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.62,192.837 399.699,224.877 410.341,231.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.367,277.557 484.41,251.636 446.137,266.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "505.666,338.625 464.923,332.459 464.923,344.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.699,452.373 425.62,484.41 410.341,446.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.625,505.67 344.791,464.931 332.456,464.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.642,484.41 277.552,452.373 266.91,446.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.875,399.696 192.839,425.612 231.105,410.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.323,332.459 171.58,338.625 212.323,344.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.105,266.912 192.839,251.636 224.875,277.557  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.552,224.877 251.642,192.837 266.91,231.112  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M522.072,424.164c0-14.138-11.095-25.656-25.045-26.4c0.011-0.197,0.059-0.392,0.059-0.597 c0-3.734-1.552-7.099-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.021-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.806,103.583c-3.767,4.599-6.506,10.068-7.807,16.085c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.253,0-27.624,12.367-27.624,27.618c0,2.237,0.339,4.386,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.7,65.629,100.66,65.629c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C521.691,429.189,522.072,426.724,522.072,424.164z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.37,166.744 364.433,220.529 381.428,225.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.896,257.387 464.816,209.999 417.437,244.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.617,293.388 454.293,310.383 508.077,286.453  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.433,454.289 388.37,508.073 381.428,449.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.446,508.073 310.381,454.289 293.393,449.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.927,417.428 210.004,464.822 257.387,429.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.201,293.388 166.747,286.453 220.527,310.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.387,244.93 210.004,209.999 244.927,257.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.381,220.529 286.446,166.744 293.393,225.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.41,170.362 331.24,211.105 343.575,211.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.405,191.622 398.484,223.662 409.126,229.897  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "451.151,276.341 483.195,250.421 444.922,265.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "504.451,337.41 463.708,331.244 463.708,343.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.484,451.157 424.405,483.195 409.126,444.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.41,504.455 343.575,463.715 331.24,463.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.426,483.195 276.337,451.157 265.695,444.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.66,398.481 191.624,424.396 229.891,409.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.108,331.244 170.365,337.41 211.108,343.575  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.891,265.697 191.624,250.421 223.66,276.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.337,223.662 250.426,191.622 265.695,229.897  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M520.857,422.949c0-14.139-11.095-25.656-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.811c-2.963-0.785-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.982-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.507l-25.423-34.507h80.404 C520.477,427.975,520.857,425.508,520.857,422.949z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.154,165.528 363.218,219.313 380.213,223.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.682,256.171 463.602,208.784 416.222,243.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.402,292.173 453.078,309.168 506.862,285.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.218,453.073 387.154,506.858 380.213,448.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.231,506.858 309.166,453.073 292.177,448.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.712,416.213 208.789,463.607 256.172,428.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.986,292.173 165.531,285.238 219.312,309.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.172,243.715 208.789,208.784 243.712,256.171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.166,219.313 285.231,165.528 292.177,223.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.195,169.146 330.025,209.891 342.36,209.891  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.189,190.406 397.269,222.447 407.91,228.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.937,275.126 481.98,249.206 443.707,264.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "503.236,336.195 462.493,330.029 462.493,342.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.269,449.942 423.189,481.98 407.91,443.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.195,503.24 342.36,462.5 330.025,462.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.211,481.98 275.121,449.942 264.48,443.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.445,397.266 190.409,423.182 228.675,407.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.893,330.029 169.149,336.195 209.893,342.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.675,264.482 190.409,249.206 222.445,275.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.121,222.447 249.211,190.406 264.48,228.683  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M519.643,421.734c0-14.139-11.095-25.656-25.046-26.4c0.011-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C519.262,426.759,519.643,424.293,519.643,421.734z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.939,164.313 362.002,218.099 378.998,222.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.467,254.956 462.387,207.569 415.007,242.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.187,290.958 451.862,307.953 505.646,284.022  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.002,451.858 385.939,505.643 378.998,447.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.017,505.643 307.951,451.858 290.962,447.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.497,414.998 207.574,462.393 254.956,427.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.771,290.958 164.316,284.022 218.097,307.953  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.956,242.5 207.574,207.569 242.497,254.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.951,218.099 284.017,164.313 290.962,222.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.98,167.932 328.811,208.676 341.146,208.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.976,189.191 396.054,221.232 406.695,227.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.722,273.911 480.766,247.991 442.492,263.267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "502.021,334.98 461.277,328.813 461.277,341.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.054,448.728 421.976,480.766 406.695,442.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.98,502.025 341.146,461.285 328.811,461.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.996,480.766 273.906,448.728 263.266,442.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.23,396.051 189.194,421.967 227.46,406.697  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.677,328.813 167.935,334.98 208.677,341.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.46,263.267 189.194,247.991 221.23,273.911  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.906,221.232 247.996,189.191 263.266,227.467  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M518.427,420.52c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.266-1.254 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.85-6.285,58.875-17.098h21.726l46.806,34.508l-25.424-34.508h80.404 C518.047,425.544,518.427,423.078,518.427,420.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.725,163.099 360.787,216.884 377.783,221.562  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.251,253.741 461.172,206.354 413.791,241.284  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.972,289.742 450.647,306.738 504.432,282.808  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.787,450.644 384.725,504.428 377.783,445.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.801,504.428 306.736,450.644 289.747,445.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.282,413.783 206.358,461.178 253.741,426.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.556,289.742 163.101,282.808 216.882,306.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.741,241.284 206.358,206.354 241.282,253.741  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.736,216.884 282.801,163.099 289.747,221.562  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.766,166.717 327.596,207.461 339.93,207.461  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.76,187.977 394.839,220.017 405.48,226.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.507,272.695 479.551,246.775 441.277,262.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "500.807,333.766 460.063,327.599 460.063,339.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.839,447.513 420.76,479.55 405.48,441.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.766,500.81 339.93,460.07 327.596,460.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.781,479.55 272.691,447.513 262.05,441.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.016,394.836 187.979,420.752 226.245,405.482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.462,327.599 166.719,333.766 207.462,339.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.245,262.053 187.979,246.775 220.016,272.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.691,220.017 246.781,187.977 262.05,226.252  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M517.212,419.305c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.924l-53.784-23.926l-0.224,0.81c-2.963-0.786-6.055-1.255-9.266-1.255 c-0.217,0-0.426,0.023-0.643,0.027c2.119-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.007-110.01-110.007 c-58.598,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.067-7.807,16.085c-2.426-0.696-4.981-1.089-7.625-1.089 c-15.254,0-27.624,12.366-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.292l55.479-6.581h14.526 c17.062,38.649,55.699,65.63,100.66,65.63c21.668,0,41.85-6.285,58.875-17.098h21.726l46.806,34.508l-25.424-34.508h80.404 C516.832,424.329,517.212,421.862,517.212,419.305z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.51,161.884 359.572,215.669 376.567,220.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.036,252.526 459.956,205.139 412.576,240.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.757,288.527 449.433,305.523 503.217,281.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.572,449.429 383.51,503.213 376.567,444.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.586,503.213 305.521,449.429 288.531,444.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.067,412.568 205.144,459.962 252.526,425.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.341,288.527 161.886,281.592 215.667,305.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.526,240.069 205.144,205.139 240.067,252.526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.521,215.669 281.586,161.884 288.531,220.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.55,165.501 326.38,206.245 338.715,206.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.545,186.761 393.623,218.802 404.266,225.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.291,271.48 478.335,245.561 440.062,260.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "499.591,332.55 458.848,326.384 458.848,338.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.623,446.297 419.545,478.336 404.266,440.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.55,499.595 338.715,458.854 326.38,458.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.565,478.336 271.477,446.297 260.836,440.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.8,393.621 186.764,419.536 225.03,404.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.247,326.384 165.504,332.55 206.247,338.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.03,260.837 186.764,245.561 218.8,271.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.477,218.802 245.565,186.761 260.836,225.037  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M515.997,418.089c0-14.139-11.095-25.656-25.046-26.4c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.784-23.926l-0.224,0.81c-2.963-0.786-6.055-1.255-9.267-1.255 c-0.216,0-0.425,0.023-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.087c-2.426-0.697-4.981-1.091-7.625-1.091 c-15.254,0-27.624,12.368-27.624,27.617c0,2.239,0.339,4.388,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.669,0,41.851-6.285,58.876-17.098h21.725l46.806,34.507l-25.423-34.507h80.404 C515.617,423.113,515.997,420.647,515.997,418.089z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.295,160.668 358.357,214.454 375.353,219.131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.821,251.311 458.741,203.924 411.361,238.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.542,287.313 448.218,304.308 502.002,280.377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.357,448.213 382.295,501.998 375.353,443.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.371,501.998 304.306,448.213 287.316,443.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.852,411.353 203.929,458.748 251.312,423.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.126,287.313 160.671,280.377 214.452,304.308  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.312,238.854 203.929,203.924 238.852,251.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.306,214.454 280.371,160.668 287.316,219.131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.335,164.286 325.165,205.03 337.5,205.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.33,185.546 392.408,217.587 403.051,223.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "445.076,270.266 477.12,244.345 438.847,259.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "498.375,331.335 457.633,325.168 457.633,337.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.408,445.082 418.33,477.12 403.051,438.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.335,498.38 337.5,457.64 325.165,457.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.351,477.12 270.262,445.082 259.62,438.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.585,392.405 185.549,418.321 223.815,403.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.032,325.168 164.289,331.335 205.032,337.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.815,259.622 185.549,244.345 217.585,270.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.262,217.587 244.351,185.546 259.62,223.822  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M514.782,416.874c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C514.401,421.898,514.782,419.433,514.782,416.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.08,159.453 357.143,213.238 374.137,217.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.606,250.096 457.526,202.709 410.146,237.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.327,286.098 447.002,303.093 500.787,279.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.143,446.998 381.08,500.782 374.137,442.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.156,500.782 303.091,446.998 286.102,442.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.637,410.138 202.713,457.532 250.096,422.601  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.911,286.098 159.456,279.162 213.237,303.093  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.096,237.64 202.713,202.709 237.637,250.096  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.091,213.238 279.156,159.453 286.102,217.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.12,163.071 323.95,203.815 336.285,203.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.114,184.331 391.193,216.372 401.836,222.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.861,269.051 475.905,243.131 437.632,258.406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "497.16,330.12 456.417,323.953 456.417,336.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.193,443.867 417.114,475.905 401.836,437.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.12,497.164 336.285,456.425 323.95,456.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.136,475.905 269.047,443.867 258.405,437.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.37,391.19 184.334,417.106 222.6,401.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.817,323.953 163.074,330.12 203.817,336.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.6,258.406 184.334,243.131 216.37,269.051  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.047,216.372 243.136,184.331 258.405,222.606  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M513.566,415.659c0-14.139-11.094-25.657-25.045-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.785-23.927l-0.223,0.81c-2.963-0.785-6.056-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.256-110.007-110.011-110.007 c-58.598,0-106.479,45.813-109.808,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.237,0.339,4.387,0.842,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.647,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C513.187,420.684,513.566,418.218,513.566,415.659z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.865,158.238 355.928,212.023 372.922,216.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.391,248.88 456.311,201.493 408.932,236.424  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.111,284.883 445.787,301.878 499.571,277.947  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.928,445.783 379.865,499.567 372.922,441.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.94,499.567 301.876,445.783 284.887,441.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.422,408.922 201.498,456.317 248.881,421.386  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.695,284.883 158.241,277.947 212.021,301.878  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.881,236.424 201.498,201.493 236.422,248.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.876,212.023 277.94,158.238 284.887,216.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.904,161.856 322.734,202.6 335.07,202.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.9,183.116 389.979,215.157 400.621,221.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.646,267.836 474.69,241.915 436.417,257.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "495.945,328.904 455.202,322.738 455.202,335.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.979,442.652 415.9,474.689 400.621,436.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.904,495.949 335.07,455.21 322.734,455.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.921,474.689 267.831,442.652 257.189,436.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.155,389.976 183.119,415.892 221.384,400.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "202.602,322.738 161.859,328.904 202.602,335.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.384,257.191 183.119,241.915 215.155,267.836  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.831,215.157 241.921,183.116 257.189,221.392  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M512.352,414.443c0-14.139-11.094-25.656-25.045-26.4c0.012-0.196,0.059-0.392,0.059-0.597 c0-3.734-1.551-7.098-4.028-9.512l16.234,1.925l-53.784-23.928l-0.223,0.811c-2.963-0.785-6.056-1.254-9.268-1.254 c-0.217,0-0.424,0.021-0.642,0.026c2.12-8.524,3.261-17.433,3.261-26.61c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.506,10.067-7.806,16.085c-2.427-0.696-4.982-1.089-7.626-1.089 c-15.254,0-27.624,12.366-27.624,27.616c0,2.239,0.34,4.387,0.843,6.473l-18.644,8.293l55.478-6.582h14.525 c17.063,38.648,55.7,65.63,100.66,65.63c21.67,0,41.852-6.285,58.876-17.097h21.726l46.805,34.507l-25.422-34.507h80.404 C511.972,419.469,512.352,417.002,512.352,414.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.649,157.023 354.712,210.808 371.707,215.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.176,247.666 455.096,200.278 407.716,235.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.896,283.668 444.572,300.663 498.356,276.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.712,444.568 378.649,498.353 371.707,439.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.726,498.353 300.661,444.568 283.672,439.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.207,407.707 200.283,455.103 247.666,420.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.48,283.668 157.025,276.732 210.807,300.663  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.666,235.209 200.283,200.278 235.207,247.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.661,210.808 276.726,157.023 283.672,215.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.689,160.641 321.52,201.385 333.854,201.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.685,181.901 388.764,213.941 399.405,220.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.431,266.62 473.475,240.7 435.201,255.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "494.73,327.689 453.987,321.523 453.987,333.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.764,441.438 414.685,473.475 399.405,435.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.689,494.734 333.854,453.994 321.52,453.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.705,473.475 266.616,441.438 255.975,435.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.94,388.76 181.903,414.676 220.17,399.406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.387,321.523 160.644,327.689 201.387,333.854  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.17,255.977 181.903,240.7 213.94,266.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.616,213.941 240.705,181.901 255.975,220.177  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M511.137,413.229c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.551-7.099-4.028-9.513l16.234,1.926l-53.784-23.928l-0.224,0.81c-2.963-0.785-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.293l55.479-6.582h14.526 c17.062,38.648,55.699,65.63,100.66,65.63c21.669,0,41.851-6.286,58.876-17.098h21.726l46.805,34.508l-25.423-34.508h80.404 C510.756,418.254,511.137,415.787,511.137,413.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.435,155.808 353.497,209.593 370.492,214.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.961,246.45 453.881,199.063 406.501,233.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.682,282.452 443.357,299.447 497.142,275.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.497,443.354 377.435,497.137 370.492,438.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.51,497.137 299.445,443.354 282.456,438.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.992,406.492 199.068,453.887 246.451,418.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.266,282.452 155.811,275.517 209.592,299.447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.451,233.994 199.068,199.063 233.992,246.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.445,209.593 275.51,155.808 282.456,214.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.475,159.426 320.305,200.17 332.64,200.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.47,180.686 387.549,212.727 398.19,218.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.216,265.405 472.26,239.485 433.986,254.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "493.516,326.475 452.772,320.309 452.772,332.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.549,440.223 413.47,472.26 398.19,433.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.475,493.52 332.64,452.779 320.305,452.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.49,472.26 265.401,440.223 254.76,433.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.725,387.545 180.688,413.461 218.954,398.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.172,320.309 159.429,326.475 200.172,332.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.954,254.761 180.688,239.485 212.725,265.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.401,212.727 239.49,180.686 254.76,218.961  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M509.922,412.014c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.432,3.261-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.479-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C509.541,417.039,509.922,414.572,509.922,412.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.22,154.593 352.281,208.378 369.277,213.056  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.746,245.235 452.666,197.848 405.286,232.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.467,281.237 442.143,298.232 495.927,274.302  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.281,442.138 376.22,495.922 369.277,437.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.295,495.922 298.23,442.138 281.241,437.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.776,405.277 197.853,452.672 245.236,417.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.051,281.237 154.596,274.302 208.376,298.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.236,232.779 197.853,197.848 232.776,245.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.23,208.378 274.295,154.593 281.241,213.056  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.26,158.211 319.09,198.955 331.425,198.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.254,179.471 386.333,211.512 396.975,217.747  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "439.001,264.189 471.045,238.271 432.771,253.546  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "492.301,325.26 451.557,319.094 451.557,331.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.333,439.007 412.254,471.045 396.975,432.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.26,492.305 331.425,451.564 319.09,451.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.275,471.045 264.186,439.007 253.544,432.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.51,386.33 179.474,412.246 217.739,396.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.957,319.094 158.214,325.26 198.957,331.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.739,253.546 179.474,238.271 211.51,264.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.186,211.512 238.275,179.471 253.544,217.747  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M508.707,410.799c0-14.139-11.095-25.657-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.808,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.478-6.581H224.6 c17.062,38.648,55.699,65.629,100.66,65.629c21.668,0,41.85-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.403 C508.326,415.823,508.707,413.357,508.707,410.799z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.004,153.378 351.066,207.163 368.063,211.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.53,244.02 451.45,196.633 404.071,231.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.252,280.021 440.928,297.018 494.711,273.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.066,440.923 375.004,494.707 368.063,436.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.08,494.707 297.016,440.923 280.026,436.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.562,404.062 196.638,451.457 244.021,416.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.835,280.021 153.381,273.087 207.161,297.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.021,231.563 196.638,196.633 231.562,244.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.016,207.163 273.08,153.378 280.026,211.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.045,156.996 317.875,197.74 330.209,197.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.04,178.256 385.118,210.296 395.76,216.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.786,262.975 469.83,237.055 431.557,252.331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "491.085,324.045 450.342,317.878 450.342,330.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.118,437.792 411.04,469.83 395.76,431.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.045,491.09 330.209,450.35 317.875,450.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.061,469.83 262.971,437.792 252.329,431.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.294,385.115 178.259,411.031 216.524,395.762  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.742,317.878 156.999,324.045 197.742,330.209  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.524,252.331 178.259,237.055 210.294,262.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.971,210.296 237.061,178.256 252.329,216.531  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M507.492,409.584c0-14.139-11.095-25.658-25.047-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.553-7.098-4.029-9.512l16.234,1.925l-53.783-23.927l-0.224,0.81c-2.963-0.785-6.056-1.254-9.267-1.254 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.007-110.011-110.007 c-58.598,0-106.479,45.813-109.808,103.583c-3.767,4.599-6.505,10.068-7.807,16.085c-2.426-0.696-4.98-1.089-7.625-1.089 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.062,38.647,55.7,65.629,100.661,65.629c21.668,0,41.851-6.285,58.875-17.098h21.726l46.805,34.508l-25.423-34.508h80.405 C507.111,414.608,507.492,412.143,507.492,409.584z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.789,152.163 349.852,205.948 366.847,210.626  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.316,242.806 450.235,195.418 402.855,230.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.037,278.807 439.713,295.803 493.496,271.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.852,439.707 373.789,493.492 366.847,435.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.865,493.492 295.8,439.707 278.811,435.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.346,402.848 195.423,450.242 242.806,415.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.62,278.807 152.166,271.871 205.946,295.803  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.806,230.349 195.423,195.418 230.346,242.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.8,205.948 271.865,152.163 278.811,210.626  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.829,155.781 316.659,196.525 328.994,196.525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.824,177.041 383.903,209.082 394.545,215.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.57,261.76 468.615,235.84 430.342,251.116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "489.87,322.829 449.127,316.663 449.127,328.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.903,436.576 409.824,468.614 394.545,430.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.829,489.874 328.994,449.134 316.659,449.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.845,468.614 261.756,436.576 251.114,430.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.08,383.9 177.043,409.815 215.31,394.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.526,316.663 155.784,322.829 196.526,328.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.31,251.116 177.043,235.84 209.08,261.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.756,209.082 235.845,177.041 251.114,215.316  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M506.276,408.368c0-14.138-11.094-25.657-25.046-26.4c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.783-23.927l-0.225,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.023-0.642,0.027c2.119-8.524,3.26-17.433,3.26-26.61c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.601-6.505,10.068-7.807,16.087c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.471l-18.644,8.293l55.478-6.58h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C505.896,413.394,506.276,410.927,506.276,408.368z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.574,150.948 348.637,204.733 365.632,209.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.101,241.59 449.021,194.203 401.641,229.134  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.822,277.592 438.497,294.588 492.281,270.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.637,438.492 372.574,492.277 365.632,433.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.65,492.277 294.586,438.492 277.596,433.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.131,401.632 194.208,449.027 241.591,414.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.405,277.592 150.95,270.656 204.731,294.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.591,229.134 194.208,194.203 229.131,241.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.586,204.733 270.65,150.948 277.596,209.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.614,154.566 315.444,195.31 327.779,195.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.609,175.826 382.688,207.866 393.33,214.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.355,260.545 467.399,234.625 429.127,249.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "488.655,321.614 447.912,315.448 447.912,327.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.688,435.361 408.609,467.399 393.33,429.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.614,488.659 327.779,447.919 315.444,447.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.63,467.399 260.541,435.361 249.899,429.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.864,382.686 175.828,408.601 214.094,393.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.312,315.448 154.568,321.614 195.312,327.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.094,249.901 175.828,234.625 207.864,260.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.541,207.866 234.63,175.826 249.899,214.102  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M505.062,407.153c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.553-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.726l46.806,34.508l-25.423-34.508h80.404 C504.682,412.178,505.062,409.712,505.062,407.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.359,149.733 347.422,203.518 364.417,208.195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.886,240.375 447.806,192.988 400.426,227.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.606,276.377 437.282,293.372 491.066,269.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.422,437.277 371.359,491.063 364.417,432.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.436,491.063 293.37,437.277 276.381,432.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.916,400.417 192.992,447.812 240.376,412.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.19,276.377 149.735,269.441 203.517,293.372  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.376,227.919 192.992,192.988 227.916,240.375  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.37,203.518 269.436,149.733 276.381,208.195  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.399,153.351 314.229,194.095 326.564,194.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.395,174.61 381.473,206.651 392.115,212.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "434.141,259.33 466.185,233.409 427.911,248.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "487.44,320.399 446.697,314.232 446.697,326.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.473,434.146 407.395,466.185 392.115,427.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.399,487.443 326.564,446.704 314.229,446.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.415,466.185 259.326,434.146 248.684,427.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.649,381.47 174.613,407.386 212.879,392.116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.097,314.232 153.354,320.399 194.097,326.564  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.879,248.686 174.613,233.409 206.649,259.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.326,206.651 233.415,174.61 248.684,212.886  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M503.847,405.938c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.099-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.021-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.807,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097H401l46.806,34.507l-25.423-34.507h80.404 C503.466,410.963,503.847,408.497,503.847,405.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.145,148.518 346.207,202.303 363.201,206.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.67,239.16 446.59,191.772 399.211,226.703  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.392,275.162 436.066,292.157 489.852,268.227  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.207,436.063 370.145,489.847 363.201,431.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.22,489.847 292.154,436.063 275.166,431.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.701,399.202 191.777,446.597 239.16,411.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.975,275.162 148.52,268.227 202.301,292.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.16,226.703 191.777,191.772 226.701,239.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.154,202.303 268.22,148.518 275.166,206.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.185,152.136 313.015,192.879 325.35,192.879  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.179,173.396 380.258,205.436 390.9,211.671  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.926,258.114 464.97,232.194 426.696,247.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "486.226,319.185 445.482,313.018 445.482,325.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.258,432.932 406.179,464.969 390.9,426.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.185,486.229 325.35,445.489 313.015,445.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.2,464.969 258.111,432.932 247.469,426.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.434,380.255 173.398,406.171 211.664,390.901  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.881,313.018 152.138,319.185 192.881,325.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.664,247.471 173.398,232.194 205.434,258.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.111,205.436 232.2,173.396 247.469,211.671  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M502.631,404.723c0-14.138-11.094-25.656-25.045-26.4c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.733-1.552-7.099-4.028-9.512l16.234,1.925l-53.785-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.424,0.021-0.641,0.025c2.119-8.523,3.26-17.432,3.26-26.608c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.767,4.6-6.505,10.069-7.807,16.087c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.366-27.624,27.616c0,2.239,0.339,4.387,0.842,6.473l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.698,65.629,100.66,65.629c21.669,0,41.851-6.286,58.875-17.097h21.726l46.805,34.507l-25.422-34.507h80.404 C502.251,409.748,502.631,407.282,502.631,404.723z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.929,147.302 344.991,201.088 361.986,205.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.455,237.944 445.375,190.558 397.996,225.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.176,273.947 434.852,290.942 488.636,267.012  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.991,434.848 368.929,488.632 361.986,430.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.005,488.632 290.939,434.848 273.951,430.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.486,397.986 190.563,445.382 237.945,410.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.76,273.947 147.305,267.012 201.086,290.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.945,225.488 190.563,190.558 225.486,237.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.939,201.088 267.005,147.302 273.951,205.766  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.969,150.921 311.799,191.664 324.135,191.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.965,172.181 379.043,204.221 389.685,210.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.711,256.899 463.755,230.979 425.48,246.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "485.01,317.969 444.267,311.803 444.267,324.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.043,431.717 404.965,463.754 389.685,425.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.969,485.014 324.135,444.273 311.799,444.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.985,463.754 256.896,431.717 246.254,425.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.219,379.04 172.183,404.955 210.449,389.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "191.666,311.803 150.923,317.969 191.666,324.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.449,246.256 172.183,230.979 204.219,256.899  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.896,204.221 230.985,172.181 246.254,210.456  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M501.416,403.508c0-14.139-11.094-25.656-25.045-26.4c0.012-0.197,0.06-0.392,0.06-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.234,1.926l-53.784-23.928l-0.223,0.811c-2.963-0.785-6.056-1.254-9.268-1.254 c-0.216,0-0.425,0.021-0.641,0.025c2.118-8.523,3.26-17.432,3.26-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.388,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.669,0,41.852-6.286,58.875-17.097h21.727l46.805,34.507l-25.423-34.507h80.405 C501.036,408.533,501.416,406.066,501.416,403.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.714,146.087 343.776,199.872 360.771,204.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.24,236.729 444.16,189.342 396.78,224.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.961,272.731 433.637,289.727 487.421,265.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.776,433.632 367.714,487.417 360.771,428.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.789,487.417 289.725,433.632 272.736,428.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.271,396.771 189.347,444.166 236.73,409.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.545,272.731 146.09,265.796 199.871,289.727  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.73,224.273 189.347,189.342 224.271,236.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.725,199.872 265.789,146.087 272.736,204.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.754,149.706 310.584,190.449 322.919,190.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.749,170.965 377.827,203.006 388.47,209.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.496,255.685 462.539,229.765 424.266,245.041  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "483.795,316.754 443.052,310.588 443.052,322.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.827,430.502 403.749,462.539 388.47,424.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.754,483.799 322.919,443.059 310.584,443.059  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.77,462.539 255.681,430.502 245.039,424.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.004,377.824 170.968,403.74 209.233,388.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "190.451,310.588 149.708,316.754 190.451,322.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.233,245.041 170.968,229.765 203.004,255.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.681,203.006 229.77,170.965 245.039,209.241  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M500.201,402.293c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.551-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.598,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.292l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.727l46.805,34.507l-25.423-34.507h80.404 C499.82,407.317,500.201,404.852,500.201,402.293z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.499,144.872 342.562,198.657 359.557,203.335  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.025,235.515 442.945,188.127 395.565,223.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.746,271.517 432.422,288.512 486.206,264.581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.562,432.417 366.499,486.201 359.557,427.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.574,486.201 288.51,432.417 271.521,427.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.056,395.557 188.132,442.951 235.515,408.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.33,271.517 144.875,264.581 198.656,288.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.515,223.058 188.132,188.127 223.056,235.515  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.51,198.657 264.574,144.872 271.521,203.335  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.539,148.491 309.369,189.234 321.704,189.234  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.534,169.75 376.613,201.791 387.255,208.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.28,254.469 461.324,228.549 423.051,243.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "482.58,315.539 441.837,309.373 441.837,321.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.613,429.286 402.534,461.324 387.255,423.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.539,482.584 321.704,441.844 309.369,441.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.555,461.324 254.465,429.286 243.824,423.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.789,376.609 169.753,402.525 208.019,387.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.236,309.373 148.493,315.539 189.236,321.704  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.019,243.826 169.753,228.549 201.789,254.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.465,201.791 228.555,169.75 243.824,208.025  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M498.986,401.078c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C498.605,406.103,498.986,403.637,498.986,401.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.283,143.657 341.347,197.442 358.342,202.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.811,234.3 441.73,186.913 394.351,221.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.531,270.301 431.207,287.297 484.99,263.366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.347,431.202 365.283,484.986 358.342,426.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.359,484.986 287.295,431.202 270.306,426.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.841,394.342 186.917,441.736 234.3,406.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "202.114,270.301 143.66,263.366 197.441,287.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.3,221.843 186.917,186.913 221.841,234.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.295,197.442 263.359,143.657 270.306,202.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.324,147.275 308.154,188.02 320.489,188.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.318,168.535 375.397,200.576 386.04,206.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "428.065,253.254 460.109,227.334 421.836,242.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "481.365,314.324 440.621,308.157 440.621,320.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.397,428.071 401.318,460.109 386.04,421.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.324,481.368 320.489,440.628 308.154,440.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.339,460.109 253.25,428.071 242.609,421.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.574,375.395 168.538,401.311 206.804,386.041  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.021,308.157 147.278,314.324 188.021,320.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.804,242.61 168.538,227.334 200.574,253.254  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.25,200.576 227.339,168.535 242.609,206.811  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M497.771,399.863c0-14.139-11.095-25.657-25.047-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.734-1.552-7.098-4.029-9.512l16.234,1.925l-53.783-23.927l-0.225,0.809c-2.962-0.784-6.054-1.253-9.266-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.011-110.006 c-58.598,0-106.479,45.813-109.808,103.583c-3.766,4.6-6.505,10.068-7.806,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.669,0,41.85-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C497.391,404.888,497.771,402.422,497.771,399.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.068,142.442 340.132,196.227 357.127,200.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.596,233.084 440.515,185.697 393.136,220.628  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.316,269.087 429.992,286.082 483.775,262.151  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.132,429.987 364.068,483.771 357.127,425.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.145,483.771 286.079,429.987 269.091,425.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.625,393.127 185.702,440.521 233.085,405.589  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.899,269.087 142.445,262.151 196.226,286.082  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.085,220.628 185.702,185.697 220.625,233.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.079,196.227 262.145,142.442 269.091,200.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.109,146.061 306.939,186.804 319.274,186.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.104,167.32 374.183,199.36 384.825,205.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.851,252.039 458.895,226.119 420.621,241.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "480.15,313.109 439.406,306.942 439.406,319.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.183,426.855 400.104,458.894 384.825,420.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.109,480.153 319.274,439.413 306.939,439.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.125,458.894 252.035,426.855 241.394,420.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.358,374.18 167.323,400.095 205.588,384.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.806,306.942 146.063,313.109 186.806,319.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.588,241.396 167.323,226.119 199.358,252.039  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.035,199.36 226.125,167.32 241.394,205.596  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M496.557,398.647c0-14.139-11.095-25.657-25.047-26.4c0.012-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.028-9.513l16.233,1.926l-53.783-23.927l-0.225,0.809c-2.962-0.784-6.055-1.253-9.266-1.253 c-0.217,0-0.426,0.022-0.642,0.025c2.118-8.523,3.26-17.433,3.26-26.608c0-60.762-49.256-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.767,4.6-6.506,10.069-7.807,16.087c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.366-27.623,27.616c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.293l55.478-6.582h14.526 c17.063,38.648,55.7,65.63,100.661,65.63c21.668,0,41.851-6.286,58.875-17.098h21.726l46.805,34.508l-25.423-34.508h80.404 C496.176,403.672,496.557,401.206,496.557,398.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.854,141.227 338.916,195.012 355.911,199.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.38,231.869 439.3,184.482 391.92,219.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.102,267.871 428.777,284.867 482.561,260.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.916,428.771 362.854,482.557 355.911,424.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.93,482.557 284.864,428.771 267.875,424.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.41,391.911 184.487,439.307 231.87,404.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.685,267.871 141.23,260.937 195.011,284.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.87,219.413 184.487,184.482 219.41,231.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.864,195.012 260.93,141.227 267.875,199.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.894,144.845 305.724,185.589 318.06,185.589  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.889,166.105 372.967,198.146 383.609,204.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.635,250.824 457.68,224.904 419.406,240.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "478.935,311.894 438.191,305.728 438.191,318.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.967,425.641 398.889,457.679 383.609,419.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.894,478.938 318.06,438.198 305.724,438.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.909,457.679 250.82,425.641 240.179,419.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.144,372.964 166.107,398.88 204.373,383.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "185.591,305.728 144.848,311.894 185.591,318.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.373,240.181 166.107,224.904 198.144,250.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.82,198.146 224.909,166.105 240.179,204.38  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M495.341,397.433c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.061-0.392,0.061-0.597 c0-3.734-1.553-7.099-4.029-9.513l16.234,1.925l-53.783-23.927l-0.225,0.81c-2.963-0.785-6.055-1.254-9.266-1.254 c-0.218,0-0.426,0.022-0.643,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.876-17.097h21.725l46.806,34.508l-25.423-34.508h80.404 C494.96,402.457,495.341,399.991,495.341,397.433z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.639,140.012 337.701,193.797 354.696,198.475  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.165,230.654 438.085,183.267 390.705,218.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "422.887,266.656 427.562,283.652 481.346,259.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.701,427.557 361.639,481.341 354.696,422.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.715,481.341 283.649,427.557 266.66,422.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.195,390.696 183.272,438.091 230.655,403.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.47,266.656 140.015,259.721 193.796,283.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.655,218.198 183.272,183.267 218.195,230.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.649,193.797 259.715,140.012 266.66,198.475  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.679,143.63 304.509,184.374 316.844,184.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.674,164.89 371.752,196.931 382.395,203.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.42,249.609 456.464,223.689 418.19,238.965  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "477.72,310.679 436.977,304.513 436.977,316.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.752,424.426 397.674,456.464 382.395,418.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.679,477.724 316.844,436.983 304.509,436.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.694,456.464 249.605,424.426 238.963,418.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.929,371.749 164.893,397.665 203.159,382.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.376,304.513 143.633,310.679 184.376,316.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.159,238.965 164.893,223.689 196.929,249.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.605,196.931 223.694,164.89 238.963,203.166  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M494.126,396.218c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C493.745,401.242,494.126,398.776,494.126,396.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.424,138.797 336.486,192.582 353.481,197.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.95,229.439 436.87,182.052 389.49,216.982  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.671,265.441 426.347,282.437 480.131,258.506  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.486,426.342 360.424,480.126 353.481,421.671  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.5,480.126 282.435,426.342 265.445,421.671  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.98,389.481 182.057,436.876 229.44,401.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.254,265.441 138.799,258.506 192.58,282.437  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.44,216.982 182.057,182.052 216.98,229.439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.435,192.582 258.5,138.797 265.445,197.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.463,142.415 303.293,183.159 315.629,183.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.459,163.675 370.537,195.716 381.18,201.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.205,248.394 455.249,222.474 416.976,237.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "476.505,309.463 435.762,303.297 435.762,315.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.537,423.211 396.459,455.249 381.18,416.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.463,476.509 315.629,435.768 303.293,435.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.479,455.249 248.39,423.211 237.748,416.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.714,370.534 163.677,396.45 201.943,381.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.161,303.297 142.417,309.463 183.161,315.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.943,237.75 163.677,222.474 195.714,248.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.39,195.716 222.479,163.675 237.748,201.95  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M492.911,395.002c0-14.138-11.095-25.656-25.046-26.4c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.733-1.552-7.099-4.028-9.512l16.234,1.925l-53.784-23.928l-0.224,0.811c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.524,3.26-17.433,3.26-26.61c0-60.76-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.601-6.505,10.068-7.807,16.087c-2.426-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.237,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.647,55.7,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C492.53,400.027,492.911,397.561,492.911,395.002z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.209,137.582 335.271,191.367 352.266,196.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.735,228.224 435.654,180.837 388.275,215.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.456,264.227 425.132,281.222 478.916,257.291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.271,425.127 359.209,478.911 352.266,420.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.284,478.911 281.219,425.127 264.23,420.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.765,388.266 180.842,435.661 228.225,400.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.039,264.227 137.584,257.291 191.365,281.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.225,215.768 180.842,180.837 215.765,228.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.219,191.367 257.284,137.582 264.23,196.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.248,141.2 302.078,181.944 314.414,181.944  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.243,162.46 369.322,194.5 379.965,200.735  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "421.99,247.179 454.034,221.259 415.761,236.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "475.29,308.248 434.547,302.082 434.547,314.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.322,421.996 395.243,454.033 379.965,415.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.248,475.293 314.414,434.553 302.078,434.553  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.264,454.033 247.175,421.996 236.533,415.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.499,369.318 162.462,395.235 200.728,379.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.946,302.082 141.203,308.248 181.946,314.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.728,236.535 162.462,221.259 194.499,247.179  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.175,194.5 221.264,162.46 236.533,200.735  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M491.696,393.787c0-14.139-11.095-25.657-25.046-26.399c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.926l-53.784-23.927l-0.224,0.809c-2.963-0.784-6.056-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.027c2.118-8.524,3.26-17.433,3.26-26.61c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.599-6.505,10.067-7.807,16.085c-2.426-0.696-4.981-1.09-7.626-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.473l-18.645,8.293l55.479-6.582h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.67,0,41.852-6.285,58.876-17.097h21.726l46.805,34.507l-25.422-34.507h80.404 C491.315,398.812,491.696,396.346,491.696,393.787z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.994,136.367 334.056,190.152 351.052,194.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.52,227.009 434.439,179.622 387.061,214.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.241,263.011 423.917,280.007 477.7,256.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.056,423.911 357.994,477.696 351.052,419.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.069,477.696 280.004,423.911 263.015,419.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.55,387.051 179.627,434.445 227.01,399.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.824,263.011 136.369,256.076 190.15,280.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.01,214.552 179.627,179.622 214.55,227.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.004,190.152 256.069,136.367 263.015,194.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.033,139.985 300.863,180.729 313.199,180.729  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.029,161.245 368.106,193.285 378.749,199.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "420.775,245.964 452.819,220.043 414.546,235.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "474.074,307.033 433.331,300.867 433.331,313.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.106,420.78 394.029,452.818 378.749,414.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.033,474.078 313.199,433.338 300.863,433.338  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.049,452.818 245.96,420.78 235.318,414.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "193.283,368.104 161.247,394.02 199.513,378.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "180.73,300.867 139.987,307.033 180.73,313.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.513,235.32 161.247,220.043 193.283,245.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.96,193.285 220.049,161.245 235.318,199.52  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M490.48,392.572c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.551-7.098-4.028-9.512l16.234,1.925l-53.783-23.927l-0.225,0.81c-2.962-0.784-6.055-1.254-9.267-1.254 c-0.216,0-0.424,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.254-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.425-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.526 c17.062,38.648,55.699,65.63,100.66,65.63c21.669,0,41.851-6.286,58.875-17.098h21.727l46.805,34.507l-25.422-34.507h80.403 C490.101,397.597,490.48,395.131,490.48,392.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.778,135.151 332.841,188.937 349.836,193.614  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.305,225.794 433.225,178.407 385.845,213.337  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.025,261.796 422.701,278.791 476.485,254.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.841,422.696 356.778,476.48 349.836,418.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.854,476.48 278.789,422.696 261.8,418.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.335,385.836 178.412,433.23 225.794,398.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "193.609,261.796 135.154,254.861 188.935,278.791  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.794,213.337 178.412,178.407 213.335,225.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "278.789,188.937 254.854,135.151 261.8,193.614  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.818,138.77 299.648,179.514 311.983,179.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.813,160.029 366.892,192.07 377.534,198.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "419.561,244.748 451.604,218.829 413.33,234.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "472.859,305.818 432.116,299.652 432.116,311.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.892,419.565 392.813,451.604 377.534,413.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "305.818,472.863 311.983,432.123 299.648,432.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.834,451.604 244.745,419.565 234.103,413.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.068,366.889 160.032,392.805 198.298,377.535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.516,299.652 138.772,305.818 179.516,311.983  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.298,234.105 160.032,218.829 192.068,244.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.745,192.07 218.834,160.029 234.103,198.305  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M489.266,391.357c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C488.885,396.382,489.266,393.916,489.266,391.357z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.563,133.937 331.626,187.722 348.621,192.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.09,224.579 432.01,177.191 384.63,212.122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "416.811,260.581 421.486,277.576 475.271,253.646  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.626,421.481 355.563,475.266 348.621,416.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.639,475.266 277.574,421.481 260.585,416.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.12,384.621 177.197,432.016 224.579,397.084  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.394,260.581 133.939,253.646 187.72,277.576  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.579,212.122 177.197,177.191 212.12,224.579  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.574,187.722 253.639,133.937 260.585,192.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.604,137.555 298.434,178.299 310.769,178.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.599,158.814 365.677,190.855 376.319,197.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "418.345,243.533 450.389,217.613 412.115,232.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "471.645,304.604 430.901,298.437 430.901,310.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.677,418.351 391.599,450.389 376.319,412.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.604,471.647 310.769,430.908 298.434,430.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.619,450.389 243.53,418.351 232.888,412.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "190.854,365.674 158.817,391.59 197.083,376.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.301,298.437 137.557,304.604 178.301,310.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.083,232.89 158.817,217.613 190.854,243.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.53,190.855 217.619,158.814 232.888,197.09  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M488.051,390.143c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.785-6.055-1.255-9.267-1.255 c-0.217,0-0.425,0.023-0.642,0.027c2.119-8.524,3.26-17.433,3.26-26.609c0-60.761-49.255-110.007-110.011-110.007 c-58.598,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.698,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C487.67,395.167,488.051,392.701,488.051,390.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.349,132.722 330.411,186.506 347.406,191.184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.875,223.363 430.795,175.977 383.415,210.907  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.596,259.366 420.271,276.361 474.055,252.431  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.411,420.267 354.349,474.051 347.406,415.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.424,474.051 276.359,420.267 259.369,415.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.905,383.405 175.981,430.801 223.364,395.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "191.179,259.366 132.724,252.431 186.505,276.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.364,210.907 175.981,175.977 210.905,223.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.359,186.506 252.424,132.722 259.369,191.184  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.388,136.34 297.218,177.083 309.554,177.083  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.383,157.6 364.461,189.64 375.104,195.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "417.13,242.318 449.174,216.398 410.9,231.675  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "470.43,303.388 429.686,297.222 429.686,309.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.461,417.136 390.383,449.173 375.104,410.898  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.388,470.433 309.554,429.692 297.218,429.692  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.404,449.173 242.314,417.136 231.673,410.898  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.638,364.459 157.602,390.374 195.868,375.105  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.085,297.222 136.342,303.388 177.085,309.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.868,231.675 157.602,216.398 189.638,242.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.314,189.64 216.404,157.6 231.673,195.875  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M486.836,388.927c0-14.138-11.095-25.657-25.047-26.4c0.013-0.196,0.061-0.392,0.061-0.597 c0-3.734-1.552-7.099-4.029-9.513l16.234,1.926l-53.783-23.928l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.023-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.599-6.505,10.067-7.807,16.086c-2.425-0.698-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.237,0.339,4.386,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.669,0,41.852-6.285,58.876-17.097h21.726l46.806,34.507l-25.424-34.507h80.405 C486.455,393.952,486.836,391.486,486.836,388.927z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.133,131.507 329.195,185.292 346.191,189.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.659,222.148 429.58,174.761 382.2,209.692  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.381,258.15 419.057,275.146 472.84,251.215  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.195,419.051 353.133,472.836 346.191,414.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "251.209,472.836 275.144,419.051 258.155,414.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.689,382.191 174.767,429.585 222.149,394.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.964,258.15 131.509,251.215 185.29,275.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.149,209.692 174.767,174.761 209.689,222.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.144,185.292 251.209,131.507 258.155,189.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.173,135.125 296.003,175.869 308.339,175.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.169,156.384 363.247,188.425 373.889,194.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "415.915,241.103 447.959,215.183 409.686,230.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "469.215,302.173 428.471,296.007 428.471,308.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.247,415.921 389.169,447.958 373.889,409.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.173,469.218 308.339,428.478 296.003,428.478  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.188,447.958 241.1,415.921 230.458,409.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.423,363.244 156.387,389.159 194.653,373.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.871,296.007 135.127,302.173 175.871,308.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.653,230.46 156.387,215.183 188.423,241.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.1,188.425 215.188,156.384 230.458,194.66  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M485.621,387.712c0-14.139-11.096-25.657-25.047-26.399c0.013-0.198,0.061-0.393,0.061-0.599 c0-3.733-1.552-7.098-4.028-9.512l16.233,1.925L419.057,329.2l-0.225,0.81c-2.963-0.784-6.055-1.254-9.266-1.254 c-0.217,0-0.426,0.022-0.643,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.254-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.239,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.284,58.876-17.097h21.725l46.807,34.507l-25.424-34.507h80.404 C485.24,392.736,485.621,390.271,485.621,387.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.918,130.292 327.98,184.076 344.976,188.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.444,220.933 428.364,173.546 380.984,208.477  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.166,256.936 417.841,273.931 471.625,250  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.98,417.836 351.918,471.62 344.976,413.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.994,471.62 273.929,417.836 256.939,413.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.475,380.976 173.551,428.37 220.935,393.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.749,256.936 130.294,250 184.075,273.931  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.935,208.477 173.551,173.546 208.475,220.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.929,184.076 249.994,130.292 256.939,188.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.958,133.91 294.788,174.653 307.123,174.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.953,155.169 362.031,187.21 372.674,193.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "414.7,239.888 446.743,213.968 408.47,229.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "467.999,300.958 427.256,294.792 427.256,307.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.031,414.705 387.953,446.743 372.674,408.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.958,468.003 307.123,427.263 294.788,427.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.974,446.743 239.885,414.705 229.243,408.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "187.208,362.028 155.172,387.944 193.438,372.675  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "174.655,294.792 133.912,300.958 174.655,307.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "193.438,229.245 155.172,213.968 187.208,239.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.885,187.21 213.974,155.169 229.243,193.444  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M484.405,386.497c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.785-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.011-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.479-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.876-17.097h21.726l46.805,34.507l-25.423-34.507h80.404 C484.024,391.521,484.405,389.056,484.405,386.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.703,129.076 326.766,182.861 343.761,187.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.229,219.718 427.149,172.331 379.77,207.262  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.951,255.721 416.626,272.716 470.41,248.785  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.766,416.621 350.703,470.405 343.761,411.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.779,470.405 272.714,416.621 255.725,411.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.26,379.761 172.336,427.155 219.719,392.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "187.533,255.721 129.079,248.785 182.859,272.716  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.719,207.262 172.336,172.331 207.26,219.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "272.714,182.861 248.779,129.076 255.725,187.539  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.743,132.694 293.573,173.438 305.908,173.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.738,153.954 360.816,185.995 371.459,192.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "413.484,238.673 445.528,212.753 407.255,228.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "466.784,299.743 426.041,293.576 426.041,305.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.816,413.49 386.738,445.528 371.459,407.254  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "299.743,466.788 305.908,426.048 293.573,426.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.758,445.528 238.669,413.49 228.027,407.254  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "185.993,360.813 153.957,386.729 192.223,371.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "173.44,293.576 132.697,299.743 173.44,305.908  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.223,228.03 153.957,212.753 185.993,238.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.669,185.995 212.758,153.954 228.027,192.229  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M483.19,385.281c0-14.138-11.095-25.657-25.046-26.399c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.011-110.006 c-58.598,0-106.48,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.697-4.981-1.091-7.625-1.091 c-15.253,0-27.623,12.368-27.623,27.618c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.582h14.526 c17.063,38.649,55.699,65.63,100.66,65.63c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C482.81,390.307,483.19,387.841,483.19,385.281z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.488,127.861 325.551,181.646 342.546,186.324  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.015,218.503 425.935,171.116 378.555,206.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "410.735,254.505 415.411,271.501 469.195,247.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.551,415.406 349.488,469.19 342.546,410.735  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.563,469.19 271.498,415.406 254.509,410.735  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.045,378.545 171.121,425.94 218.504,391.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.319,254.505 127.864,247.57 181.645,271.501  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.504,206.047 171.121,171.116 206.045,218.503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.498,181.646 247.563,127.861 254.509,186.324  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.528,131.479 292.357,172.223 304.693,172.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.523,152.739 359.602,184.78 370.244,191.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "412.27,237.458 444.313,211.538 406.04,226.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "465.569,298.528 424.826,292.361 424.826,304.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.602,412.275 385.523,444.313 370.244,406.039  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.528,465.572 304.693,424.832 292.357,424.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.543,444.313 237.454,412.275 226.813,406.039  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.778,359.599 152.742,385.515 191.007,370.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.225,292.361 131.482,298.528 172.225,304.693  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "191.007,226.814 152.742,211.538 184.778,237.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.454,184.78 211.543,152.739 226.813,191.014  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M481.976,384.067c0-14.14-11.095-25.658-25.046-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.099-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.608c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.697-4.981-1.089-7.625-1.089 c-15.254,0-27.624,12.366-27.624,27.617c0,2.238,0.339,4.386,0.843,6.472l-18.644,8.292l55.478-6.581h14.526 c17.063,38.648,55.699,65.63,100.661,65.63c21.669,0,41.851-6.286,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C481.595,389.092,481.976,386.625,481.976,384.067z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.273,126.646 324.336,180.431 341.33,185.109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.799,217.288 424.72,169.901 377.34,204.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.521,253.29 414.196,270.285 467.98,246.355  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.336,414.191 348.273,467.975 341.33,409.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "246.349,467.975 270.283,414.191 253.294,409.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.829,377.33 169.906,424.725 217.289,389.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "185.104,253.29 126.648,246.355 180.43,270.285  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.289,204.832 169.906,169.901 204.829,217.288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.283,180.431 246.349,126.646 253.294,185.109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.313,130.265 291.143,171.008 303.479,171.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.308,151.524 358.387,183.564 369.029,189.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "411.055,236.243 443.099,210.323 404.825,225.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "464.354,297.313 423.611,291.146 423.611,303.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.387,411.061 384.308,443.098 369.029,404.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.313,464.357 303.479,423.617 291.143,423.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.328,443.098 236.239,411.061 225.597,404.824  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.563,358.383 151.526,384.299 189.792,369.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "171.01,291.146 130.267,297.313 171.01,303.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.792,225.6 151.526,210.323 183.563,236.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.239,183.564 210.328,151.524 225.597,189.799  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M480.761,382.852c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.056-1.254-9.268-1.254 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.626-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.669,0,41.852-6.286,58.876-17.097h21.726l46.806,34.506l-25.423-34.506h80.404 C480.38,387.877,480.761,385.41,480.761,382.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.058,125.431 323.12,179.216 340.115,183.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.584,216.073 423.504,168.686 376.125,203.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.306,252.075 412.98,269.07 466.765,245.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.12,412.976 347.058,466.76 340.115,408.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.133,466.76 269.068,412.976 252.079,408.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.614,376.115 168.691,423.51 216.074,388.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.889,252.075 125.434,245.14 179.214,269.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.074,203.617 168.691,168.686 203.614,216.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.068,179.216 245.133,125.431 252.079,183.894  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.098,129.049 289.928,169.793 302.264,169.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.094,150.309 357.171,182.35 367.813,188.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "409.84,235.028 441.883,209.108 403.609,224.384  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "463.139,296.098 422.396,289.932 422.396,302.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.171,409.846 383.094,441.883 367.813,403.608  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.098,463.143 302.264,422.402 289.928,422.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.113,441.883 235.024,409.846 224.382,403.608  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.348,357.168 150.312,383.084 188.577,367.814  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "169.795,289.932 129.052,296.098 169.795,302.264  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.577,224.384 150.312,209.108 182.348,235.028  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.024,182.35 209.113,150.309 224.382,188.584  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M479.545,381.637c0-14.139-11.094-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.551-7.098-4.027-9.512l16.233,1.925l-53.784-23.927l-0.224,0.81c-2.962-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.506,10.068-7.808,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.876-17.097h21.726l46.805,34.507l-25.423-34.507h80.404 C479.165,386.661,479.545,384.195,479.545,381.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.843,124.216 321.905,178.001 338.9,182.679  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.369,214.857 422.289,167.471 374.909,202.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.09,250.86 411.766,267.855 465.55,243.925  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.905,411.761 345.843,465.545 338.9,407.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.918,465.545 267.853,411.761 250.864,407.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "202.399,374.9 167.476,422.295 214.859,387.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.673,250.86 124.218,243.925 178,267.855  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.859,202.402 167.476,167.471 202.399,214.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "267.853,178.001 243.918,124.216 250.864,182.679  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.883,127.834 288.713,168.578 301.049,168.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.878,149.094 355.956,181.135 366.599,187.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "408.624,233.813 440.668,207.893 402.395,223.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "461.924,294.883 421.181,288.717 421.181,301.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.956,408.63 381.878,440.668 366.599,402.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "294.883,461.928 301.049,421.188 288.713,421.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.898,440.668 233.809,408.63 223.167,402.394  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.132,355.953 149.097,381.869 187.362,366.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "168.58,288.717 127.836,294.883 168.58,301.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "187.362,223.169 149.097,207.893 181.132,233.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.809,181.135 207.898,149.094 223.167,187.369  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M478.33,380.422c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.809c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.762-49.256-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.253,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.292l55.479-6.58h14.525 c17.063,38.648,55.699,65.629,100.661,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C477.949,385.446,478.33,382.98,478.33,380.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.628,123.001 320.69,176.786 337.686,181.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.154,213.643 421.074,166.256 373.694,201.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "405.875,249.645 410.551,266.641 464.335,242.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.69,410.546 344.628,464.33 337.686,405.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.704,464.33 266.638,410.546 249.649,405.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.185,373.685 166.261,421.08 213.644,386.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.458,249.645 123.003,242.71 176.784,266.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.644,201.187 166.261,166.256 201.185,213.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.638,176.786 242.704,123.001 249.649,181.464  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.668,126.619 287.498,167.363 299.833,167.363  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.663,147.879 354.741,179.92 365.384,186.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "407.409,232.598 439.453,206.678 401.18,221.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "460.709,293.668 419.966,287.501 419.966,299.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.741,407.415 380.663,439.453 365.384,401.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.668,460.713 299.833,419.973 287.498,419.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.683,439.453 232.594,407.415 221.952,401.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.917,354.738 147.881,380.653 186.147,365.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "167.365,287.501 126.622,293.668 167.365,299.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.147,221.954 147.881,206.678 179.917,232.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.594,179.92 206.683,147.879 221.952,186.154  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M477.115,379.206c0-14.139-11.095-25.657-25.046-26.4c0.012-0.196,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.784-23.926l-0.224,0.809c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.027c2.119-8.524,3.26-17.434,3.26-26.609c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.479,45.813-109.808,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.426-0.697-4.981-1.091-7.625-1.091 c-15.254,0-27.624,12.368-27.624,27.618c0,2.238,0.339,4.386,0.843,6.472l-18.644,8.292l55.478-6.58h14.526 c17.062,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C476.734,384.23,477.115,381.765,477.115,379.206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.412,121.786 319.475,175.57 336.471,180.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.939,212.428 419.859,165.041 372.479,199.972  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.66,248.43 409.336,265.426 463.12,241.495  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.475,409.33 343.412,463.115 336.471,404.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.488,463.115 265.423,409.33 248.434,404.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.969,372.47 165.045,419.864 212.429,384.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "180.243,248.43 121.788,241.495 175.569,265.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.429,199.972 165.045,165.041 199.969,212.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.423,175.57 241.488,121.786 248.434,180.248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.453,125.404 286.283,166.148 298.618,166.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.447,146.664 353.525,178.704 364.169,184.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "406.194,231.382 438.238,205.463 399.965,220.739  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "459.494,292.453 418.751,286.286 418.751,298.618  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.525,406.2 379.447,438.237 364.169,399.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.453,459.497 298.618,418.757 286.283,418.757  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.468,438.237 231.379,406.2 220.736,399.964  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.703,353.522 146.666,379.438 184.932,364.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "166.149,286.286 125.406,292.453 166.149,298.618  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.932,220.739 146.666,205.463 178.703,231.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.379,178.704 205.468,146.664 220.736,184.939  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M475.9,377.991c0-14.138-11.095-25.657-25.047-26.399c0.013-0.198,0.061-0.393,0.061-0.599 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.426,0.022-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.608c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.768,4.6-6.506,10.069-7.807,16.086c-2.426-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.618c0,2.237,0.339,4.387,0.843,6.471l-18.645,8.293l55.479-6.581h14.526 c17.062,38.648,55.699,65.629,100.661,65.629c21.669,0,41.851-6.285,58.875-17.096h21.726l46.806,34.506l-25.423-34.506h80.403 C475.52,383.016,475.9,380.551,475.9,377.991z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.197,120.571 318.261,174.355 335.256,179.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.725,211.213 418.645,163.825 371.265,198.756  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.445,247.215 408.12,264.21 461.904,240.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.261,408.115 342.197,461.9 335.256,403.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "240.273,461.9 264.207,408.115 247.219,403.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.754,371.255 163.831,418.649 211.213,383.718  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.028,247.215 120.573,240.28 174.354,264.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.213,198.756 163.831,163.825 198.754,211.213  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.207,174.355 240.273,120.571 247.219,179.033  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.237,124.189 285.067,164.933 297.403,164.933  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.233,145.449 352.311,177.489 362.953,183.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "404.979,230.167 437.023,204.248 398.75,219.524  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "458.278,291.237 417.535,285.071 417.535,297.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.311,404.985 378.233,437.022 362.953,398.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.237,458.282 297.403,417.542 285.067,417.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.253,437.022 230.164,404.985 219.521,398.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.487,352.308 145.451,378.224 183.717,362.954  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "164.935,285.071 124.191,291.237 164.935,297.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.717,219.524 145.451,204.248 177.487,230.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.164,177.489 204.253,145.449 219.521,183.724  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M474.686,376.776c0-14.139-11.095-25.657-25.047-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.553-7.098-4.029-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.962-0.783-6.055-1.253-9.267-1.253 c-0.216,0-0.425,0.022-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.768,4.6-6.506,10.068-7.807,16.086c-2.426-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.285,58.876-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C474.305,381.801,474.686,379.335,474.686,376.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.982,119.355 317.045,173.141 334.04,177.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.509,209.997 417.429,162.61 370.049,197.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.23,246 406.905,262.995 460.689,239.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.045,406.9 340.982,460.685 334.04,402.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.058,460.685 262.992,406.9 246.004,402.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.539,370.04 162.616,417.435 209.999,382.503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.813,246 119.358,239.064 173.139,262.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.999,197.542 162.616,162.61 197.539,209.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.992,173.141 239.058,119.355 246.004,177.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.022,122.974 283.853,163.717 296.188,163.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.018,144.233 351.096,176.274 361.738,182.508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "403.764,228.952 435.808,203.033 397.535,218.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "457.063,290.022 416.32,283.856 416.32,296.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.096,403.771 377.018,435.808 361.738,397.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.022,457.066 296.188,416.327 283.853,416.327  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.038,435.808 228.948,403.771 218.307,397.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "176.272,351.093 144.236,377.009 182.502,361.739  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "163.72,283.856 122.977,290.022 163.72,296.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.502,218.309 144.236,203.033 176.272,228.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.948,176.274 203.038,144.233 218.307,182.508  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M473.471,375.561c0-14.138-11.096-25.656-25.047-26.399c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.784-6.055-1.253-9.266-1.253 c-0.218,0-0.426,0.022-0.643,0.026c2.119-8.524,3.261-17.433,3.261-26.609c0-60.762-49.256-110.007-110.012-110.007 c-58.597,0-106.48,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.253,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.062,38.648,55.699,65.629,100.66,65.629c21.669,0,41.851-6.286,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C473.089,380.586,473.471,378.12,473.471,375.561z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "339.768,118.141 315.83,171.926 332.825,176.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.294,208.783 416.214,161.395 368.834,196.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.016,244.785 405.69,261.78 459.475,237.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.83,405.686 339.768,459.47 332.825,401.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.843,459.47 261.777,405.686 244.789,401.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.324,368.825 161.4,416.219 208.783,381.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "176.598,244.785 118.144,237.85 171.924,261.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.783,196.326 161.4,161.395 196.324,208.783  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "261.777,171.926 237.843,118.141 244.789,176.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.807,121.759 282.637,162.502 294.973,162.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.803,143.019 349.881,175.059 360.523,181.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "402.549,227.737 434.593,201.817 396.319,217.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "455.849,288.807 415.105,282.641 415.105,294.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.881,402.555 375.803,434.593 360.523,396.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "288.807,455.852 294.973,415.111 282.637,415.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.823,434.593 227.733,402.555 217.092,396.318  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.057,349.877 143.021,375.794 181.287,360.523  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "162.505,282.641 121.761,288.807 162.505,294.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.287,217.094 143.021,201.817 175.057,227.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "227.733,175.059 201.823,143.019 217.092,181.293  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M472.255,374.347c0-14.14-11.095-25.658-25.046-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.512l16.234,1.924l-53.784-23.926l-0.224,0.809c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.61c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.601-6.505,10.068-7.807,16.086c-2.426-0.697-4.98-1.089-7.625-1.089 c-15.253,0-27.624,12.367-27.624,27.616c0,2.238,0.339,4.387,0.843,6.473l-18.644,8.292l55.478-6.58h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.67,0,41.852-6.286,58.876-17.097h21.726l46.806,34.506l-25.423-34.506h80.404 C471.874,379.371,472.255,376.905,472.255,374.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.553,116.925 314.615,170.71 331.61,175.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.079,207.567 414.999,160.18 367.619,195.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "399.801,243.569 404.476,260.565 458.26,236.634  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.615,404.47 338.553,458.255 331.61,399.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.628,458.255 260.563,404.47 243.574,399.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.108,367.609 160.186,415.004 207.568,380.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.383,243.569 116.928,236.634 170.709,260.565  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.568,195.111 160.186,160.18 195.108,207.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.563,170.71 236.628,116.925 243.574,175.388  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.592,120.544 281.422,161.287 293.758,161.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.588,141.804 348.666,173.844 359.309,180.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "401.334,226.522 433.378,200.603 395.104,215.879  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "454.634,287.592 413.891,281.426 413.891,293.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.666,401.34 374.588,433.377 359.309,395.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.592,454.637 293.758,413.896 281.422,413.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.607,433.377 226.519,401.34 215.876,395.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "173.842,348.662 141.806,374.578 180.072,359.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "161.29,281.426 120.546,287.592 161.29,293.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "180.072,215.879 141.806,200.603 173.842,226.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.519,173.844 200.607,141.804 215.876,180.078  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M471.039,373.131c0-14.139-11.094-25.657-25.045-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.478-6.581h14.525 c17.063,38.648,55.699,65.63,100.66,65.63c21.67,0,41.852-6.286,58.876-17.097h21.726l46.806,34.506l-25.423-34.506h80.404 C470.659,378.155,471.039,375.689,471.039,373.131z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.338,115.71 313.4,169.496 330.396,174.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.864,206.352 413.784,158.965 366.404,193.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.585,242.354 403.26,259.35 457.045,235.419  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.4,403.255 337.338,457.039 330.396,398.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.413,457.039 259.348,403.255 242.358,398.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "193.894,366.395 158.971,413.789 206.353,378.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "174.168,242.354 115.713,235.419 169.494,259.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.353,193.896 158.971,158.965 193.894,206.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.348,169.496 235.413,115.71 242.358,174.173  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.377,119.328 280.207,160.072 292.543,160.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.372,140.588 347.45,172.629 358.094,178.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "400.119,225.307 432.163,199.387 393.889,214.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "453.419,286.377 412.676,280.211 412.676,292.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.45,400.125 373.372,432.162 358.094,393.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.377,453.422 292.543,412.682 280.207,412.682  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.393,432.162 225.304,400.125 214.661,393.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.627,347.447 140.591,373.363 178.856,358.094  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "160.074,280.211 119.331,286.377 160.074,292.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.856,214.664 140.591,199.387 172.627,225.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.304,172.629 199.393,140.588 214.661,178.863  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M469.824,371.916c0-14.139-11.094-25.658-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.235,1.925l-53.785-23.927l-0.223,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.118-8.523,3.26-17.433,3.26-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.506,10.068-7.808,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.525 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.875-17.096h21.727l46.806,34.506l-25.423-34.506h80.403 C469.443,376.94,469.824,374.475,469.824,371.916z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.123,114.495 312.185,168.28 329.18,172.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.648,205.137 412.569,157.75 365.189,192.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.37,241.14 402.045,258.135 455.83,234.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "312.185,402.04 336.123,455.824 329.18,397.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "234.197,455.824 258.132,402.04 241.144,397.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.679,365.18 157.755,412.574 205.138,377.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.953,241.14 114.498,234.204 168.279,258.135  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.138,192.681 157.755,157.75 192.679,205.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.132,168.28 234.197,114.495 241.144,172.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.162,118.113 278.992,158.857 291.328,158.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.158,139.373 346.235,171.414 356.878,177.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "398.903,224.092 430.947,198.172 392.675,213.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "452.203,285.162 411.461,278.995 411.461,291.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.235,398.91 372.158,430.947 356.878,392.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.162,452.207 291.328,411.467 278.992,411.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.178,430.947 224.088,398.91 213.446,392.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "171.412,346.232 139.376,372.148 177.642,356.879  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "158.859,278.995 118.116,285.162 158.859,291.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.642,213.449 139.376,198.172 171.412,224.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.088,171.414 198.178,139.373 213.446,177.648  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M468.609,370.701c0-14.139-11.094-25.658-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.785-23.927l-0.223,0.809c-2.964-0.784-6.056-1.253-9.268-1.253 c-0.216,0-0.424,0.022-0.641,0.026c2.118-8.523,3.259-17.433,3.259-26.609c0-60.761-49.255-110.007-110.011-110.007 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.506,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.479-6.581h14.526 c17.062,38.648,55.698,65.629,100.66,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.807,34.507l-25.424-34.507h80.405 C468.229,375.726,468.609,373.26,468.609,370.701z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.907,113.28 310.97,167.065 327.965,171.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.434,203.922 411.354,156.535 363.974,191.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.155,239.924 400.83,256.92 454.614,232.989  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.97,400.825 334.907,454.609 327.965,396.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.982,454.609 256.917,400.825 239.928,396.154  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "191.464,363.964 156.54,411.359 203.923,376.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "171.738,239.924 113.283,232.989 167.063,256.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.923,191.466 156.54,156.535 191.464,203.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256.917,167.065 232.982,113.28 239.928,171.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.946,116.898 277.776,157.643 290.112,157.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.942,138.158 345.021,170.199 355.663,176.433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "397.688,222.876 429.732,196.957 391.459,212.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "450.988,283.946 410.245,277.78 410.245,290.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.021,397.694 370.942,429.732 355.663,391.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.946,450.992 290.112,410.252 277.776,410.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.962,429.732 222.873,397.694 212.231,391.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "170.197,345.018 138.161,370.934 176.427,355.664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "157.644,277.78 116.901,283.946 157.644,290.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "176.427,212.233 138.161,196.957 170.197,222.876  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.873,170.199 196.962,138.158 212.231,176.433  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M467.395,369.485c0-14.138-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.392,0.06-0.597 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.784-23.926l-0.224,0.809c-2.962-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.522,3.26-17.432,3.26-26.609c0-60.76-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.806,103.583c-3.768,4.6-6.506,10.067-7.808,16.086c-2.425-0.698-4.98-1.091-7.625-1.091 c-15.254,0-27.623,12.368-27.623,27.617c0,2.239,0.339,4.387,0.842,6.473l-18.644,8.292l55.478-6.58h14.526 c17.063,38.647,55.699,65.629,100.66,65.629c21.67,0,41.852-6.286,58.876-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C467.014,374.511,467.395,372.045,467.395,369.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "333.692,112.065 309.755,165.85 326.75,170.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.219,202.707 410.139,155.32 362.759,190.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.939,238.709 399.615,255.705 453.399,231.774  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.755,399.61 333.692,453.395 326.75,394.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.768,453.395 255.702,399.61 238.713,394.939  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "190.249,362.749 155.325,410.144 202.708,375.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "170.522,238.709 112.067,231.774 165.849,255.705  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "202.708,190.251 155.325,155.32 190.249,202.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "255.702,165.85 231.768,112.065 238.713,170.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.731,115.684 276.562,156.427 288.897,156.427  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.728,136.943 343.805,168.984 354.448,175.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "396.474,221.662 428.518,195.742 390.244,211.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "449.773,282.731 409.03,276.565 409.03,288.897  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "343.805,396.479 369.728,428.517 354.448,390.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "282.731,449.776 288.897,409.037 276.562,409.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.748,428.517 221.658,396.479 211.016,390.243  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "168.981,343.803 136.946,369.718 175.211,354.448  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "156.429,276.565 115.686,282.731 156.429,288.897  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.211,211.018 136.946,195.742 168.981,221.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "221.658,168.984 195.748,136.943 211.016,175.218  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M466.18,368.271c0-14.14-11.095-25.658-25.046-26.4c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.784-23.926l-0.224,0.809c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.98-1.089-7.625-1.089 c-15.254,0-27.624,12.366-27.624,27.616c0,2.238,0.339,4.388,0.843,6.472l-18.645,8.293l55.479-6.58h14.525 c17.063,38.647,55.699,65.628,100.66,65.628c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C465.799,373.295,466.18,370.829,466.18,368.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.478,110.851 308.54,164.635 325.535,169.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.004,201.492 408.924,154.105 361.544,189.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "393.726,237.494 398.4,254.49 452.185,230.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.54,398.395 332.478,452.179 325.535,393.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.553,452.179 254.487,398.395 237.499,393.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.034,361.534 154.11,408.929 201.493,373.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "169.308,237.494 110.853,230.559 164.634,254.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.493,189.036 154.11,154.105 189.034,201.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "254.487,164.635 230.553,110.851 237.499,169.313  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.517,114.468 275.347,155.212 287.683,155.212  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.512,135.728 342.59,167.769 353.233,174.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "395.259,220.446 427.303,194.527 389.029,209.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "448.559,281.517 407.815,275.35 407.815,287.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.59,395.265 368.512,427.302 353.233,389.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "281.517,448.562 287.683,407.821 275.347,407.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.532,427.302 220.443,395.265 209.801,389.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "167.767,342.587 135.73,368.503 173.996,353.233  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "155.214,275.35 114.471,281.517 155.214,287.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "173.996,209.804 135.73,194.527 167.767,220.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.443,167.769 194.532,135.728 209.801,174.003  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M464.965,367.056c0-14.139-11.095-25.658-25.047-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925L398.4,308.544l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.843,6.472l-18.645,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C464.584,372.08,464.965,369.614,464.965,367.056z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.262,109.635 307.324,163.42 324.32,168.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.789,200.276 407.709,152.89 360.329,187.821  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.51,236.279 397.185,253.274 450.97,229.344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "307.324,397.18 331.262,450.964 324.32,392.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "229.337,450.964 253.271,397.18 236.283,392.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "187.818,360.319 152.895,407.714 200.278,372.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "168.092,236.279 109.638,229.344 163.418,253.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "200.278,187.821 152.895,152.89 187.818,200.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "253.271,163.42 229.337,109.635 236.283,168.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.302,113.253 274.132,153.997 286.467,153.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.298,134.513 341.375,166.554 352.018,172.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "394.043,219.231 426.087,193.312 387.814,208.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "447.344,280.302 406.6,274.135 406.6,286.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "341.375,394.05 367.298,426.087 352.018,387.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "280.302,447.347 286.467,406.606 274.132,406.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "193.317,426.087 219.228,394.05 208.585,387.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "166.552,341.372 134.515,367.288 172.781,352.019  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "153.999,274.135 113.256,280.302 153.999,286.467  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.781,208.588 134.515,193.312 166.552,219.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.228,166.554 193.317,134.513 208.585,172.788  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M463.749,365.841c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.553-7.098-4.029-9.512l16.235,1.925l-53.785-23.927l-0.223,0.809c-2.964-0.783-6.056-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.259-17.433,3.259-26.609c0-60.761-49.254-110.006-110.011-110.006 c-58.597,0-106.48,45.813-109.808,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.981-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.525 c17.063,38.648,55.699,65.629,100.661,65.629c21.67,0,41.851-6.285,58.876-17.097h21.726l46.806,34.507l-25.424-34.507h80.404 C463.369,370.865,463.749,368.399,463.749,365.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.047,108.42 306.109,162.205 323.104,166.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.573,199.062 406.493,151.674 359.113,186.605  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.295,235.064 395.97,252.06 449.754,228.129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.109,395.965 330.047,449.749 323.104,391.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.122,449.749 252.057,395.965 235.068,391.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.604,359.104 151.68,406.499 199.063,371.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "166.877,235.064 108.422,228.129 162.203,252.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.063,186.605 151.68,151.674 186.604,199.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "252.057,162.205 228.122,108.42 235.068,166.882  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.087,112.038 272.917,152.782 285.252,152.782  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.082,133.298 340.16,165.338 350.803,171.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "392.828,218.016 424.872,192.097 386.599,207.373  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "446.128,279.087 405.385,272.92 405.385,285.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "340.16,392.834 366.082,424.872 350.803,386.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "279.087,446.132 285.252,405.392 272.917,405.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.102,424.872 218.013,392.834 207.371,386.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "165.337,340.157 133.301,366.073 171.566,350.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "152.784,272.92 112.041,279.087 152.784,285.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "171.566,207.373 133.301,192.097 165.337,218.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.013,165.338 192.102,133.298 207.371,171.573  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M462.534,364.626c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.599 c0-3.733-1.553-7.097-4.029-9.511l16.234,1.925l-53.784-23.928l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.023-0.642,0.026c2.119-8.523,3.26-17.432,3.26-26.608c0-60.761-49.254-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.767,4.601-6.505,10.069-7.807,16.087c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.237,0.339,4.386,0.843,6.472l-18.645,8.293l55.478-6.582h14.526 c17.062,38.648,55.698,65.63,100.66,65.63c21.669,0,41.851-6.285,58.876-17.097h21.725l46.806,34.507l-25.423-34.507h80.404 C462.153,369.65,462.534,367.185,462.534,364.626z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.832,107.205 304.895,160.99 321.89,165.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.358,197.846 405.278,150.459 357.898,185.391  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.08,233.849 394.755,250.844 448.539,226.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "304.895,394.75 328.832,448.533 321.89,390.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "226.907,448.533 250.842,394.75 233.853,390.078  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "185.388,357.889 150.465,405.284 197.848,370.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "165.662,233.849 107.208,226.914 160.988,250.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.848,185.391 150.465,150.459 185.388,197.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "250.842,160.99 226.907,107.205 233.853,165.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.871,110.823 271.701,151.567 284.037,151.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.867,132.083 338.944,164.123 349.588,170.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "391.613,216.801 423.657,190.882 385.384,206.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "444.913,277.871 404.17,271.705 404.17,284.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "338.944,391.619 364.867,423.656 349.588,385.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "277.871,444.916 284.037,404.177 271.701,404.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "190.887,423.656 216.798,391.619 206.155,385.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "164.122,338.941 132.085,364.857 170.351,349.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "151.569,271.705 110.825,277.871 151.569,284.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "170.351,206.158 132.085,190.882 164.122,216.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "216.798,164.123 190.887,132.083 206.155,170.357  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M461.319,363.41c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.597 c0-3.734-1.552-7.098-4.028-9.513l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.599-6.505,10.067-7.807,16.085c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.239,0.339,4.388,0.842,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.63,100.66,65.63c21.67,0,41.852-6.286,58.876-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C460.938,368.436,461.319,365.969,461.319,363.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "327.617,105.99 303.68,159.775 320.675,164.453  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.144,196.631 404.063,149.244 356.684,184.175  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "388.865,232.634 393.54,249.63 447.324,225.698  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "303.68,393.534 327.617,447.318 320.675,388.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "225.692,447.318 249.626,393.534 232.638,388.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.173,356.674 149.25,404.068 196.633,369.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "164.447,232.634 105.992,225.698 159.773,249.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.633,184.175 149.25,149.244 184.173,196.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "249.626,159.775 225.692,105.99 232.638,164.453  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.656,109.608 270.486,150.352 282.822,150.352  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.652,130.868 337.729,162.908 348.373,169.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "390.398,215.586 422.442,189.667 384.169,204.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "443.698,276.656 402.955,270.49 402.955,282.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "337.729,390.404 363.652,422.441 348.373,384.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "276.656,443.701 282.822,402.961 270.486,402.961  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.672,422.441 215.583,390.404 204.94,384.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "162.906,337.727 130.87,363.643 169.136,348.373  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "150.354,270.49 109.61,276.656 150.354,282.822  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "169.136,204.943 130.87,189.667 162.906,215.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.583,162.908 189.672,130.868 204.94,169.143  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M460.104,362.195c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.253,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C459.724,367.22,460.104,364.754,460.104,362.195z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.402,104.775 302.465,158.56 319.46,163.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "367.928,195.416 402.848,148.029 355.469,182.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.649,231.419 392.325,248.415 446.109,224.483  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "302.465,392.319 326.402,446.104 319.46,387.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "224.477,446.104 248.412,392.319 231.423,387.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.958,355.459 148.035,402.854 195.417,367.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "163.232,231.419 104.777,224.483 158.558,248.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "195.417,182.96 148.035,148.029 182.958,195.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "248.412,158.56 224.477,104.775 231.423,163.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.441,108.393 269.271,149.137 281.607,149.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "362.437,129.652 336.515,161.693 347.157,167.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "389.184,214.371 421.228,188.452 382.954,203.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "442.483,275.441 401.74,269.274 401.74,281.607  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "336.515,389.189 362.437,421.227 347.157,382.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "275.441,442.486 281.607,401.746 269.271,401.746  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.457,421.227 214.368,389.189 203.726,382.952  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "161.691,336.512 129.655,362.428 167.921,347.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "149.139,269.274 108.396,275.441 149.139,281.607  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "167.921,203.728 129.655,188.452 161.691,214.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.368,161.693 188.457,129.652 203.726,167.928  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M458.889,360.98c0-14.139-11.094-25.658-25.046-26.4c0.013-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.235,1.925l-53.784-23.927l-0.225,0.809c-2.963-0.783-6.054-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.641,0.026c2.118-8.523,3.26-17.433,3.26-26.609c0-60.761-49.256-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.808,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.698,65.629,100.66,65.629c21.669,0,41.852-6.285,58.876-17.096h21.726l46.805,34.506l-25.422-34.506h80.404 C458.508,366.005,458.889,363.539,458.889,360.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.187,103.56 301.25,157.345 318.244,162.022  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "366.713,194.201 401.633,146.814 354.254,181.745  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.435,230.204 391.109,247.2 444.895,223.268  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "301.25,391.104 325.187,444.889 318.244,386.434  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "223.262,444.889 247.196,391.104 230.208,386.434  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.743,354.244 146.819,401.639 194.202,366.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "162.017,230.204 103.563,223.268 157.343,247.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.202,181.745 146.819,146.814 181.743,194.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "247.196,157.345 223.262,103.56 230.208,162.022  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.227,107.178 268.057,147.922 280.392,147.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.223,128.438 335.3,160.479 345.942,166.712  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "387.968,213.156 420.012,187.236 381.738,202.513  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "441.268,274.227 400.524,268.06 400.524,280.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "335.3,387.974 361.223,420.012 345.942,381.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "274.227,441.271 280.392,400.531 268.057,400.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "187.242,420.012 213.152,387.974 202.51,381.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "160.476,335.297 128.44,361.213 166.706,345.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "147.923,268.06 107.181,274.227 147.923,280.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "166.706,202.513 128.44,187.236 160.476,213.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.152,160.479 187.242,128.438 202.51,166.712  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M457.674,359.765c0-14.138-11.095-25.657-25.046-26.399c0.012-0.198,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.099-4.028-9.513l16.235,1.926l-53.785-23.927l-0.224,0.809c-2.962-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.007-110.011-110.007 c-58.597,0-106.479,45.813-109.808,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.661,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C457.293,364.789,457.674,362.324,457.674,359.765z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.972,102.345 300.034,156.129 317.029,160.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "365.498,192.986 400.418,145.599 353.038,180.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.22,228.988 389.895,245.984 443.679,222.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "300.034,389.889 323.972,443.673 317.029,385.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "222.047,443.673 245.981,389.889 228.993,385.219  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "180.528,353.028 145.604,400.424 192.987,365.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "160.802,228.988 102.347,222.053 156.128,245.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "192.987,180.53 145.604,145.599 180.528,192.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "245.981,156.129 222.047,102.345 228.993,160.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.012,105.963 266.842,146.707 279.177,146.707  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.007,127.223 334.085,159.263 344.728,165.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "386.753,211.94 418.797,186.021 380.523,201.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "440.053,273.012 399.31,266.845 399.31,279.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "334.085,386.759 360.007,418.797 344.728,380.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "273.012,440.056 279.177,399.316 266.842,399.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.027,418.797 211.938,386.759 201.295,380.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "159.261,334.081 127.225,359.997 165.491,344.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "146.708,266.845 105.965,273.012 146.708,279.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "165.491,201.298 127.225,186.021 159.261,211.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.938,159.263 186.027,127.223 201.295,165.497  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M456.459,358.551c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.734-1.552-7.099-4.028-9.512l16.234,1.924l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.021-0.642,0.025c2.119-8.523,3.26-17.432,3.26-26.608c0-60.762-49.255-110.007-110.011-110.007 c-58.598,0-106.48,45.813-109.808,103.582c-3.767,4.6-6.506,10.069-7.808,16.086c-2.425-0.697-4.98-1.089-7.625-1.089 c-15.254,0-27.624,12.367-27.624,27.616c0,2.238,0.339,4.388,0.843,6.472l-18.645,8.293l55.479-6.581h14.526 c17.063,38.648,55.698,65.629,100.661,65.629c21.669,0,41.851-6.284,58.875-17.096h21.726l46.806,34.507l-25.423-34.507h80.404 C456.078,363.574,456.459,361.109,456.459,358.551z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "322.757,101.13 298.819,154.914 315.814,159.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "364.283,191.771 399.203,144.384 351.823,179.315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.004,227.774 388.68,244.769 442.464,220.838  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "298.819,388.674 322.757,442.458 315.814,384.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "220.832,442.458 244.766,388.674 227.777,384.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.313,351.813 144.39,399.208 191.772,364.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "159.587,227.774 101.132,220.838 154.913,244.769  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "191.772,179.315 144.39,144.384 179.313,191.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "244.766,154.914 220.832,101.13 227.777,159.592  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.796,104.748 265.626,145.492 277.962,145.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.792,126.007 332.869,158.048 343.513,164.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "385.538,210.726 417.582,184.806 379.309,200.083  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "438.838,271.796 398.095,265.63 398.095,277.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "332.869,385.544 358.792,417.581 343.513,379.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "271.796,438.841 277.962,398.101 265.626,398.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.812,417.581 210.722,385.544 200.08,379.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "158.046,332.866 126.01,358.782 164.275,343.513  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "145.493,265.63 104.75,271.796 145.493,277.962  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "164.275,200.083 126.01,184.806 158.046,210.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "210.722,158.048 184.812,126.007 200.08,164.282  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M455.244,357.335c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.767,4.6-6.505,10.068-7.808,16.086c-2.424-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.645,8.293l55.479-6.581h14.526 c17.063,38.648,55.698,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C454.863,362.359,455.244,359.894,455.244,357.335z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.541,99.914 297.604,153.699 314.6,158.377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "363.068,190.556 397.988,143.169 350.608,178.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "382.79,226.559 387.465,243.554 441.249,219.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "297.604,387.459 321.541,441.243 314.6,382.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "219.617,441.243 243.551,387.459 226.563,382.788  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.098,350.599 143.174,397.993 190.557,363.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "158.372,226.559 99.917,219.623 153.697,243.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "190.557,178.1 143.174,143.169 178.098,190.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "243.551,153.699 219.617,99.914 226.563,158.377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.581,103.533 264.411,144.276 276.747,144.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "357.576,124.792 331.654,156.833 342.298,163.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "384.323,209.51 416.367,183.591 378.094,198.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "437.623,270.581 396.88,264.414 396.88,276.747  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "331.654,384.329 357.576,416.366 342.298,378.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "270.581,437.626 276.747,396.886 264.411,396.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.597,416.366 209.507,384.329 198.865,378.092  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "156.831,331.651 124.794,357.567 163.061,342.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "144.278,264.414 103.535,270.581 144.278,276.747  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "163.061,198.868 124.794,183.591 156.831,209.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.507,156.833 183.597,124.792 198.865,163.067  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M454.029,356.12c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.225,0.809c-2.962-0.783-6.054-1.253-9.266-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.762-49.255-110.006-110.012-110.006 c-58.597,0-106.48,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.808,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C453.648,361.145,454.029,358.679,454.029,356.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.326,98.699 296.389,152.484 313.384,157.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "361.853,189.34 396.772,141.953 349.394,176.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.574,225.343 386.25,242.339 440.034,218.408  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "296.389,386.244 320.326,440.028 313.384,381.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "218.401,440.028 242.336,386.244 225.348,381.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "176.883,349.384 141.959,396.778 189.342,361.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "157.157,225.343 98.702,218.408 152.482,242.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "189.342,176.885 141.959,141.953 176.883,189.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "242.336,152.484 218.401,98.699 225.348,157.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.366,102.317 263.196,143.061 275.531,143.061  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.362,123.577 330.439,155.618 341.082,161.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "383.108,208.295 415.151,182.376 376.878,197.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "436.407,269.366 395.665,263.199 395.665,275.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "330.439,383.113 356.362,415.15 341.082,376.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "269.366,436.411 275.531,395.671 263.196,395.671  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.381,415.15 208.292,383.113 197.65,376.877  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "155.616,330.437 123.58,356.353 161.846,341.083  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "143.063,263.199 102.32,269.366 143.063,275.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "161.846,197.653 123.58,182.376 155.616,208.295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.292,155.618 182.381,123.577 197.65,161.852  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M452.813,354.905c0-14.139-11.094-25.658-25.046-26.4c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.552-7.099-4.029-9.512l16.235,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.784-6.056-1.253-9.268-1.253 c-0.216,0-0.425,0.022-0.642,0.026c2.12-8.523,3.261-17.433,3.261-26.609c0-60.762-49.256-110.006-110.012-110.006 c-58.597,0-106.48,45.813-109.808,103.583c-3.767,4.6-6.505,10.068-7.808,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.253,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.698,65.629,100.661,65.629c21.669,0,41.851-6.285,58.875-17.097h21.726l46.806,34.507l-25.422-34.507h80.403 C452.434,359.93,452.813,357.464,452.813,354.905z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.111,97.484 295.174,151.269 312.169,155.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "360.638,188.126 395.558,140.738 348.178,175.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.359,224.128 385.034,241.124 438.818,217.193  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "295.174,385.028 319.111,438.813 312.169,380.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "217.187,438.813 241.121,385.028 224.132,380.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.667,348.168 140.744,395.563 188.127,360.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "155.941,224.128 97.487,217.193 151.268,241.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "188.127,175.67 140.744,140.738 175.667,188.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "241.121,151.269 217.187,97.484 224.132,155.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.15,101.103 261.981,141.846 274.316,141.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.146,122.362 329.224,154.403 339.867,160.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "381.893,207.08 413.937,181.161 375.663,196.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "435.192,268.15 394.449,261.984 394.449,274.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "329.224,381.898 355.146,413.937 339.867,375.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "268.15,435.196 274.316,394.456 261.981,394.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "181.167,413.937 207.077,381.898 196.435,375.662  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "154.401,329.221 122.365,355.138 160.63,339.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "141.848,261.984 101.104,268.15 141.848,274.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "160.63,196.438 122.365,181.161 154.401,207.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.077,154.403 181.167,122.362 196.435,160.637  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M451.599,353.689c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.81c-2.963-0.784-6.055-1.254-9.267-1.254 c-0.216,0-0.425,0.022-0.642,0.027c2.119-8.524,3.26-17.433,3.26-26.61c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.582c-3.768,4.601-6.505,10.069-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.618c0,2.237,0.339,4.387,0.843,6.471l-18.644,8.293l55.478-6.58h14.526 c17.063,38.647,55.698,65.629,100.66,65.629c21.67,0,41.852-6.286,58.876-17.097h21.726l46.806,34.507l-25.423-34.507h80.404 C451.218,358.714,451.599,356.249,451.599,353.689z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.896,96.269 293.959,150.054 310.954,154.731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "359.423,186.911 394.343,139.523 346.963,174.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.145,222.914 383.819,239.909 437.604,215.978  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "293.959,383.813 317.896,437.598 310.954,379.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "215.971,437.598 239.905,383.813 222.917,379.143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "174.453,346.953 139.529,394.348 186.912,359.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "154.727,222.914 96.271,215.978 150.052,239.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "186.912,174.455 139.529,139.523 174.453,186.911  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "239.905,150.054 215.971,96.269 222.917,154.731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.936,99.887 260.766,140.631 273.102,140.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.932,121.147 328.009,153.188 338.652,159.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "380.678,205.865 412.722,179.946 374.448,195.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "433.978,266.936 393.234,260.77 393.234,273.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "328.009,380.684 353.932,412.721 338.652,374.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "266.936,433.98 273.102,393.24 260.766,393.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.951,412.721 205.862,380.684 195.22,374.446  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "153.186,328.006 121.15,353.922 159.416,338.652  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "140.633,260.77 99.89,266.936 140.633,273.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "159.416,195.222 121.15,179.946 153.186,205.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.862,153.188 179.951,121.147 195.22,159.422  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M450.384,352.475c0-14.139-11.095-25.657-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C450.003,357.499,450.384,355.033,450.384,352.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "316.682,95.054 292.744,148.839 309.739,153.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "358.208,185.696 393.128,138.308 345.748,173.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.93,221.698 382.604,238.694 436.389,214.763  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "292.744,382.599 316.682,436.383 309.739,377.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "214.756,436.383 238.69,382.599 221.702,377.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "173.237,345.738 138.314,393.133 185.696,358.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "153.511,221.698 95.057,214.763 148.837,238.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "185.696,173.24 138.314,138.308 173.237,185.696  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "238.69,148.839 214.756,95.054 221.702,153.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.721,98.672 259.551,139.416 271.887,139.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.717,119.932 326.794,151.972 337.438,158.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "379.463,204.65 411.507,178.731 373.233,194.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "432.763,265.721 392.02,259.554 392.02,271.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "326.794,379.469 352.717,411.506 337.438,373.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "265.721,432.766 271.887,392.025 259.551,392.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.736,411.506 204.647,379.469 194.004,373.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "151.971,326.791 119.935,352.707 158.2,337.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "139.418,259.554 98.675,265.721 139.418,271.887  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "158.2,194.007 119.935,178.731 151.971,204.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "204.647,151.972 178.736,119.932 194.004,158.207  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M449.169,351.26c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.007-110.012-110.007 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.506,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.698,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C448.788,356.284,449.169,353.818,449.169,351.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "315.467,93.839 291.529,147.624 308.524,152.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "356.993,184.48 391.912,137.093 344.532,172.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "376.714,220.483 381.39,237.479 435.174,213.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "291.529,381.384 315.467,435.168 308.524,376.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "213.541,435.168 237.475,381.384 220.487,376.713  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.022,344.523 137.099,391.918 184.481,356.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "152.296,220.483 93.842,213.548 147.623,237.479  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "184.481,172.024 137.099,137.093 172.022,184.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "237.475,147.624 213.541,93.839 220.487,152.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.506,97.458 258.336,138.201 270.672,138.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "351.501,118.717 325.579,150.757 336.222,156.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "378.248,203.435 410.291,177.516 372.019,192.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "431.547,264.506 390.804,258.339 390.804,270.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "325.579,378.253 351.501,410.291 336.222,372.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "264.506,431.551 270.672,390.811 258.336,390.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.521,410.291 203.432,378.253 192.789,372.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "150.755,325.576 118.719,351.492 156.985,336.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "138.203,258.339 97.46,264.506 138.203,270.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "156.985,192.792 118.719,177.516 150.755,203.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "203.432,150.757 177.521,118.717 192.789,156.992  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M447.953,350.045c0-14.139-11.095-25.658-25.046-26.4c0.013-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.551-7.098-4.027-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.643,0.025c2.119-8.523,3.261-17.432,3.261-26.608c0-60.762-49.255-110.007-110.012-110.007 c-58.597,0-106.479,45.813-109.808,103.582c-3.767,4.6-6.505,10.069-7.807,16.087c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.843,6.472l-18.644,8.293l55.478-6.582h14.526 c17.063,38.649,55.698,65.63,100.66,65.63c21.67,0,41.851-6.285,58.876-17.096h21.726l46.805,34.506l-25.423-34.506h80.405 C447.572,355.069,447.953,352.604,447.953,350.045z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "314.252,92.624 290.313,146.409 307.309,151.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "355.777,183.265 390.697,135.878 343.318,170.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.499,219.268 380.175,236.263 433.958,212.333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "290.313,380.169 314.252,433.953 307.309,375.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "212.326,433.953 236.261,380.169 219.272,375.497  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "170.807,343.308 135.884,390.703 183.267,355.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "151.081,219.268 92.626,212.333 146.407,236.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "183.267,170.81 135.884,135.878 170.807,183.265  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "236.261,146.409 212.326,92.624 219.272,151.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.29,96.242 257.12,136.986 269.456,136.986  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.287,117.502 324.363,149.542 335.007,155.776  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "377.033,202.22 409.077,176.301 370.803,191.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "430.332,263.29 389.589,257.124 389.589,269.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "324.363,377.038 350.287,409.076 335.007,370.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "263.29,430.335 269.456,389.596 257.12,389.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "176.306,409.076 202.217,377.038 191.574,370.802  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "149.541,324.361 117.504,350.276 155.77,335.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "136.988,257.124 96.244,263.29 136.988,269.456  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "155.77,191.577 117.504,176.301 149.541,202.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "202.217,149.542 176.306,117.502 191.574,155.776  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M446.738,348.83c0-14.14-11.095-25.659-25.046-26.4c0.013-0.197,0.061-0.393,0.061-0.599 c0-3.733-1.552-7.098-4.029-9.511l16.234,1.924l-53.783-23.926l-0.225,0.808c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.424,0.023-0.642,0.026c2.119-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.006-110.013-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.808,16.085c-2.425-0.697-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.618c0,2.238,0.339,4.387,0.843,6.471l-18.644,8.293l55.478-6.581h14.526 c17.063,38.649,55.698,65.629,100.66,65.629c21.67,0,41.853-6.285,58.876-17.096h21.727l46.805,34.507l-25.423-34.507h80.404 C446.357,353.854,446.738,351.388,446.738,348.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "313.036,91.409 289.099,145.194 306.094,149.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "354.563,182.05 389.482,134.663 342.103,169.594  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.284,218.053 378.959,235.049 432.743,211.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "289.099,378.953 313.036,432.737 306.094,374.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "211.111,432.737 235.045,378.953 218.057,374.282  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "169.592,342.093 134.669,389.487 182.052,354.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "149.866,218.053 91.412,211.117 145.192,235.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "182.052,169.594 134.669,134.663 169.592,182.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "235.045,145.194 211.111,91.409 218.057,149.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.075,95.027 255.905,135.771 268.241,135.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.071,116.287 323.148,148.328 333.792,154.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "375.817,201.004 407.861,175.086 369.588,190.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "429.117,262.075 388.374,255.909 388.374,268.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "323.148,375.823 349.071,407.86 333.792,369.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "262.075,429.12 268.241,388.38 255.905,388.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.091,407.86 201.001,375.823 190.359,369.586  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "148.325,323.146 116.289,349.062 154.555,333.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "135.772,255.909 95.029,262.075 135.772,268.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "154.555,190.362 116.289,175.086 148.325,201.004  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "201.001,148.328 175.091,116.287 190.359,154.561  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M445.523,347.614c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.767,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C445.143,352.639,445.523,350.173,445.523,347.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "311.821,90.193 287.884,143.979 304.879,148.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "353.348,180.835 388.268,133.448 340.888,168.379  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.069,216.838 377.744,233.833 431.527,209.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "287.884,377.738 311.821,431.522 304.879,373.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "209.896,431.522 233.83,377.738 216.842,373.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "168.377,340.878 133.454,388.272 180.836,353.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "148.651,216.838 90.196,209.902 143.977,233.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "180.836,168.379 133.454,133.448 168.377,180.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "233.83,143.979 209.896,90.193 216.842,148.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.86,93.812 254.69,134.555 267.026,134.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "347.856,115.072 321.934,147.112 332.577,153.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "374.603,199.79 406.646,173.871 368.373,189.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "427.902,260.86 387.159,254.694 387.159,267.026  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "321.934,374.608 347.856,406.646 332.577,368.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "260.86,427.905 267.026,387.165 254.69,387.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "173.876,406.646 199.787,374.608 189.144,368.371  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "147.11,321.931 115.074,347.847 153.34,332.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "134.558,254.694 93.814,260.86 134.558,267.026  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "153.34,189.147 115.074,173.871 147.11,199.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "199.787,147.112 173.876,115.072 189.144,153.346  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M444.309,346.399c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.233,1.925l-53.783-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.48,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.808,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581H160.2 c17.063,38.648,55.698,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C443.928,351.424,444.309,348.958,444.309,346.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "310.606,88.979 286.669,142.763 303.664,147.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "352.132,179.62 387.053,132.232 339.673,167.164  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "371.854,215.623 376.529,232.619 430.313,208.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "286.669,376.523 310.606,430.307 303.664,371.853  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "208.681,430.307 232.615,376.523 215.626,371.853  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "167.162,339.663 132.238,387.057 179.622,352.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "147.436,215.623 88.981,208.687 142.762,232.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "179.622,167.164 132.238,132.232 167.162,179.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "232.615,142.763 208.681,88.979 215.626,147.441  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.646,92.597 253.475,133.34 265.812,133.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "346.641,113.857 320.719,145.897 331.361,152.131  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "373.388,198.574 405.432,172.656 367.158,187.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "426.688,259.646 385.943,253.479 385.943,265.812  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "320.719,373.394 346.641,405.431 331.361,367.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "259.646,426.69 265.812,385.949 253.475,385.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "172.661,405.431 198.571,373.394 187.929,367.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "145.896,320.716 113.859,346.632 152.125,331.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "133.342,253.479 92.6,259.646 133.342,265.812  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "152.125,187.932 113.859,172.656 145.896,198.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "198.571,145.897 172.661,113.857 187.929,152.131  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M443.094,345.185c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.029-9.512l16.234,1.925l-53.783-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.218,0-0.425,0.022-0.643,0.026c2.12-8.523,3.261-17.433,3.261-26.609c0-60.761-49.256-110.007-110.012-110.007 c-58.597,0-106.48,45.813-109.808,103.583c-3.768,4.6-6.505,10.068-7.807,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.34,4.387,0.843,6.472L88.981,310.6l55.478-6.581h14.526 c17.063,38.648,55.699,65.629,100.661,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.505l-25.423-34.505h80.403 C442.713,350.209,443.094,347.743,443.094,345.185z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "309.391,87.764 285.454,141.548 302.448,146.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "350.918,178.405 385.837,131.018 338.458,165.949  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.64,214.407 375.313,231.403 429.098,207.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "285.454,375.308 309.391,429.092 302.448,370.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "207.466,429.092 231.4,375.308 214.412,370.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "165.947,338.448 131.023,385.843 178.406,350.911  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "146.221,214.407 87.766,207.472 141.547,231.403  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "178.406,165.949 131.023,131.018 165.947,178.405  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "231.4,141.548 207.466,87.764 214.412,146.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.43,91.382 252.26,132.125 264.597,132.125  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "345.427,112.642 319.504,144.682 330.146,150.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "372.172,197.359 404.217,171.44 365.943,186.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "425.472,258.43 384.729,252.264 384.729,264.597  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "319.504,372.178 345.427,404.216 330.146,365.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "258.43,425.475 264.597,384.734 252.26,384.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "171.446,404.216 197.356,372.178 186.714,365.941  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "144.68,319.501 112.644,345.417 150.91,330.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "132.127,252.264 91.384,258.43 132.127,264.597  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "150.91,186.717 112.644,171.44 144.68,197.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "197.356,144.682 171.446,112.642 186.714,150.916  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M441.878,343.97c0-14.14-11.095-25.659-25.046-26.401c0.012-0.197,0.061-0.393,0.061-0.598 c0-3.733-1.553-7.098-4.028-9.512l16.233,1.925l-53.784-23.926l-0.223,0.808c-2.963-0.783-6.056-1.252-9.267-1.252 c-0.218,0-0.426,0.021-0.643,0.025c2.12-8.522,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.808,16.085c-2.425-0.697-4.98-1.089-7.625-1.089 c-15.254,0-27.624,12.367-27.624,27.617c0,2.237,0.339,4.387,0.843,6.471l-18.644,8.293l55.478-6.581h14.526 c17.063,38.649,55.698,65.629,100.66,65.629c21.671,0,41.853-6.285,58.877-17.095h21.726l46.805,34.506l-25.423-34.506h80.405 C441.498,348.993,441.878,346.528,441.878,343.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "308.176,86.548 284.238,140.333 301.233,145.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "349.702,177.19 384.623,129.802 337.242,164.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.424,213.193 374.099,230.188 427.883,206.257  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "284.238,374.093 308.176,427.877 301.233,369.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "206.25,427.877 230.185,374.093 213.197,369.422  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "164.732,337.232 129.808,384.627 177.191,349.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "145.006,213.193 86.551,206.257 140.332,230.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "177.191,164.734 129.808,129.802 164.732,177.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "230.185,140.333 206.25,86.548 213.197,145.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.215,90.167 251.045,130.91 263.381,130.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "344.211,111.427 318.288,143.467 328.932,149.701  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "370.957,196.144 403.001,170.226 364.728,185.502  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "424.258,257.215 383.514,251.048 383.514,263.381  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "318.288,370.963 344.211,403 328.932,364.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "257.215,424.261 263.381,383.52 251.045,383.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "170.23,403 196.141,370.963 185.499,364.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "143.465,318.285 111.429,344.201 149.695,328.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "130.912,251.048 90.169,257.215 130.912,263.381  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "149.695,185.502 111.429,170.226 143.465,196.144  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "196.141,143.467 170.23,111.427 185.499,149.701  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M440.663,342.754c0-14.139-11.094-25.657-25.045-26.4c0.012-0.197,0.059-0.393,0.059-0.598 c0-3.733-1.552-7.097-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.216,0-0.424,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.807,16.085c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.253,0-27.623,12.367-27.623,27.617c0,2.238,0.339,4.387,0.842,6.472l-18.644,8.293l55.479-6.58h14.526 c17.063,38.648,55.698,65.628,100.66,65.628c21.67,0,41.852-6.285,58.877-17.096h21.725l46.807,34.506l-25.424-34.506h80.404 C440.282,347.778,440.663,345.313,440.663,342.754z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "306.961,85.333 283.023,139.118 300.019,143.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "348.487,175.975 383.407,128.587 336.027,163.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "368.209,211.978 372.884,228.973 426.668,205.042  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "283.023,372.878 306.961,426.662 300.019,368.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "205.036,426.662 228.97,372.878 211.981,368.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "163.517,336.018 128.593,383.412 175.976,348.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "143.791,211.978 85.336,205.042 139.117,228.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "175.976,163.519 128.593,128.587 163.517,175.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "228.97,139.118 205.036,85.333 211.981,143.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256,88.952 249.83,129.695 262.166,129.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "342.996,110.211 317.073,142.252 327.717,148.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "369.742,194.929 401.786,169.01 363.513,184.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "423.042,256 382.299,249.833 382.299,262.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "317.073,369.748 342.996,401.785 327.717,363.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "256,423.045 262.166,382.305 249.83,382.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "169.016,401.785 194.926,369.748 184.284,363.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "142.25,317.07 110.214,342.986 148.479,327.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "129.697,249.833 88.954,256 129.697,262.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "148.479,184.287 110.214,169.01 142.25,194.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#13B5E6",
    points: "194.926,142.252 169.016,110.211 184.284,148.486  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13B5E6",
    d: "M439.448,341.539c0-14.139-11.095-25.658-25.046-26.4c0.012-0.197,0.06-0.393,0.06-0.598 c0-3.733-1.552-7.098-4.028-9.512l16.234,1.925l-53.784-23.927l-0.224,0.809c-2.963-0.783-6.055-1.253-9.267-1.253 c-0.217,0-0.425,0.022-0.642,0.026c2.119-8.523,3.26-17.433,3.26-26.609c0-60.761-49.255-110.006-110.012-110.006 c-58.597,0-106.479,45.813-109.807,103.583c-3.768,4.6-6.505,10.068-7.808,16.086c-2.425-0.698-4.98-1.09-7.625-1.09 c-15.254,0-27.624,12.367-27.624,27.617c0,2.238,0.339,4.387,0.843,6.472l-18.644,8.293l55.478-6.581h14.526 c17.063,38.648,55.698,65.629,100.66,65.629c21.67,0,41.852-6.285,58.876-17.096h21.726l46.806,34.506l-25.423-34.506h80.404 C439.067,346.563,439.448,344.098,439.448,341.539z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "sun_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EB",
    d: "M366.012,256c0,60.754-49.255,110.002-110.012,110.002c-60.76,0-110.008-49.248-110.008-110.002 c0-60.761,49.248-110.006,110.008-110.006C316.757,145.994,366.012,195.239,366.012,256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD835",
    d: "M357.148,256c0,55.867-45.279,101.154-101.148,101.154c-55.874,0-101.152-45.287-101.152-101.154 c0-55.863,45.279-101.158,101.152-101.158C311.869,154.842,357.148,200.137,357.148,256z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "283.023,139.118 306.961,85.333 300.019,143.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "336.027,163.519 383.407,128.587 348.487,175.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "368.209,211.978 426.668,205.042 372.884,228.973  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "372.884,283.027 426.668,306.954 368.209,300.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "348.487,336.018 383.407,383.412 336.027,348.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "300.019,368.207 306.961,426.662 283.023,372.878  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "228.97,372.878 205.036,426.662 211.981,368.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "175.976,348.48 128.593,383.412 163.517,336.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "143.791,300.02 85.336,306.954 139.124,283.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "139.117,228.973 85.336,205.042 143.791,211.978  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "163.517,175.975 128.593,128.587 175.976,163.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "211.981,143.796 205.036,85.333 228.97,139.118  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "249.83,129.695 256,88.952 262.166,129.695  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "317.073,142.252 342.996,110.211 327.717,148.486  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "363.513,184.287 401.786,169.01 369.742,194.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "382.299,249.833 423.042,256 382.299,262.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "369.742,317.07 401.786,342.986 363.513,327.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "327.717,363.511 342.996,401.785 317.073,369.748  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "262.166,382.305 256,423.045 249.83,382.305  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "194.926,369.748 169.016,401.785 184.284,363.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "148.479,327.717 110.214,342.986 142.25,317.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "129.697,262.166 88.954,256 129.697,249.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "142.25,194.929 110.214,169.01 148.479,184.287  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FDD835",
    points: "184.284,148.486 169.016,110.211 194.926,142.252  "
  })))), /*#__PURE__*/React.createElement("path", {
    id: "cloud_9_",
    fill: "#FFFFFF",
    d: "M243.227,300.373c1.544-3.719,2.402-7.793,2.402-12.071 c0-17.399-14.104-31.507-31.506-31.507c-1.351,0-2.671,0.112-3.98,0.28c-6.204-12.747-19.245-21.554-34.375-21.554 c-18.346,0-33.656,12.915-37.382,30.142c-2.425-0.698-4.98-1.09-7.625-1.09c-15.254,0-27.624,12.367-27.624,27.617 c0,2.85,0.437,5.595,1.235,8.184H243.227z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud_8_",
    fill: "#FFFFFF",
    d: "M438.389,348.906c0.679-2.343,1.06-4.809,1.06-7.367c0-14.139-11.095-25.658-25.046-26.4 c0.012-0.197,0.06-0.393,0.06-0.598c0-7.341-5.953-13.295-13.295-13.295c-1.962,0-3.805,0.451-5.479,1.213 c-5.977-11.785-18.179-19.876-32.294-19.876c-16.675,0-30.693,11.295-34.901,26.64c-0.69-0.045-1.384-0.102-2.089-0.102 c-16.265,0-29.444,13.18-29.444,29.441c0,3.648,0.69,7.117,1.902,10.344H438.389z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.0870038cc037fc8463a5b397f0575268.svg";
export { ForwardRef as ReactComponent };